/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * PanLuma API
 * Enterprise productivity application API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type { AIPlatformKeyFallbackUpdate } from '../models/aIPlatformKeyFallbackUpdate';

import type { AIProviderKeyListResponse } from '../models/aIProviderKeyListResponse';

import type { AIProviderKeyUpdate } from '../models/aIProviderKeyUpdate';

import type { AIProviderKeyVerifyResponse } from '../models/aIProviderKeyVerifyResponse';

import type { AISkillCategoriesUpdate } from '../models/aISkillCategoriesUpdate';

import type { AISkillCategoryUpdate } from '../models/aISkillCategoryUpdate';

import type { AISkillReasoningUpdate } from '../models/aISkillReasoningUpdate';

import type { AddContextFileRequest } from '../models/addContextFileRequest';

import type { AddFromBridgeRequest } from '../models/addFromBridgeRequest';

import type { AddMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesPost200 } from '../models/addMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesPost200';

import type { AdminDashboardStatus } from '../models/adminDashboardStatus';

import type { AnalyseDriftApiV1AdminDataImportDesignImportIdDriftAnalysePost200 } from '../models/analyseDriftApiV1AdminDataImportDesignImportIdDriftAnalysePost200';

import type { ApplyDriftApiV1AdminDataImportDesignImportIdDriftApplyPost200 } from '../models/applyDriftApiV1AdminDataImportDesignImportIdDriftApplyPost200';

import type { ApplyDriftRequest } from '../models/applyDriftRequest';

import type { ArchiveHistoryApiV1AdminDataImportHistoryImportIdArchivePost200 } from '../models/archiveHistoryApiV1AdminDataImportHistoryImportIdArchivePost200';

import type { BeginDraftDesignApiV1AdminDataImportImportsImportIdBeginPost200 } from '../models/beginDraftDesignApiV1AdminDataImportImportsImportIdBeginPost200';

import type { BeginDraftDesignApiV1AdminDataImportImportsImportIdBeginPostBody } from '../models/beginDraftDesignApiV1AdminDataImportImportsImportIdBeginPostBody';

import type { BodyCreateDraftImportApiV1AdminDataImportImportsDraftPost } from '../models/bodyCreateDraftImportApiV1AdminDataImportImportsDraftPost';

import type { BodyRunAdapterImportApiV1AdminDataImportRunAdapterAdapterIdPost } from '../models/bodyRunAdapterImportApiV1AdminDataImportRunAdapterAdapterIdPost';

import type { BodyRunAiImportApiV1AdminDataImportRunPost } from '../models/bodyRunAiImportApiV1AdminDataImportRunPost';

import type { ChannelMoneyResolutionCensusResponse } from '../models/channelMoneyResolutionCensusResponse';

import type { ChannelMoneyResolutionResetResponse } from '../models/channelMoneyResolutionResetResponse';

import type { ConfirmImportApiV1AdminDataImportConfirmImportIdPost200 } from '../models/confirmImportApiV1AdminDataImportConfirmImportIdPost200';

import type { ConfirmImportApiV1AdminDataImportConfirmImportIdPostBody } from '../models/confirmImportApiV1AdminDataImportConfirmImportIdPostBody';

import type { ConfirmImportApiV1AdminDataImportConfirmImportIdPostParams } from '../models/confirmImportApiV1AdminDataImportConfirmImportIdPostParams';

import type { CreateDraftImportApiV1AdminDataImportImportsDraftPost200 } from '../models/createDraftImportApiV1AdminDataImportImportsDraftPost200';

import type { CreateMigrationProjectApiV1AdminDataImportMigrationProjectsPost200 } from '../models/createMigrationProjectApiV1AdminDataImportMigrationProjectsPost200';

import type { DeleteAdapterApiV1AdminDataImportAdaptersAdapterIdDelete200 } from '../models/deleteAdapterApiV1AdminDataImportAdaptersAdapterIdDelete200';

import type { DeleteMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdDelete200 } from '../models/deleteMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdDelete200';

import type { DemoProvisionResponse } from '../models/demoProvisionResponse';

import type { DraftPatchRequest } from '../models/draftPatchRequest';

import type { EntityTablesResponse } from '../models/entityTablesResponse';

import type { GeneratePreviewApiV1AdminDataImportDesignImportIdPreviewPost200 } from '../models/generatePreviewApiV1AdminDataImportDesignImportIdPreviewPost200';

import type { GetAdapterApiV1AdminDataImportAdaptersAdapterIdGet200 } from '../models/getAdapterApiV1AdminDataImportAdaptersAdapterIdGet200';

import type { GetAdapterVersionApiV1AdminDataImportAdaptersAdapterIdVersionsVersionIdGet200 } from '../models/getAdapterVersionApiV1AdminDataImportAdaptersAdapterIdVersionsVersionIdGet200';

import type { GetDesignSessionApiV1AdminDataImportDesignImportIdGet200 } from '../models/getDesignSessionApiV1AdminDataImportDesignImportIdGet200';

import type { GetEmailTemplateApiV1AdminEmailTemplatesTemplateTypeGetParams } from '../models/getEmailTemplateApiV1AdminEmailTemplatesTemplateTypeGetParams';

import type { GetEntitySchemaApiV1AdminDataImportEntitiesModuleIdEntityIdSchemaGet200 } from '../models/getEntitySchemaApiV1AdminDataImportEntitiesModuleIdEntityIdSchemaGet200';

import type { GetHistoryDetailApiV1AdminDataImportHistoryImportIdGet200 } from '../models/getHistoryDetailApiV1AdminDataImportHistoryImportIdGet200';

import type { GetMcpServerInvocationsApiV1AdminMcpServersServerIdInvocationsGetParams } from '../models/getMcpServerInvocationsApiV1AdminMcpServersServerIdInvocationsGetParams';

import type { GetMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdGet200 } from '../models/getMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdGet200';

import type { GoldenTenantsStatusResponse } from '../models/goldenTenantsStatusResponse';

import type { HTTPValidationError } from '../models/hTTPValidationError';

import type { IntegrationToggleRequest } from '../models/integrationToggleRequest';

import type { ListAdapterVersionsApiV1AdminDataImportAdaptersAdapterIdVersionsGet200 } from '../models/listAdapterVersionsApiV1AdminDataImportAdaptersAdapterIdVersionsGet200';

import type { ListAdaptersApiV1AdminDataImportAdaptersGet200 } from '../models/listAdaptersApiV1AdminDataImportAdaptersGet200';

import type { ListAdaptersApiV1AdminDataImportAdaptersGetParams } from '../models/listAdaptersApiV1AdminDataImportAdaptersGetParams';

import type { ListAdminAuditLogsApiV1AdminAuditLogsGetParams } from '../models/listAdminAuditLogsApiV1AdminAuditLogsGetParams';

import type { ListEmulationSessionsApiV1AdminEmulationSessionsGetParams } from '../models/listEmulationSessionsApiV1AdminEmulationSessionsGetParams';

import type { ListHistoryApiV1AdminDataImportHistoryGet200 } from '../models/listHistoryApiV1AdminDataImportHistoryGet200';

import type { ListHistoryApiV1AdminDataImportHistoryGetParams } from '../models/listHistoryApiV1AdminDataImportHistoryGetParams';

import type { ListImportableEntitiesApiV1AdminDataImportEntitiesGet200 } from '../models/listImportableEntitiesApiV1AdminDataImportEntitiesGet200';

import type { ListImportedRecordEntityTablesApiV1AdminDataImportRecordsEntityTablesGetParams } from '../models/listImportedRecordEntityTablesApiV1AdminDataImportRecordsEntityTablesGetParams';

import type { ListImportedRecordsApiV1AdminDataImportRecordsGet200 } from '../models/listImportedRecordsApiV1AdminDataImportRecordsGet200';

import type { ListImportedRecordsApiV1AdminDataImportRecordsGetParams } from '../models/listImportedRecordsApiV1AdminDataImportRecordsGetParams';

import type { ListMcpServersApiV1AdminMcpServersGetParams } from '../models/listMcpServersApiV1AdminMcpServersGetParams';

import type { ListMigrationProjectsApiV1AdminDataImportMigrationProjectsGet200 } from '../models/listMigrationProjectsApiV1AdminDataImportMigrationProjectsGet200';

import type { ListOfficesApiV1AdminOfficesGetParams } from '../models/listOfficesApiV1AdminOfficesGetParams';

import type { ListTenantDataResetHistoryParams } from '../models/listTenantDataResetHistoryParams';

import type { ListTenantsForEmulationApiV1AdminEmulationTenantsGetParams } from '../models/listTenantsForEmulationApiV1AdminEmulationTenantsGetParams';

import type { McpServerCreate } from '../models/mcpServerCreate';

import type { McpServerUpdate } from '../models/mcpServerUpdate';

import type { MigrationProjectCreateRequest } from '../models/migrationProjectCreateRequest';

import type { MigrationProjectFileAddRequest } from '../models/migrationProjectFileAddRequest';

import type { MigrationProjectFileUpdateRequest } from '../models/migrationProjectFileUpdateRequest';

import type { MigrationProjectRunDesignRequest } from '../models/migrationProjectRunDesignRequest';

import type { MigrationProjectRunExecuteRequest } from '../models/migrationProjectRunExecuteRequest';

import type { MigrationProjectUpdateRequest } from '../models/migrationProjectUpdateRequest';

import type { ModulesAdminApiDemoProvisioningRoutesDemoVariationsResponse } from '../models/modulesAdminApiDemoProvisioningRoutesDemoVariationsResponse';

import type { ModulesAdminApiRoutesEmailTemplateUpdate } from '../models/modulesAdminApiRoutesEmailTemplateUpdate';

import type { ModulesAdminApiRoutesTenantSettingsUpdate } from '../models/modulesAdminApiRoutesTenantSettingsUpdate';

import type { OfficeCreate } from '../models/officeCreate';

import type { OfficeUpdate } from '../models/officeUpdate';

import type { PlatformIntegrationsResponse } from '../models/platformIntegrationsResponse';

import type { PreviewEmailTemplateApiV1AdminEmailTemplatesTemplateTypePreviewGetParams } from '../models/previewEmailTemplateApiV1AdminEmailTemplatesTemplateTypePreviewGetParams';

import type { ProvisionDemoRequest } from '../models/provisionDemoRequest';

import type { RemoveMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesFileIdDelete200 } from '../models/removeMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesFileIdDelete200';

import type { ReseedGoldenTenantRequest } from '../models/reseedGoldenTenantRequest';

import type { ReseedGoldenTenantResponse } from '../models/reseedGoldenTenantResponse';

import type { RetryMappingApiV1AdminDataImportDesignImportIdRetryMappingPost200 } from '../models/retryMappingApiV1AdminDataImportDesignImportIdRetryMappingPost200';

import type { RollbackMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdRollbackPost200 } from '../models/rollbackMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdRollbackPost200';

import type { RunAdapterImportApiV1AdminDataImportRunAdapterAdapterIdPost200 } from '../models/runAdapterImportApiV1AdminDataImportRunAdapterAdapterIdPost200';

import type { RunAiImportApiV1AdminDataImportRunPost200 } from '../models/runAiImportApiV1AdminDataImportRunPost200';

import type { RunMigrationProjectDesignApiV1AdminDataImportMigrationProjectsProjectIdRunDesignPost200 } from '../models/runMigrationProjectDesignApiV1AdminDataImportMigrationProjectsProjectIdRunDesignPost200';

import type { RunMigrationProjectExecuteApiV1AdminDataImportMigrationProjectsProjectIdRunExecutePost200 } from '../models/runMigrationProjectExecuteApiV1AdminDataImportMigrationProjectsProjectIdRunExecutePost200';

import type { SaveAdapterApiV1AdminDataImportAdaptersPost200 } from '../models/saveAdapterApiV1AdminDataImportAdaptersPost200';

import type { SaveAdapterRequest } from '../models/saveAdapterRequest';

import type { SearchUsersForEmulationApiV1AdminEmulationUsersSearchGetParams } from '../models/searchUsersForEmulationApiV1AdminEmulationUsersSearchGetParams';

import type { StartEmulationRequest } from '../models/startEmulationRequest';

import type { TenantContextUpdate } from '../models/tenantContextUpdate';

import type { TenantDataResetHistory } from '../models/tenantDataResetHistory';

import type { TenantDataResetPreview } from '../models/tenantDataResetPreview';

import type { TenantDataResetPreviewRequest } from '../models/tenantDataResetPreviewRequest';

import type { TenantDataResetScheduleRequest } from '../models/tenantDataResetScheduleRequest';

import type { TenantDataResetState } from '../models/tenantDataResetState';

import type { TenantDataRestoreRequest } from '../models/tenantDataRestoreRequest';

import type { TranslateRequest } from '../models/translateRequest';

import type { UnarchiveHistoryApiV1AdminDataImportHistoryImportIdUnarchivePost200 } from '../models/unarchiveHistoryApiV1AdminDataImportHistoryImportIdUnarchivePost200';

import type { UpdateAdapterApiV1AdminDataImportAdaptersAdapterIdPut200 } from '../models/updateAdapterApiV1AdminDataImportAdaptersAdapterIdPut200';

import type { UpdateAdapterRequest } from '../models/updateAdapterRequest';

import type { UpdateContextFileRequest } from '../models/updateContextFileRequest';

import type { UpdateDesignMappingApiV1AdminDataImportDesignImportIdMappingPut200 } from '../models/updateDesignMappingApiV1AdminDataImportDesignImportIdMappingPut200';

import type { UpdateDraftImportApiV1AdminDataImportImportsImportIdDraftPatch200 } from '../models/updateDraftImportApiV1AdminDataImportImportsImportIdDraftPatch200';

import type { UpdateMappingRequest } from '../models/updateMappingRequest';

import type { UpdateMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdPut200 } from '../models/updateMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdPut200';

import type { UpdateMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesFileIdPut200 } from '../models/updateMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesFileIdPut200';

import { customInstance } from '../../../shared/api/axiosInstance';

/**
 * Get current tenant settings. Admin only.
 * @summary Get Tenant Settings
 */
export const getTenantSettingsApiV1AdminSettingsGet = (
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/admin/settings`,
    method: 'GET',
    signal
  });
};

export const getGetTenantSettingsApiV1AdminSettingsGetQueryKey = () => {
  return [`/api/v1/admin/settings`] as const;
};

export const getGetTenantSettingsApiV1AdminSettingsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getTenantSettingsApiV1AdminSettingsGet>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTenantSettingsApiV1AdminSettingsGet>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetTenantSettingsApiV1AdminSettingsGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTenantSettingsApiV1AdminSettingsGet>>
  > = ({ signal }) => getTenantSettingsApiV1AdminSettingsGet(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTenantSettingsApiV1AdminSettingsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTenantSettingsApiV1AdminSettingsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTenantSettingsApiV1AdminSettingsGet>>
>;
export type GetTenantSettingsApiV1AdminSettingsGetQueryError = unknown;

export function useGetTenantSettingsApiV1AdminSettingsGet<
  TData = Awaited<ReturnType<typeof getTenantSettingsApiV1AdminSettingsGet>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTenantSettingsApiV1AdminSettingsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenantSettingsApiV1AdminSettingsGet>>,
          TError,
          Awaited<ReturnType<typeof getTenantSettingsApiV1AdminSettingsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTenantSettingsApiV1AdminSettingsGet<
  TData = Awaited<ReturnType<typeof getTenantSettingsApiV1AdminSettingsGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTenantSettingsApiV1AdminSettingsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenantSettingsApiV1AdminSettingsGet>>,
          TError,
          Awaited<ReturnType<typeof getTenantSettingsApiV1AdminSettingsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTenantSettingsApiV1AdminSettingsGet<
  TData = Awaited<ReturnType<typeof getTenantSettingsApiV1AdminSettingsGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTenantSettingsApiV1AdminSettingsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Tenant Settings
 */

export function useGetTenantSettingsApiV1AdminSettingsGet<
  TData = Awaited<ReturnType<typeof getTenantSettingsApiV1AdminSettingsGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTenantSettingsApiV1AdminSettingsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetTenantSettingsApiV1AdminSettingsGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update current tenant settings. Admin only.
 * @summary Update Tenant Settings
 */
export const updateTenantSettingsApiV1AdminSettingsPut = (
  modulesAdminApiRoutesTenantSettingsUpdate: ModulesAdminApiRoutesTenantSettingsUpdate
) => {
  return customInstance<unknown>({
    url: `/api/v1/admin/settings`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: modulesAdminApiRoutesTenantSettingsUpdate
  });
};

export const getUpdateTenantSettingsApiV1AdminSettingsPutMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTenantSettingsApiV1AdminSettingsPut>>,
    TError,
    { data: ModulesAdminApiRoutesTenantSettingsUpdate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTenantSettingsApiV1AdminSettingsPut>>,
  TError,
  { data: ModulesAdminApiRoutesTenantSettingsUpdate },
  TContext
> => {
  const mutationKey = ['updateTenantSettingsApiV1AdminSettingsPut'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTenantSettingsApiV1AdminSettingsPut>>,
    { data: ModulesAdminApiRoutesTenantSettingsUpdate }
  > = (props) => {
    const { data } = props ?? {};

    return updateTenantSettingsApiV1AdminSettingsPut(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTenantSettingsApiV1AdminSettingsPutMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateTenantSettingsApiV1AdminSettingsPut>>
  >;
export type UpdateTenantSettingsApiV1AdminSettingsPutMutationBody =
  ModulesAdminApiRoutesTenantSettingsUpdate;
export type UpdateTenantSettingsApiV1AdminSettingsPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Tenant Settings
 */
export const useUpdateTenantSettingsApiV1AdminSettingsPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateTenantSettingsApiV1AdminSettingsPut>>,
      TError,
      { data: ModulesAdminApiRoutesTenantSettingsUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateTenantSettingsApiV1AdminSettingsPut>>,
  TError,
  { data: ModulesAdminApiRoutesTenantSettingsUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateTenantSettingsApiV1AdminSettingsPutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get unique email domains from verified users in the current tenant.

Returns domains that can be assigned to this tenant for SSO auto-assignment.
Excludes generic email domains (gmail.com, etc.) and already assigned domains.
Admin only.
 * @summary Get Tenant User Domains
 */
export const getTenantUserDomainsApiV1AdminSettingsUserDomainsGet = (
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/admin/settings/user-domains`,
    method: 'GET',
    signal
  });
};

export const getGetTenantUserDomainsApiV1AdminSettingsUserDomainsGetQueryKey =
  () => {
    return [`/api/v1/admin/settings/user-domains`] as const;
  };

export const getGetTenantUserDomainsApiV1AdminSettingsUserDomainsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getTenantUserDomainsApiV1AdminSettingsUserDomainsGet>
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTenantUserDomainsApiV1AdminSettingsUserDomainsGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetTenantUserDomainsApiV1AdminSettingsUserDomainsGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getTenantUserDomainsApiV1AdminSettingsUserDomainsGet>
      >
    > = ({ signal }) =>
      getTenantUserDomainsApiV1AdminSettingsUserDomainsGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getTenantUserDomainsApiV1AdminSettingsUserDomainsGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetTenantUserDomainsApiV1AdminSettingsUserDomainsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getTenantUserDomainsApiV1AdminSettingsUserDomainsGet>
    >
  >;
export type GetTenantUserDomainsApiV1AdminSettingsUserDomainsGetQueryError =
  unknown;

export function useGetTenantUserDomainsApiV1AdminSettingsUserDomainsGet<
  TData = Awaited<
    ReturnType<typeof getTenantUserDomainsApiV1AdminSettingsUserDomainsGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTenantUserDomainsApiV1AdminSettingsUserDomainsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTenantUserDomainsApiV1AdminSettingsUserDomainsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTenantUserDomainsApiV1AdminSettingsUserDomainsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTenantUserDomainsApiV1AdminSettingsUserDomainsGet<
  TData = Awaited<
    ReturnType<typeof getTenantUserDomainsApiV1AdminSettingsUserDomainsGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTenantUserDomainsApiV1AdminSettingsUserDomainsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTenantUserDomainsApiV1AdminSettingsUserDomainsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTenantUserDomainsApiV1AdminSettingsUserDomainsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTenantUserDomainsApiV1AdminSettingsUserDomainsGet<
  TData = Awaited<
    ReturnType<typeof getTenantUserDomainsApiV1AdminSettingsUserDomainsGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTenantUserDomainsApiV1AdminSettingsUserDomainsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Tenant User Domains
 */

export function useGetTenantUserDomainsApiV1AdminSettingsUserDomainsGet<
  TData = Awaited<
    ReturnType<typeof getTenantUserDomainsApiV1AdminSettingsUserDomainsGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTenantUserDomainsApiV1AdminSettingsUserDomainsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetTenantUserDomainsApiV1AdminSettingsUserDomainsGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get tenant context (description and files). Admin only.
 * @summary Get Tenant Context
 */
export const getTenantContextApiV1AdminContextGet = (signal?: AbortSignal) => {
  return customInstance<unknown>({
    url: `/api/v1/admin/context`,
    method: 'GET',
    signal
  });
};

export const getGetTenantContextApiV1AdminContextGetQueryKey = () => {
  return [`/api/v1/admin/context`] as const;
};

export const getGetTenantContextApiV1AdminContextGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getTenantContextApiV1AdminContextGet>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTenantContextApiV1AdminContextGet>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTenantContextApiV1AdminContextGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTenantContextApiV1AdminContextGet>>
  > = ({ signal }) => getTenantContextApiV1AdminContextGet(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTenantContextApiV1AdminContextGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTenantContextApiV1AdminContextGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTenantContextApiV1AdminContextGet>>
>;
export type GetTenantContextApiV1AdminContextGetQueryError = unknown;

export function useGetTenantContextApiV1AdminContextGet<
  TData = Awaited<ReturnType<typeof getTenantContextApiV1AdminContextGet>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTenantContextApiV1AdminContextGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenantContextApiV1AdminContextGet>>,
          TError,
          Awaited<ReturnType<typeof getTenantContextApiV1AdminContextGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTenantContextApiV1AdminContextGet<
  TData = Awaited<ReturnType<typeof getTenantContextApiV1AdminContextGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTenantContextApiV1AdminContextGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenantContextApiV1AdminContextGet>>,
          TError,
          Awaited<ReturnType<typeof getTenantContextApiV1AdminContextGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTenantContextApiV1AdminContextGet<
  TData = Awaited<ReturnType<typeof getTenantContextApiV1AdminContextGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTenantContextApiV1AdminContextGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Tenant Context
 */

export function useGetTenantContextApiV1AdminContextGet<
  TData = Awaited<ReturnType<typeof getTenantContextApiV1AdminContextGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTenantContextApiV1AdminContextGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetTenantContextApiV1AdminContextGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update tenant context description. Admin only.
 * @summary Update Tenant Context
 */
export const updateTenantContextApiV1AdminContextPut = (
  tenantContextUpdate: TenantContextUpdate
) => {
  return customInstance<unknown>({
    url: `/api/v1/admin/context`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: tenantContextUpdate
  });
};

export const getUpdateTenantContextApiV1AdminContextPutMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTenantContextApiV1AdminContextPut>>,
    TError,
    { data: TenantContextUpdate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTenantContextApiV1AdminContextPut>>,
  TError,
  { data: TenantContextUpdate },
  TContext
> => {
  const mutationKey = ['updateTenantContextApiV1AdminContextPut'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTenantContextApiV1AdminContextPut>>,
    { data: TenantContextUpdate }
  > = (props) => {
    const { data } = props ?? {};

    return updateTenantContextApiV1AdminContextPut(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTenantContextApiV1AdminContextPutMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTenantContextApiV1AdminContextPut>>
>;
export type UpdateTenantContextApiV1AdminContextPutMutationBody =
  TenantContextUpdate;
export type UpdateTenantContextApiV1AdminContextPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Tenant Context
 */
export const useUpdateTenantContextApiV1AdminContextPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateTenantContextApiV1AdminContextPut>>,
      TError,
      { data: TenantContextUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateTenantContextApiV1AdminContextPut>>,
  TError,
  { data: TenantContextUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateTenantContextApiV1AdminContextPutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * List all context files/folders for the tenant. Admin only.
 * @summary List Tenant Context Files
 */
export const listTenantContextFilesApiV1AdminContextFilesGet = (
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/admin/context/files`,
    method: 'GET',
    signal
  });
};

export const getListTenantContextFilesApiV1AdminContextFilesGetQueryKey =
  () => {
    return [`/api/v1/admin/context/files`] as const;
  };

export const getListTenantContextFilesApiV1AdminContextFilesGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listTenantContextFilesApiV1AdminContextFilesGet>
  >,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<typeof listTenantContextFilesApiV1AdminContextFilesGet>
      >,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListTenantContextFilesApiV1AdminContextFilesGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listTenantContextFilesApiV1AdminContextFilesGet>>
  > = ({ signal }) => listTenantContextFilesApiV1AdminContextFilesGet(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTenantContextFilesApiV1AdminContextFilesGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListTenantContextFilesApiV1AdminContextFilesGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listTenantContextFilesApiV1AdminContextFilesGet>>
  >;
export type ListTenantContextFilesApiV1AdminContextFilesGetQueryError = unknown;

export function useListTenantContextFilesApiV1AdminContextFilesGet<
  TData = Awaited<
    ReturnType<typeof listTenantContextFilesApiV1AdminContextFilesGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listTenantContextFilesApiV1AdminContextFilesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listTenantContextFilesApiV1AdminContextFilesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listTenantContextFilesApiV1AdminContextFilesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListTenantContextFilesApiV1AdminContextFilesGet<
  TData = Awaited<
    ReturnType<typeof listTenantContextFilesApiV1AdminContextFilesGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listTenantContextFilesApiV1AdminContextFilesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listTenantContextFilesApiV1AdminContextFilesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listTenantContextFilesApiV1AdminContextFilesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListTenantContextFilesApiV1AdminContextFilesGet<
  TData = Awaited<
    ReturnType<typeof listTenantContextFilesApiV1AdminContextFilesGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listTenantContextFilesApiV1AdminContextFilesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Tenant Context Files
 */

export function useListTenantContextFilesApiV1AdminContextFilesGet<
  TData = Awaited<
    ReturnType<typeof listTenantContextFilesApiV1AdminContextFilesGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listTenantContextFilesApiV1AdminContextFilesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListTenantContextFilesApiV1AdminContextFilesGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Add a file or folder to tenant context. Admin only.
 * @summary Add Tenant Context File
 */
export const addTenantContextFileApiV1AdminContextFilesPost = (
  addContextFileRequest: AddContextFileRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/admin/context/files`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: addContextFileRequest,
    signal
  });
};

export const getAddTenantContextFileApiV1AdminContextFilesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof addTenantContextFileApiV1AdminContextFilesPost>
      >,
      TError,
      { data: AddContextFileRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof addTenantContextFileApiV1AdminContextFilesPost>>,
    TError,
    { data: AddContextFileRequest },
    TContext
  > => {
    const mutationKey = ['addTenantContextFileApiV1AdminContextFilesPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof addTenantContextFileApiV1AdminContextFilesPost>
      >,
      { data: AddContextFileRequest }
    > = (props) => {
      const { data } = props ?? {};

      return addTenantContextFileApiV1AdminContextFilesPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type AddTenantContextFileApiV1AdminContextFilesPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof addTenantContextFileApiV1AdminContextFilesPost>>
  >;
export type AddTenantContextFileApiV1AdminContextFilesPostMutationBody =
  AddContextFileRequest;
export type AddTenantContextFileApiV1AdminContextFilesPostMutationError =
  HTTPValidationError;

/**
 * @summary Add Tenant Context File
 */
export const useAddTenantContextFileApiV1AdminContextFilesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof addTenantContextFileApiV1AdminContextFilesPost>
      >,
      TError,
      { data: AddContextFileRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof addTenantContextFileApiV1AdminContextFilesPost>>,
  TError,
  { data: AddContextFileRequest },
  TContext
> => {
  const mutationOptions =
    getAddTenantContextFileApiV1AdminContextFilesPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Update a context file association (e.g., description). Admin only.
 * @summary Update Tenant Context File
 */
export const updateTenantContextFileApiV1AdminContextFilesAssociationIdPatch = (
  associationId: string,
  updateContextFileRequest: UpdateContextFileRequest
) => {
  return customInstance<unknown>({
    url: `/api/v1/admin/context/files/${associationId}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: updateContextFileRequest
  });
};

export const getUpdateTenantContextFileApiV1AdminContextFilesAssociationIdPatchMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateTenantContextFileApiV1AdminContextFilesAssociationIdPatch
        >
      >,
      TError,
      { associationId: string; data: UpdateContextFileRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateTenantContextFileApiV1AdminContextFilesAssociationIdPatch
      >
    >,
    TError,
    { associationId: string; data: UpdateContextFileRequest },
    TContext
  > => {
    const mutationKey = [
      'updateTenantContextFileApiV1AdminContextFilesAssociationIdPatch'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateTenantContextFileApiV1AdminContextFilesAssociationIdPatch
        >
      >,
      { associationId: string; data: UpdateContextFileRequest }
    > = (props) => {
      const { associationId, data } = props ?? {};

      return updateTenantContextFileApiV1AdminContextFilesAssociationIdPatch(
        associationId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateTenantContextFileApiV1AdminContextFilesAssociationIdPatchMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateTenantContextFileApiV1AdminContextFilesAssociationIdPatch
      >
    >
  >;
export type UpdateTenantContextFileApiV1AdminContextFilesAssociationIdPatchMutationBody =
  UpdateContextFileRequest;
export type UpdateTenantContextFileApiV1AdminContextFilesAssociationIdPatchMutationError =
  HTTPValidationError;

/**
 * @summary Update Tenant Context File
 */
export const useUpdateTenantContextFileApiV1AdminContextFilesAssociationIdPatch =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateTenantContextFileApiV1AdminContextFilesAssociationIdPatch
          >
        >,
        TError,
        { associationId: string; data: UpdateContextFileRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateTenantContextFileApiV1AdminContextFilesAssociationIdPatch
      >
    >,
    TError,
    { associationId: string; data: UpdateContextFileRequest },
    TContext
  > => {
    const mutationOptions =
      getUpdateTenantContextFileApiV1AdminContextFilesAssociationIdPatchMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Remove a file or folder from tenant context. Admin only.
 * @summary Remove Tenant Context File
 */
export const removeTenantContextFileApiV1AdminContextFilesAssociationIdDelete =
  (associationId: string) => {
    return customInstance<void>({
      url: `/api/v1/admin/context/files/${associationId}`,
      method: 'DELETE'
    });
  };

export const getRemoveTenantContextFileApiV1AdminContextFilesAssociationIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof removeTenantContextFileApiV1AdminContextFilesAssociationIdDelete
        >
      >,
      TError,
      { associationId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof removeTenantContextFileApiV1AdminContextFilesAssociationIdDelete
      >
    >,
    TError,
    { associationId: string },
    TContext
  > => {
    const mutationKey = [
      'removeTenantContextFileApiV1AdminContextFilesAssociationIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof removeTenantContextFileApiV1AdminContextFilesAssociationIdDelete
        >
      >,
      { associationId: string }
    > = (props) => {
      const { associationId } = props ?? {};

      return removeTenantContextFileApiV1AdminContextFilesAssociationIdDelete(
        associationId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RemoveTenantContextFileApiV1AdminContextFilesAssociationIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof removeTenantContextFileApiV1AdminContextFilesAssociationIdDelete
      >
    >
  >;

export type RemoveTenantContextFileApiV1AdminContextFilesAssociationIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Remove Tenant Context File
 */
export const useRemoveTenantContextFileApiV1AdminContextFilesAssociationIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof removeTenantContextFileApiV1AdminContextFilesAssociationIdDelete
          >
        >,
        TError,
        { associationId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof removeTenantContextFileApiV1AdminContextFilesAssociationIdDelete
      >
    >,
    TError,
    { associationId: string },
    TContext
  > => {
    const mutationOptions =
      getRemoveTenantContextFileApiV1AdminContextFilesAssociationIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List all email template types with their configuration status.
 * @summary List Email Template Types
 */
export const listEmailTemplateTypesApiV1AdminEmailTemplatesGet = (
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/admin/email-templates`,
    method: 'GET',
    signal
  });
};

export const getListEmailTemplateTypesApiV1AdminEmailTemplatesGetQueryKey =
  () => {
    return [`/api/v1/admin/email-templates`] as const;
  };

export const getListEmailTemplateTypesApiV1AdminEmailTemplatesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listEmailTemplateTypesApiV1AdminEmailTemplatesGet>
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listEmailTemplateTypesApiV1AdminEmailTemplatesGet>
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListEmailTemplateTypesApiV1AdminEmailTemplatesGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listEmailTemplateTypesApiV1AdminEmailTemplatesGet>
      >
    > = ({ signal }) =>
      listEmailTemplateTypesApiV1AdminEmailTemplatesGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listEmailTemplateTypesApiV1AdminEmailTemplatesGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListEmailTemplateTypesApiV1AdminEmailTemplatesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listEmailTemplateTypesApiV1AdminEmailTemplatesGet>
    >
  >;
export type ListEmailTemplateTypesApiV1AdminEmailTemplatesGetQueryError =
  unknown;

export function useListEmailTemplateTypesApiV1AdminEmailTemplatesGet<
  TData = Awaited<
    ReturnType<typeof listEmailTemplateTypesApiV1AdminEmailTemplatesGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listEmailTemplateTypesApiV1AdminEmailTemplatesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listEmailTemplateTypesApiV1AdminEmailTemplatesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listEmailTemplateTypesApiV1AdminEmailTemplatesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListEmailTemplateTypesApiV1AdminEmailTemplatesGet<
  TData = Awaited<
    ReturnType<typeof listEmailTemplateTypesApiV1AdminEmailTemplatesGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listEmailTemplateTypesApiV1AdminEmailTemplatesGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listEmailTemplateTypesApiV1AdminEmailTemplatesGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listEmailTemplateTypesApiV1AdminEmailTemplatesGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListEmailTemplateTypesApiV1AdminEmailTemplatesGet<
  TData = Awaited<
    ReturnType<typeof listEmailTemplateTypesApiV1AdminEmailTemplatesGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listEmailTemplateTypesApiV1AdminEmailTemplatesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Email Template Types
 */

export function useListEmailTemplateTypesApiV1AdminEmailTemplatesGet<
  TData = Awaited<
    ReturnType<typeof listEmailTemplateTypesApiV1AdminEmailTemplatesGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listEmailTemplateTypesApiV1AdminEmailTemplatesGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListEmailTemplateTypesApiV1AdminEmailTemplatesGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get email template for a specific type and language.

Returns the resolved template (tenant -> sysadmin -> default) along with
information about which source is being used.
 * @summary Get Email Template
 */
export const getEmailTemplateApiV1AdminEmailTemplatesTemplateTypeGet = (
  templateType: string,
  params?: GetEmailTemplateApiV1AdminEmailTemplatesTemplateTypeGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/admin/email-templates/${templateType}`,
    method: 'GET',
    params,
    signal
  });
};

export const getGetEmailTemplateApiV1AdminEmailTemplatesTemplateTypeGetQueryKey =
  (
    templateType?: string,
    params?: GetEmailTemplateApiV1AdminEmailTemplatesTemplateTypeGetParams
  ) => {
    return [
      `/api/v1/admin/email-templates/${templateType}`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetEmailTemplateApiV1AdminEmailTemplatesTemplateTypeGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getEmailTemplateApiV1AdminEmailTemplatesTemplateTypeGet>
    >,
    TError = HTTPValidationError
  >(
    templateType: string,
    params?: GetEmailTemplateApiV1AdminEmailTemplatesTemplateTypeGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getEmailTemplateApiV1AdminEmailTemplatesTemplateTypeGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetEmailTemplateApiV1AdminEmailTemplatesTemplateTypeGetQueryKey(
        templateType,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getEmailTemplateApiV1AdminEmailTemplatesTemplateTypeGet
        >
      >
    > = ({ signal }) =>
      getEmailTemplateApiV1AdminEmailTemplatesTemplateTypeGet(
        templateType,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!templateType,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getEmailTemplateApiV1AdminEmailTemplatesTemplateTypeGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetEmailTemplateApiV1AdminEmailTemplatesTemplateTypeGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getEmailTemplateApiV1AdminEmailTemplatesTemplateTypeGet>
    >
  >;
export type GetEmailTemplateApiV1AdminEmailTemplatesTemplateTypeGetQueryError =
  HTTPValidationError;

export function useGetEmailTemplateApiV1AdminEmailTemplatesTemplateTypeGet<
  TData = Awaited<
    ReturnType<typeof getEmailTemplateApiV1AdminEmailTemplatesTemplateTypeGet>
  >,
  TError = HTTPValidationError
>(
  templateType: string,
  params:
    | undefined
    | GetEmailTemplateApiV1AdminEmailTemplatesTemplateTypeGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEmailTemplateApiV1AdminEmailTemplatesTemplateTypeGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getEmailTemplateApiV1AdminEmailTemplatesTemplateTypeGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getEmailTemplateApiV1AdminEmailTemplatesTemplateTypeGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetEmailTemplateApiV1AdminEmailTemplatesTemplateTypeGet<
  TData = Awaited<
    ReturnType<typeof getEmailTemplateApiV1AdminEmailTemplatesTemplateTypeGet>
  >,
  TError = HTTPValidationError
>(
  templateType: string,
  params?: GetEmailTemplateApiV1AdminEmailTemplatesTemplateTypeGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEmailTemplateApiV1AdminEmailTemplatesTemplateTypeGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getEmailTemplateApiV1AdminEmailTemplatesTemplateTypeGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getEmailTemplateApiV1AdminEmailTemplatesTemplateTypeGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetEmailTemplateApiV1AdminEmailTemplatesTemplateTypeGet<
  TData = Awaited<
    ReturnType<typeof getEmailTemplateApiV1AdminEmailTemplatesTemplateTypeGet>
  >,
  TError = HTTPValidationError
>(
  templateType: string,
  params?: GetEmailTemplateApiV1AdminEmailTemplatesTemplateTypeGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEmailTemplateApiV1AdminEmailTemplatesTemplateTypeGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Email Template
 */

export function useGetEmailTemplateApiV1AdminEmailTemplatesTemplateTypeGet<
  TData = Awaited<
    ReturnType<typeof getEmailTemplateApiV1AdminEmailTemplatesTemplateTypeGet>
  >,
  TError = HTTPValidationError
>(
  templateType: string,
  params?: GetEmailTemplateApiV1AdminEmailTemplatesTemplateTypeGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEmailTemplateApiV1AdminEmailTemplatesTemplateTypeGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetEmailTemplateApiV1AdminEmailTemplatesTemplateTypeGetQueryOptions(
      templateType,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create or update an email template for a specific type and language.
 * @summary Save Email Template
 */
export const saveEmailTemplateApiV1AdminEmailTemplatesTemplateTypeLanguagePut =
  (
    templateType: string,
    language: string,
    modulesAdminApiRoutesEmailTemplateUpdate: ModulesAdminApiRoutesEmailTemplateUpdate
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/admin/email-templates/${templateType}/${language}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: modulesAdminApiRoutesEmailTemplateUpdate
    });
  };

export const getSaveEmailTemplateApiV1AdminEmailTemplatesTemplateTypeLanguagePutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof saveEmailTemplateApiV1AdminEmailTemplatesTemplateTypeLanguagePut
        >
      >,
      TError,
      {
        templateType: string;
        language: string;
        data: ModulesAdminApiRoutesEmailTemplateUpdate;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof saveEmailTemplateApiV1AdminEmailTemplatesTemplateTypeLanguagePut
      >
    >,
    TError,
    {
      templateType: string;
      language: string;
      data: ModulesAdminApiRoutesEmailTemplateUpdate;
    },
    TContext
  > => {
    const mutationKey = [
      'saveEmailTemplateApiV1AdminEmailTemplatesTemplateTypeLanguagePut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof saveEmailTemplateApiV1AdminEmailTemplatesTemplateTypeLanguagePut
        >
      >,
      {
        templateType: string;
        language: string;
        data: ModulesAdminApiRoutesEmailTemplateUpdate;
      }
    > = (props) => {
      const { templateType, language, data } = props ?? {};

      return saveEmailTemplateApiV1AdminEmailTemplatesTemplateTypeLanguagePut(
        templateType,
        language,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type SaveEmailTemplateApiV1AdminEmailTemplatesTemplateTypeLanguagePutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof saveEmailTemplateApiV1AdminEmailTemplatesTemplateTypeLanguagePut
      >
    >
  >;
export type SaveEmailTemplateApiV1AdminEmailTemplatesTemplateTypeLanguagePutMutationBody =
  ModulesAdminApiRoutesEmailTemplateUpdate;
export type SaveEmailTemplateApiV1AdminEmailTemplatesTemplateTypeLanguagePutMutationError =
  HTTPValidationError;

/**
 * @summary Save Email Template
 */
export const useSaveEmailTemplateApiV1AdminEmailTemplatesTemplateTypeLanguagePut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof saveEmailTemplateApiV1AdminEmailTemplatesTemplateTypeLanguagePut
          >
        >,
        TError,
        {
          templateType: string;
          language: string;
          data: ModulesAdminApiRoutesEmailTemplateUpdate;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof saveEmailTemplateApiV1AdminEmailTemplatesTemplateTypeLanguagePut
      >
    >,
    TError,
    {
      templateType: string;
      language: string;
      data: ModulesAdminApiRoutesEmailTemplateUpdate;
    },
    TContext
  > => {
    const mutationOptions =
      getSaveEmailTemplateApiV1AdminEmailTemplatesTemplateTypeLanguagePutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Delete a custom email template (reset to default/sysadmin fallback).
 * @summary Delete Email Template
 */
export const deleteEmailTemplateApiV1AdminEmailTemplatesTemplateTypeLanguageDelete =
  (templateType: string, language: string) => {
    return customInstance<void>({
      url: `/api/v1/admin/email-templates/${templateType}/${language}`,
      method: 'DELETE'
    });
  };

export const getDeleteEmailTemplateApiV1AdminEmailTemplatesTemplateTypeLanguageDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteEmailTemplateApiV1AdminEmailTemplatesTemplateTypeLanguageDelete
        >
      >,
      TError,
      { templateType: string; language: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteEmailTemplateApiV1AdminEmailTemplatesTemplateTypeLanguageDelete
      >
    >,
    TError,
    { templateType: string; language: string },
    TContext
  > => {
    const mutationKey = [
      'deleteEmailTemplateApiV1AdminEmailTemplatesTemplateTypeLanguageDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteEmailTemplateApiV1AdminEmailTemplatesTemplateTypeLanguageDelete
        >
      >,
      { templateType: string; language: string }
    > = (props) => {
      const { templateType, language } = props ?? {};

      return deleteEmailTemplateApiV1AdminEmailTemplatesTemplateTypeLanguageDelete(
        templateType,
        language
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteEmailTemplateApiV1AdminEmailTemplatesTemplateTypeLanguageDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteEmailTemplateApiV1AdminEmailTemplatesTemplateTypeLanguageDelete
      >
    >
  >;

export type DeleteEmailTemplateApiV1AdminEmailTemplatesTemplateTypeLanguageDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Email Template
 */
export const useDeleteEmailTemplateApiV1AdminEmailTemplatesTemplateTypeLanguageDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteEmailTemplateApiV1AdminEmailTemplatesTemplateTypeLanguageDelete
          >
        >,
        TError,
        { templateType: string; language: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteEmailTemplateApiV1AdminEmailTemplatesTemplateTypeLanguageDelete
      >
    >,
    TError,
    { templateType: string; language: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteEmailTemplateApiV1AdminEmailTemplatesTemplateTypeLanguageDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Translate email template from English to another language using AI.

Requires the English template to exist (either custom or default).
Returns the translated content for review before saving.
 * @summary Translate Email Template
 */
export const translateEmailTemplateApiV1AdminEmailTemplatesTemplateTypeTranslatePost =
  (
    templateType: string,
    translateRequest: TranslateRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/admin/email-templates/${templateType}/translate`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: translateRequest,
      signal
    });
  };

export const getTranslateEmailTemplateApiV1AdminEmailTemplatesTemplateTypeTranslatePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof translateEmailTemplateApiV1AdminEmailTemplatesTemplateTypeTranslatePost
        >
      >,
      TError,
      { templateType: string; data: TranslateRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof translateEmailTemplateApiV1AdminEmailTemplatesTemplateTypeTranslatePost
      >
    >,
    TError,
    { templateType: string; data: TranslateRequest },
    TContext
  > => {
    const mutationKey = [
      'translateEmailTemplateApiV1AdminEmailTemplatesTemplateTypeTranslatePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof translateEmailTemplateApiV1AdminEmailTemplatesTemplateTypeTranslatePost
        >
      >,
      { templateType: string; data: TranslateRequest }
    > = (props) => {
      const { templateType, data } = props ?? {};

      return translateEmailTemplateApiV1AdminEmailTemplatesTemplateTypeTranslatePost(
        templateType,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type TranslateEmailTemplateApiV1AdminEmailTemplatesTemplateTypeTranslatePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof translateEmailTemplateApiV1AdminEmailTemplatesTemplateTypeTranslatePost
      >
    >
  >;
export type TranslateEmailTemplateApiV1AdminEmailTemplatesTemplateTypeTranslatePostMutationBody =
  TranslateRequest;
export type TranslateEmailTemplateApiV1AdminEmailTemplatesTemplateTypeTranslatePostMutationError =
  HTTPValidationError;

/**
 * @summary Translate Email Template
 */
export const useTranslateEmailTemplateApiV1AdminEmailTemplatesTemplateTypeTranslatePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof translateEmailTemplateApiV1AdminEmailTemplatesTemplateTypeTranslatePost
          >
        >,
        TError,
        { templateType: string; data: TranslateRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof translateEmailTemplateApiV1AdminEmailTemplatesTemplateTypeTranslatePost
      >
    >,
    TError,
    { templateType: string; data: TranslateRequest },
    TContext
  > => {
    const mutationOptions =
      getTranslateEmailTemplateApiV1AdminEmailTemplatesTemplateTypeTranslatePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Get a preview of the email template with sample data filled in.
 * @summary Preview Email Template
 */
export const previewEmailTemplateApiV1AdminEmailTemplatesTemplateTypePreviewGet =
  (
    templateType: string,
    params?: PreviewEmailTemplateApiV1AdminEmailTemplatesTemplateTypePreviewGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/admin/email-templates/${templateType}/preview`,
      method: 'GET',
      params,
      signal
    });
  };

export const getPreviewEmailTemplateApiV1AdminEmailTemplatesTemplateTypePreviewGetQueryKey =
  (
    templateType?: string,
    params?: PreviewEmailTemplateApiV1AdminEmailTemplatesTemplateTypePreviewGetParams
  ) => {
    return [
      `/api/v1/admin/email-templates/${templateType}/preview`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getPreviewEmailTemplateApiV1AdminEmailTemplatesTemplateTypePreviewGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof previewEmailTemplateApiV1AdminEmailTemplatesTemplateTypePreviewGet
      >
    >,
    TError = HTTPValidationError
  >(
    templateType: string,
    params?: PreviewEmailTemplateApiV1AdminEmailTemplatesTemplateTypePreviewGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof previewEmailTemplateApiV1AdminEmailTemplatesTemplateTypePreviewGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getPreviewEmailTemplateApiV1AdminEmailTemplatesTemplateTypePreviewGetQueryKey(
        templateType,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof previewEmailTemplateApiV1AdminEmailTemplatesTemplateTypePreviewGet
        >
      >
    > = ({ signal }) =>
      previewEmailTemplateApiV1AdminEmailTemplatesTemplateTypePreviewGet(
        templateType,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!templateType,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof previewEmailTemplateApiV1AdminEmailTemplatesTemplateTypePreviewGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type PreviewEmailTemplateApiV1AdminEmailTemplatesTemplateTypePreviewGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof previewEmailTemplateApiV1AdminEmailTemplatesTemplateTypePreviewGet
      >
    >
  >;
export type PreviewEmailTemplateApiV1AdminEmailTemplatesTemplateTypePreviewGetQueryError =
  HTTPValidationError;

export function usePreviewEmailTemplateApiV1AdminEmailTemplatesTemplateTypePreviewGet<
  TData = Awaited<
    ReturnType<
      typeof previewEmailTemplateApiV1AdminEmailTemplatesTemplateTypePreviewGet
    >
  >,
  TError = HTTPValidationError
>(
  templateType: string,
  params:
    | undefined
    | PreviewEmailTemplateApiV1AdminEmailTemplatesTemplateTypePreviewGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof previewEmailTemplateApiV1AdminEmailTemplatesTemplateTypePreviewGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof previewEmailTemplateApiV1AdminEmailTemplatesTemplateTypePreviewGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof previewEmailTemplateApiV1AdminEmailTemplatesTemplateTypePreviewGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function usePreviewEmailTemplateApiV1AdminEmailTemplatesTemplateTypePreviewGet<
  TData = Awaited<
    ReturnType<
      typeof previewEmailTemplateApiV1AdminEmailTemplatesTemplateTypePreviewGet
    >
  >,
  TError = HTTPValidationError
>(
  templateType: string,
  params?: PreviewEmailTemplateApiV1AdminEmailTemplatesTemplateTypePreviewGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof previewEmailTemplateApiV1AdminEmailTemplatesTemplateTypePreviewGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof previewEmailTemplateApiV1AdminEmailTemplatesTemplateTypePreviewGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof previewEmailTemplateApiV1AdminEmailTemplatesTemplateTypePreviewGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function usePreviewEmailTemplateApiV1AdminEmailTemplatesTemplateTypePreviewGet<
  TData = Awaited<
    ReturnType<
      typeof previewEmailTemplateApiV1AdminEmailTemplatesTemplateTypePreviewGet
    >
  >,
  TError = HTTPValidationError
>(
  templateType: string,
  params?: PreviewEmailTemplateApiV1AdminEmailTemplatesTemplateTypePreviewGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof previewEmailTemplateApiV1AdminEmailTemplatesTemplateTypePreviewGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Preview Email Template
 */

export function usePreviewEmailTemplateApiV1AdminEmailTemplatesTemplateTypePreviewGet<
  TData = Awaited<
    ReturnType<
      typeof previewEmailTemplateApiV1AdminEmailTemplatesTemplateTypePreviewGet
    >
  >,
  TError = HTTPValidationError
>(
  templateType: string,
  params?: PreviewEmailTemplateApiV1AdminEmailTemplatesTemplateTypePreviewGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof previewEmailTemplateApiV1AdminEmailTemplatesTemplateTypePreviewGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getPreviewEmailTemplateApiV1AdminEmailTemplatesTemplateTypePreviewGetQueryOptions(
      templateType,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List audit logs for the current tenant. Admin only.
 * @summary List Admin Audit Logs
 */
export const listAdminAuditLogsApiV1AdminAuditLogsGet = (
  params?: ListAdminAuditLogsApiV1AdminAuditLogsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/admin/audit-logs`,
    method: 'GET',
    params,
    signal
  });
};

export const getListAdminAuditLogsApiV1AdminAuditLogsGetQueryKey = (
  params?: ListAdminAuditLogsApiV1AdminAuditLogsGetParams
) => {
  return [`/api/v1/admin/audit-logs`, ...(params ? [params] : [])] as const;
};

export const getListAdminAuditLogsApiV1AdminAuditLogsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listAdminAuditLogsApiV1AdminAuditLogsGet>>,
  TError = HTTPValidationError
>(
  params?: ListAdminAuditLogsApiV1AdminAuditLogsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAdminAuditLogsApiV1AdminAuditLogsGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListAdminAuditLogsApiV1AdminAuditLogsGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAdminAuditLogsApiV1AdminAuditLogsGet>>
  > = ({ signal }) => listAdminAuditLogsApiV1AdminAuditLogsGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAdminAuditLogsApiV1AdminAuditLogsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListAdminAuditLogsApiV1AdminAuditLogsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAdminAuditLogsApiV1AdminAuditLogsGet>>
>;
export type ListAdminAuditLogsApiV1AdminAuditLogsGetQueryError =
  HTTPValidationError;

export function useListAdminAuditLogsApiV1AdminAuditLogsGet<
  TData = Awaited<ReturnType<typeof listAdminAuditLogsApiV1AdminAuditLogsGet>>,
  TError = HTTPValidationError
>(
  params: undefined | ListAdminAuditLogsApiV1AdminAuditLogsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAdminAuditLogsApiV1AdminAuditLogsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminAuditLogsApiV1AdminAuditLogsGet>>,
          TError,
          Awaited<ReturnType<typeof listAdminAuditLogsApiV1AdminAuditLogsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListAdminAuditLogsApiV1AdminAuditLogsGet<
  TData = Awaited<ReturnType<typeof listAdminAuditLogsApiV1AdminAuditLogsGet>>,
  TError = HTTPValidationError
>(
  params?: ListAdminAuditLogsApiV1AdminAuditLogsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAdminAuditLogsApiV1AdminAuditLogsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAdminAuditLogsApiV1AdminAuditLogsGet>>,
          TError,
          Awaited<ReturnType<typeof listAdminAuditLogsApiV1AdminAuditLogsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListAdminAuditLogsApiV1AdminAuditLogsGet<
  TData = Awaited<ReturnType<typeof listAdminAuditLogsApiV1AdminAuditLogsGet>>,
  TError = HTTPValidationError
>(
  params?: ListAdminAuditLogsApiV1AdminAuditLogsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAdminAuditLogsApiV1AdminAuditLogsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Admin Audit Logs
 */

export function useListAdminAuditLogsApiV1AdminAuditLogsGet<
  TData = Awaited<ReturnType<typeof listAdminAuditLogsApiV1AdminAuditLogsGet>>,
  TError = HTTPValidationError
>(
  params?: ListAdminAuditLogsApiV1AdminAuditLogsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAdminAuditLogsApiV1AdminAuditLogsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListAdminAuditLogsApiV1AdminAuditLogsGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Enriched integration catalog for the Integrations page.

Merges static data from integrations.config.json with:
- Live OAuth connection counts for user-scoped integrations
- Bridge health status for tenant-scoped bridges (graceful fallback)
- Connection status for tenant MCP servers

Filters out platform-scoped integrations — those are server-wide vendor
accounts a tenant admin can neither see nor configure. They are rendered by
the sysadmin-only ``GET /admin/integrations/platform`` below.
 * @summary Get Integration Catalog
 */
export const getIntegrationCatalogApiV1AdminIntegrationsCatalogGet = (
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/admin/integrations/catalog`,
    method: 'GET',
    signal
  });
};

export const getGetIntegrationCatalogApiV1AdminIntegrationsCatalogGetQueryKey =
  () => {
    return [`/api/v1/admin/integrations/catalog`] as const;
  };

export const getGetIntegrationCatalogApiV1AdminIntegrationsCatalogGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getIntegrationCatalogApiV1AdminIntegrationsCatalogGet>
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getIntegrationCatalogApiV1AdminIntegrationsCatalogGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetIntegrationCatalogApiV1AdminIntegrationsCatalogGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getIntegrationCatalogApiV1AdminIntegrationsCatalogGet>
      >
    > = ({ signal }) =>
      getIntegrationCatalogApiV1AdminIntegrationsCatalogGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getIntegrationCatalogApiV1AdminIntegrationsCatalogGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetIntegrationCatalogApiV1AdminIntegrationsCatalogGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getIntegrationCatalogApiV1AdminIntegrationsCatalogGet>
    >
  >;
export type GetIntegrationCatalogApiV1AdminIntegrationsCatalogGetQueryError =
  unknown;

export function useGetIntegrationCatalogApiV1AdminIntegrationsCatalogGet<
  TData = Awaited<
    ReturnType<typeof getIntegrationCatalogApiV1AdminIntegrationsCatalogGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getIntegrationCatalogApiV1AdminIntegrationsCatalogGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getIntegrationCatalogApiV1AdminIntegrationsCatalogGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getIntegrationCatalogApiV1AdminIntegrationsCatalogGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetIntegrationCatalogApiV1AdminIntegrationsCatalogGet<
  TData = Awaited<
    ReturnType<typeof getIntegrationCatalogApiV1AdminIntegrationsCatalogGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getIntegrationCatalogApiV1AdminIntegrationsCatalogGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getIntegrationCatalogApiV1AdminIntegrationsCatalogGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getIntegrationCatalogApiV1AdminIntegrationsCatalogGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetIntegrationCatalogApiV1AdminIntegrationsCatalogGet<
  TData = Awaited<
    ReturnType<typeof getIntegrationCatalogApiV1AdminIntegrationsCatalogGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getIntegrationCatalogApiV1AdminIntegrationsCatalogGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Integration Catalog
 */

export function useGetIntegrationCatalogApiV1AdminIntegrationsCatalogGet<
  TData = Awaited<
    ReturnType<typeof getIntegrationCatalogApiV1AdminIntegrationsCatalogGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getIntegrationCatalogApiV1AdminIntegrationsCatalogGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetIntegrationCatalogApiV1AdminIntegrationsCatalogGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Platform-scoped integrations and whether each one is provisioned here.

The counterpart to ``/integrations/catalog``: that route serves the tenant
admin and excludes ``scope: "platform"`` entries, which left them rendered
nowhere at all. Several are metered, pay-per-use vendor accounts, so an
operator needs to read their provisioning out of the product rather than out
of ``.env`` or an ECS task definition.

Reports credential **presence only** — no key material and no prefix of it —
and names the environment it inspected, since a key set locally says nothing
about production.
 * @summary Get Platform Integrations
 */
export const getPlatformIntegrationsApiV1AdminIntegrationsPlatformGet = (
  signal?: AbortSignal
) => {
  return customInstance<PlatformIntegrationsResponse>({
    url: `/api/v1/admin/integrations/platform`,
    method: 'GET',
    signal
  });
};

export const getGetPlatformIntegrationsApiV1AdminIntegrationsPlatformGetQueryKey =
  () => {
    return [`/api/v1/admin/integrations/platform`] as const;
  };

export const getGetPlatformIntegrationsApiV1AdminIntegrationsPlatformGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getPlatformIntegrationsApiV1AdminIntegrationsPlatformGet
      >
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPlatformIntegrationsApiV1AdminIntegrationsPlatformGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetPlatformIntegrationsApiV1AdminIntegrationsPlatformGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getPlatformIntegrationsApiV1AdminIntegrationsPlatformGet
        >
      >
    > = ({ signal }) =>
      getPlatformIntegrationsApiV1AdminIntegrationsPlatformGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getPlatformIntegrationsApiV1AdminIntegrationsPlatformGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetPlatformIntegrationsApiV1AdminIntegrationsPlatformGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getPlatformIntegrationsApiV1AdminIntegrationsPlatformGet
      >
    >
  >;
export type GetPlatformIntegrationsApiV1AdminIntegrationsPlatformGetQueryError =
  unknown;

export function useGetPlatformIntegrationsApiV1AdminIntegrationsPlatformGet<
  TData = Awaited<
    ReturnType<typeof getPlatformIntegrationsApiV1AdminIntegrationsPlatformGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPlatformIntegrationsApiV1AdminIntegrationsPlatformGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getPlatformIntegrationsApiV1AdminIntegrationsPlatformGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getPlatformIntegrationsApiV1AdminIntegrationsPlatformGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetPlatformIntegrationsApiV1AdminIntegrationsPlatformGet<
  TData = Awaited<
    ReturnType<typeof getPlatformIntegrationsApiV1AdminIntegrationsPlatformGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPlatformIntegrationsApiV1AdminIntegrationsPlatformGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getPlatformIntegrationsApiV1AdminIntegrationsPlatformGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getPlatformIntegrationsApiV1AdminIntegrationsPlatformGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetPlatformIntegrationsApiV1AdminIntegrationsPlatformGet<
  TData = Awaited<
    ReturnType<typeof getPlatformIntegrationsApiV1AdminIntegrationsPlatformGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPlatformIntegrationsApiV1AdminIntegrationsPlatformGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Platform Integrations
 */

export function useGetPlatformIntegrationsApiV1AdminIntegrationsPlatformGet<
  TData = Awaited<
    ReturnType<typeof getPlatformIntegrationsApiV1AdminIntegrationsPlatformGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getPlatformIntegrationsApiV1AdminIntegrationsPlatformGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetPlatformIntegrationsApiV1AdminIntegrationsPlatformGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Enable or disable a user-scoped integration for the tenant.

Stores disabled integration IDs in tenant.settings.disabled_integrations (deny-list).
Only user-scoped integrations can be toggled; tenant/platform-scoped ones are managed
via MCP server add/remove.
 * @summary Toggle Integration
 */
export const toggleIntegrationApiV1AdminIntegrationsIntegrationIdTogglePut = (
  integrationId: string,
  integrationToggleRequest: IntegrationToggleRequest
) => {
  return customInstance<unknown>({
    url: `/api/v1/admin/integrations/${integrationId}/toggle`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: integrationToggleRequest
  });
};

export const getToggleIntegrationApiV1AdminIntegrationsIntegrationIdTogglePutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof toggleIntegrationApiV1AdminIntegrationsIntegrationIdTogglePut
        >
      >,
      TError,
      { integrationId: string; data: IntegrationToggleRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof toggleIntegrationApiV1AdminIntegrationsIntegrationIdTogglePut
      >
    >,
    TError,
    { integrationId: string; data: IntegrationToggleRequest },
    TContext
  > => {
    const mutationKey = [
      'toggleIntegrationApiV1AdminIntegrationsIntegrationIdTogglePut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof toggleIntegrationApiV1AdminIntegrationsIntegrationIdTogglePut
        >
      >,
      { integrationId: string; data: IntegrationToggleRequest }
    > = (props) => {
      const { integrationId, data } = props ?? {};

      return toggleIntegrationApiV1AdminIntegrationsIntegrationIdTogglePut(
        integrationId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ToggleIntegrationApiV1AdminIntegrationsIntegrationIdTogglePutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof toggleIntegrationApiV1AdminIntegrationsIntegrationIdTogglePut
      >
    >
  >;
export type ToggleIntegrationApiV1AdminIntegrationsIntegrationIdTogglePutMutationBody =
  IntegrationToggleRequest;
export type ToggleIntegrationApiV1AdminIntegrationsIntegrationIdTogglePutMutationError =
  HTTPValidationError;

/**
 * @summary Toggle Integration
 */
export const useToggleIntegrationApiV1AdminIntegrationsIntegrationIdTogglePut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof toggleIntegrationApiV1AdminIntegrationsIntegrationIdTogglePut
          >
        >,
        TError,
        { integrationId: string; data: IntegrationToggleRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof toggleIntegrationApiV1AdminIntegrationsIntegrationIdTogglePut
      >
    >,
    TError,
    { integrationId: string; data: IntegrationToggleRequest },
    TContext
  > => {
    const mutationOptions =
      getToggleIntegrationApiV1AdminIntegrationsIntegrationIdTogglePutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List all MCP servers for the tenant. Admin only.
 * @summary List Mcp Servers
 */
export const listMcpServersApiV1AdminMcpServersGet = (
  params?: ListMcpServersApiV1AdminMcpServersGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/admin/mcp-servers`,
    method: 'GET',
    params,
    signal
  });
};

export const getListMcpServersApiV1AdminMcpServersGetQueryKey = (
  params?: ListMcpServersApiV1AdminMcpServersGetParams
) => {
  return [`/api/v1/admin/mcp-servers`, ...(params ? [params] : [])] as const;
};

export const getListMcpServersApiV1AdminMcpServersGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listMcpServersApiV1AdminMcpServersGet>>,
  TError = HTTPValidationError
>(
  params?: ListMcpServersApiV1AdminMcpServersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listMcpServersApiV1AdminMcpServersGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListMcpServersApiV1AdminMcpServersGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listMcpServersApiV1AdminMcpServersGet>>
  > = ({ signal }) => listMcpServersApiV1AdminMcpServersGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMcpServersApiV1AdminMcpServersGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListMcpServersApiV1AdminMcpServersGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMcpServersApiV1AdminMcpServersGet>>
>;
export type ListMcpServersApiV1AdminMcpServersGetQueryError =
  HTTPValidationError;

export function useListMcpServersApiV1AdminMcpServersGet<
  TData = Awaited<ReturnType<typeof listMcpServersApiV1AdminMcpServersGet>>,
  TError = HTTPValidationError
>(
  params: undefined | ListMcpServersApiV1AdminMcpServersGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listMcpServersApiV1AdminMcpServersGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMcpServersApiV1AdminMcpServersGet>>,
          TError,
          Awaited<ReturnType<typeof listMcpServersApiV1AdminMcpServersGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListMcpServersApiV1AdminMcpServersGet<
  TData = Awaited<ReturnType<typeof listMcpServersApiV1AdminMcpServersGet>>,
  TError = HTTPValidationError
>(
  params?: ListMcpServersApiV1AdminMcpServersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listMcpServersApiV1AdminMcpServersGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMcpServersApiV1AdminMcpServersGet>>,
          TError,
          Awaited<ReturnType<typeof listMcpServersApiV1AdminMcpServersGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListMcpServersApiV1AdminMcpServersGet<
  TData = Awaited<ReturnType<typeof listMcpServersApiV1AdminMcpServersGet>>,
  TError = HTTPValidationError
>(
  params?: ListMcpServersApiV1AdminMcpServersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listMcpServersApiV1AdminMcpServersGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Mcp Servers
 */

export function useListMcpServersApiV1AdminMcpServersGet<
  TData = Awaited<ReturnType<typeof listMcpServersApiV1AdminMcpServersGet>>,
  TError = HTTPValidationError
>(
  params?: ListMcpServersApiV1AdminMcpServersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listMcpServersApiV1AdminMcpServersGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListMcpServersApiV1AdminMcpServersGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new MCP server. Admin only.
 * @summary Create Mcp Server
 */
export const createMcpServerApiV1AdminMcpServersPost = (
  mcpServerCreate: McpServerCreate,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/admin/mcp-servers`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: mcpServerCreate,
    signal
  });
};

export const getCreateMcpServerApiV1AdminMcpServersPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMcpServerApiV1AdminMcpServersPost>>,
    TError,
    { data: McpServerCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMcpServerApiV1AdminMcpServersPost>>,
  TError,
  { data: McpServerCreate },
  TContext
> => {
  const mutationKey = ['createMcpServerApiV1AdminMcpServersPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMcpServerApiV1AdminMcpServersPost>>,
    { data: McpServerCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createMcpServerApiV1AdminMcpServersPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMcpServerApiV1AdminMcpServersPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMcpServerApiV1AdminMcpServersPost>>
>;
export type CreateMcpServerApiV1AdminMcpServersPostMutationBody =
  McpServerCreate;
export type CreateMcpServerApiV1AdminMcpServersPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Mcp Server
 */
export const useCreateMcpServerApiV1AdminMcpServersPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createMcpServerApiV1AdminMcpServersPost>>,
      TError,
      { data: McpServerCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createMcpServerApiV1AdminMcpServersPost>>,
  TError,
  { data: McpServerCreate },
  TContext
> => {
  const mutationOptions =
    getCreateMcpServerApiV1AdminMcpServersPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Fetch available MCP bridges from the sidecar container.

Returns the catalog of bridges with health status and whether
each bridge is already added to the tenant. Admin only.
 * @summary Get Bridge Catalog
 */
export const getBridgeCatalogApiV1AdminMcpServersBridgeCatalogGet = (
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/admin/mcp-servers/bridge-catalog`,
    method: 'GET',
    signal
  });
};

export const getGetBridgeCatalogApiV1AdminMcpServersBridgeCatalogGetQueryKey =
  () => {
    return [`/api/v1/admin/mcp-servers/bridge-catalog`] as const;
  };

export const getGetBridgeCatalogApiV1AdminMcpServersBridgeCatalogGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getBridgeCatalogApiV1AdminMcpServersBridgeCatalogGet>
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getBridgeCatalogApiV1AdminMcpServersBridgeCatalogGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetBridgeCatalogApiV1AdminMcpServersBridgeCatalogGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getBridgeCatalogApiV1AdminMcpServersBridgeCatalogGet>
      >
    > = ({ signal }) =>
      getBridgeCatalogApiV1AdminMcpServersBridgeCatalogGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getBridgeCatalogApiV1AdminMcpServersBridgeCatalogGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetBridgeCatalogApiV1AdminMcpServersBridgeCatalogGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getBridgeCatalogApiV1AdminMcpServersBridgeCatalogGet>
    >
  >;
export type GetBridgeCatalogApiV1AdminMcpServersBridgeCatalogGetQueryError =
  unknown;

export function useGetBridgeCatalogApiV1AdminMcpServersBridgeCatalogGet<
  TData = Awaited<
    ReturnType<typeof getBridgeCatalogApiV1AdminMcpServersBridgeCatalogGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getBridgeCatalogApiV1AdminMcpServersBridgeCatalogGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getBridgeCatalogApiV1AdminMcpServersBridgeCatalogGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getBridgeCatalogApiV1AdminMcpServersBridgeCatalogGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetBridgeCatalogApiV1AdminMcpServersBridgeCatalogGet<
  TData = Awaited<
    ReturnType<typeof getBridgeCatalogApiV1AdminMcpServersBridgeCatalogGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getBridgeCatalogApiV1AdminMcpServersBridgeCatalogGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getBridgeCatalogApiV1AdminMcpServersBridgeCatalogGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getBridgeCatalogApiV1AdminMcpServersBridgeCatalogGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetBridgeCatalogApiV1AdminMcpServersBridgeCatalogGet<
  TData = Awaited<
    ReturnType<typeof getBridgeCatalogApiV1AdminMcpServersBridgeCatalogGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getBridgeCatalogApiV1AdminMcpServersBridgeCatalogGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Bridge Catalog
 */

export function useGetBridgeCatalogApiV1AdminMcpServersBridgeCatalogGet<
  TData = Awaited<
    ReturnType<typeof getBridgeCatalogApiV1AdminMcpServersBridgeCatalogGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getBridgeCatalogApiV1AdminMcpServersBridgeCatalogGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetBridgeCatalogApiV1AdminMcpServersBridgeCatalogGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Add an MCP server from the bridge catalog.

Creates a tenant_mcp_servers row pointing to the sidecar bridge URL,
then auto-discovers tools so agents can use them immediately.
Auth is handled by the sidecar container (via env vars), so auth_type is 'none'.
Admin only.
 * @summary Add From Bridge Catalog
 */
export const addFromBridgeCatalogApiV1AdminMcpServersFromBridgePost = (
  addFromBridgeRequest: AddFromBridgeRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/admin/mcp-servers/from-bridge`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: addFromBridgeRequest,
    signal
  });
};

export const getAddFromBridgeCatalogApiV1AdminMcpServersFromBridgePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof addFromBridgeCatalogApiV1AdminMcpServersFromBridgePost
        >
      >,
      TError,
      { data: AddFromBridgeRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof addFromBridgeCatalogApiV1AdminMcpServersFromBridgePost>
    >,
    TError,
    { data: AddFromBridgeRequest },
    TContext
  > => {
    const mutationKey = [
      'addFromBridgeCatalogApiV1AdminMcpServersFromBridgePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof addFromBridgeCatalogApiV1AdminMcpServersFromBridgePost
        >
      >,
      { data: AddFromBridgeRequest }
    > = (props) => {
      const { data } = props ?? {};

      return addFromBridgeCatalogApiV1AdminMcpServersFromBridgePost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type AddFromBridgeCatalogApiV1AdminMcpServersFromBridgePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof addFromBridgeCatalogApiV1AdminMcpServersFromBridgePost>
    >
  >;
export type AddFromBridgeCatalogApiV1AdminMcpServersFromBridgePostMutationBody =
  AddFromBridgeRequest;
export type AddFromBridgeCatalogApiV1AdminMcpServersFromBridgePostMutationError =
  HTTPValidationError;

/**
 * @summary Add From Bridge Catalog
 */
export const useAddFromBridgeCatalogApiV1AdminMcpServersFromBridgePost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof addFromBridgeCatalogApiV1AdminMcpServersFromBridgePost
        >
      >,
      TError,
      { data: AddFromBridgeRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof addFromBridgeCatalogApiV1AdminMcpServersFromBridgePost>
  >,
  TError,
  { data: AddFromBridgeRequest },
  TContext
> => {
  const mutationOptions =
    getAddFromBridgeCatalogApiV1AdminMcpServersFromBridgePostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get a specific MCP server. Admin only.
 * @summary Get Mcp Server
 */
export const getMcpServerApiV1AdminMcpServersServerIdGet = (
  serverId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/admin/mcp-servers/${serverId}`,
    method: 'GET',
    signal
  });
};

export const getGetMcpServerApiV1AdminMcpServersServerIdGetQueryKey = (
  serverId?: string
) => {
  return [`/api/v1/admin/mcp-servers/${serverId}`] as const;
};

export const getGetMcpServerApiV1AdminMcpServersServerIdGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getMcpServerApiV1AdminMcpServersServerIdGet>
  >,
  TError = HTTPValidationError
>(
  serverId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMcpServerApiV1AdminMcpServersServerIdGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetMcpServerApiV1AdminMcpServersServerIdGetQueryKey(serverId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMcpServerApiV1AdminMcpServersServerIdGet>>
  > = ({ signal }) =>
    getMcpServerApiV1AdminMcpServersServerIdGet(serverId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!serverId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getMcpServerApiV1AdminMcpServersServerIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetMcpServerApiV1AdminMcpServersServerIdGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getMcpServerApiV1AdminMcpServersServerIdGet>>
  >;
export type GetMcpServerApiV1AdminMcpServersServerIdGetQueryError =
  HTTPValidationError;

export function useGetMcpServerApiV1AdminMcpServersServerIdGet<
  TData = Awaited<
    ReturnType<typeof getMcpServerApiV1AdminMcpServersServerIdGet>
  >,
  TError = HTTPValidationError
>(
  serverId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMcpServerApiV1AdminMcpServersServerIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getMcpServerApiV1AdminMcpServersServerIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getMcpServerApiV1AdminMcpServersServerIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMcpServerApiV1AdminMcpServersServerIdGet<
  TData = Awaited<
    ReturnType<typeof getMcpServerApiV1AdminMcpServersServerIdGet>
  >,
  TError = HTTPValidationError
>(
  serverId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMcpServerApiV1AdminMcpServersServerIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getMcpServerApiV1AdminMcpServersServerIdGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getMcpServerApiV1AdminMcpServersServerIdGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMcpServerApiV1AdminMcpServersServerIdGet<
  TData = Awaited<
    ReturnType<typeof getMcpServerApiV1AdminMcpServersServerIdGet>
  >,
  TError = HTTPValidationError
>(
  serverId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMcpServerApiV1AdminMcpServersServerIdGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Mcp Server
 */

export function useGetMcpServerApiV1AdminMcpServersServerIdGet<
  TData = Awaited<
    ReturnType<typeof getMcpServerApiV1AdminMcpServersServerIdGet>
  >,
  TError = HTTPValidationError
>(
  serverId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getMcpServerApiV1AdminMcpServersServerIdGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetMcpServerApiV1AdminMcpServersServerIdGetQueryOptions(
      serverId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update an MCP server. Admin only.
 * @summary Update Mcp Server
 */
export const updateMcpServerApiV1AdminMcpServersServerIdPut = (
  serverId: string,
  mcpServerUpdate: McpServerUpdate
) => {
  return customInstance<unknown>({
    url: `/api/v1/admin/mcp-servers/${serverId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: mcpServerUpdate
  });
};

export const getUpdateMcpServerApiV1AdminMcpServersServerIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateMcpServerApiV1AdminMcpServersServerIdPut>
      >,
      TError,
      { serverId: string; data: McpServerUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof updateMcpServerApiV1AdminMcpServersServerIdPut>>,
    TError,
    { serverId: string; data: McpServerUpdate },
    TContext
  > => {
    const mutationKey = ['updateMcpServerApiV1AdminMcpServersServerIdPut'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateMcpServerApiV1AdminMcpServersServerIdPut>
      >,
      { serverId: string; data: McpServerUpdate }
    > = (props) => {
      const { serverId, data } = props ?? {};

      return updateMcpServerApiV1AdminMcpServersServerIdPut(serverId, data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateMcpServerApiV1AdminMcpServersServerIdPutMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateMcpServerApiV1AdminMcpServersServerIdPut>>
  >;
export type UpdateMcpServerApiV1AdminMcpServersServerIdPutMutationBody =
  McpServerUpdate;
export type UpdateMcpServerApiV1AdminMcpServersServerIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Mcp Server
 */
export const useUpdateMcpServerApiV1AdminMcpServersServerIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateMcpServerApiV1AdminMcpServersServerIdPut>
      >,
      TError,
      { serverId: string; data: McpServerUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateMcpServerApiV1AdminMcpServersServerIdPut>>,
  TError,
  { serverId: string; data: McpServerUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateMcpServerApiV1AdminMcpServersServerIdPutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete an MCP server. Admin only.
 * @summary Delete Mcp Server
 */
export const deleteMcpServerApiV1AdminMcpServersServerIdDelete = (
  serverId: string
) => {
  return customInstance<void>({
    url: `/api/v1/admin/mcp-servers/${serverId}`,
    method: 'DELETE'
  });
};

export const getDeleteMcpServerApiV1AdminMcpServersServerIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteMcpServerApiV1AdminMcpServersServerIdDelete>
      >,
      TError,
      { serverId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof deleteMcpServerApiV1AdminMcpServersServerIdDelete>
    >,
    TError,
    { serverId: string },
    TContext
  > => {
    const mutationKey = ['deleteMcpServerApiV1AdminMcpServersServerIdDelete'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof deleteMcpServerApiV1AdminMcpServersServerIdDelete>
      >,
      { serverId: string }
    > = (props) => {
      const { serverId } = props ?? {};

      return deleteMcpServerApiV1AdminMcpServersServerIdDelete(serverId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteMcpServerApiV1AdminMcpServersServerIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof deleteMcpServerApiV1AdminMcpServersServerIdDelete>
    >
  >;

export type DeleteMcpServerApiV1AdminMcpServersServerIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Mcp Server
 */
export const useDeleteMcpServerApiV1AdminMcpServersServerIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof deleteMcpServerApiV1AdminMcpServersServerIdDelete>
      >,
      TError,
      { serverId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteMcpServerApiV1AdminMcpServersServerIdDelete>>,
  TError,
  { serverId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteMcpServerApiV1AdminMcpServersServerIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Discover available tools from an external MCP server.

Connects to the MCP server and retrieves its list of available tools,
then caches them in the database for agents to use.

Admin only.
 * @summary Discover Mcp Server Tools
 */
export const discoverMcpServerToolsApiV1AdminMcpServersServerIdDiscoverToolsPost =
  (serverId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/admin/mcp-servers/${serverId}/discover-tools`,
      method: 'POST',
      signal
    });
  };

export const getDiscoverMcpServerToolsApiV1AdminMcpServersServerIdDiscoverToolsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof discoverMcpServerToolsApiV1AdminMcpServersServerIdDiscoverToolsPost
        >
      >,
      TError,
      { serverId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof discoverMcpServerToolsApiV1AdminMcpServersServerIdDiscoverToolsPost
      >
    >,
    TError,
    { serverId: string },
    TContext
  > => {
    const mutationKey = [
      'discoverMcpServerToolsApiV1AdminMcpServersServerIdDiscoverToolsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof discoverMcpServerToolsApiV1AdminMcpServersServerIdDiscoverToolsPost
        >
      >,
      { serverId: string }
    > = (props) => {
      const { serverId } = props ?? {};

      return discoverMcpServerToolsApiV1AdminMcpServersServerIdDiscoverToolsPost(
        serverId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DiscoverMcpServerToolsApiV1AdminMcpServersServerIdDiscoverToolsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof discoverMcpServerToolsApiV1AdminMcpServersServerIdDiscoverToolsPost
      >
    >
  >;

export type DiscoverMcpServerToolsApiV1AdminMcpServersServerIdDiscoverToolsPostMutationError =
  HTTPValidationError;

/**
 * @summary Discover Mcp Server Tools
 */
export const useDiscoverMcpServerToolsApiV1AdminMcpServersServerIdDiscoverToolsPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof discoverMcpServerToolsApiV1AdminMcpServersServerIdDiscoverToolsPost
          >
        >,
        TError,
        { serverId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof discoverMcpServerToolsApiV1AdminMcpServersServerIdDiscoverToolsPost
      >
    >,
    TError,
    { serverId: string },
    TContext
  > => {
    const mutationOptions =
      getDiscoverMcpServerToolsApiV1AdminMcpServersServerIdDiscoverToolsPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Get agents assigned to a specific MCP server. Admin only.
 * @summary Get Mcp Server Agents
 */
export const getMcpServerAgentsApiV1AdminMcpServersServerIdAgentsGet = (
  serverId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/admin/mcp-servers/${serverId}/agents`,
    method: 'GET',
    signal
  });
};

export const getGetMcpServerAgentsApiV1AdminMcpServersServerIdAgentsGetQueryKey =
  (serverId?: string) => {
    return [`/api/v1/admin/mcp-servers/${serverId}/agents`] as const;
  };

export const getGetMcpServerAgentsApiV1AdminMcpServersServerIdAgentsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getMcpServerAgentsApiV1AdminMcpServersServerIdAgentsGet>
    >,
    TError = HTTPValidationError
  >(
    serverId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getMcpServerAgentsApiV1AdminMcpServersServerIdAgentsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetMcpServerAgentsApiV1AdminMcpServersServerIdAgentsGetQueryKey(
        serverId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getMcpServerAgentsApiV1AdminMcpServersServerIdAgentsGet
        >
      >
    > = ({ signal }) =>
      getMcpServerAgentsApiV1AdminMcpServersServerIdAgentsGet(serverId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!serverId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getMcpServerAgentsApiV1AdminMcpServersServerIdAgentsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetMcpServerAgentsApiV1AdminMcpServersServerIdAgentsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getMcpServerAgentsApiV1AdminMcpServersServerIdAgentsGet>
    >
  >;
export type GetMcpServerAgentsApiV1AdminMcpServersServerIdAgentsGetQueryError =
  HTTPValidationError;

export function useGetMcpServerAgentsApiV1AdminMcpServersServerIdAgentsGet<
  TData = Awaited<
    ReturnType<typeof getMcpServerAgentsApiV1AdminMcpServersServerIdAgentsGet>
  >,
  TError = HTTPValidationError
>(
  serverId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getMcpServerAgentsApiV1AdminMcpServersServerIdAgentsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getMcpServerAgentsApiV1AdminMcpServersServerIdAgentsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getMcpServerAgentsApiV1AdminMcpServersServerIdAgentsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMcpServerAgentsApiV1AdminMcpServersServerIdAgentsGet<
  TData = Awaited<
    ReturnType<typeof getMcpServerAgentsApiV1AdminMcpServersServerIdAgentsGet>
  >,
  TError = HTTPValidationError
>(
  serverId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getMcpServerAgentsApiV1AdminMcpServersServerIdAgentsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getMcpServerAgentsApiV1AdminMcpServersServerIdAgentsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getMcpServerAgentsApiV1AdminMcpServersServerIdAgentsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMcpServerAgentsApiV1AdminMcpServersServerIdAgentsGet<
  TData = Awaited<
    ReturnType<typeof getMcpServerAgentsApiV1AdminMcpServersServerIdAgentsGet>
  >,
  TError = HTTPValidationError
>(
  serverId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getMcpServerAgentsApiV1AdminMcpServersServerIdAgentsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Mcp Server Agents
 */

export function useGetMcpServerAgentsApiV1AdminMcpServersServerIdAgentsGet<
  TData = Awaited<
    ReturnType<typeof getMcpServerAgentsApiV1AdminMcpServersServerIdAgentsGet>
  >,
  TError = HTTPValidationError
>(
  serverId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getMcpServerAgentsApiV1AdminMcpServersServerIdAgentsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetMcpServerAgentsApiV1AdminMcpServersServerIdAgentsGetQueryOptions(
      serverId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get tool invocations for a specific MCP server. Admin only.
 * @summary Get Mcp Server Invocations
 */
export const getMcpServerInvocationsApiV1AdminMcpServersServerIdInvocationsGet =
  (
    serverId: string,
    params?: GetMcpServerInvocationsApiV1AdminMcpServersServerIdInvocationsGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<unknown>({
      url: `/api/v1/admin/mcp-servers/${serverId}/invocations`,
      method: 'GET',
      params,
      signal
    });
  };

export const getGetMcpServerInvocationsApiV1AdminMcpServersServerIdInvocationsGetQueryKey =
  (
    serverId?: string,
    params?: GetMcpServerInvocationsApiV1AdminMcpServersServerIdInvocationsGetParams
  ) => {
    return [
      `/api/v1/admin/mcp-servers/${serverId}/invocations`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getGetMcpServerInvocationsApiV1AdminMcpServersServerIdInvocationsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getMcpServerInvocationsApiV1AdminMcpServersServerIdInvocationsGet
      >
    >,
    TError = HTTPValidationError
  >(
    serverId: string,
    params?: GetMcpServerInvocationsApiV1AdminMcpServersServerIdInvocationsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getMcpServerInvocationsApiV1AdminMcpServersServerIdInvocationsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetMcpServerInvocationsApiV1AdminMcpServersServerIdInvocationsGetQueryKey(
        serverId,
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getMcpServerInvocationsApiV1AdminMcpServersServerIdInvocationsGet
        >
      >
    > = ({ signal }) =>
      getMcpServerInvocationsApiV1AdminMcpServersServerIdInvocationsGet(
        serverId,
        params,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!serverId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getMcpServerInvocationsApiV1AdminMcpServersServerIdInvocationsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetMcpServerInvocationsApiV1AdminMcpServersServerIdInvocationsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getMcpServerInvocationsApiV1AdminMcpServersServerIdInvocationsGet
      >
    >
  >;
export type GetMcpServerInvocationsApiV1AdminMcpServersServerIdInvocationsGetQueryError =
  HTTPValidationError;

export function useGetMcpServerInvocationsApiV1AdminMcpServersServerIdInvocationsGet<
  TData = Awaited<
    ReturnType<
      typeof getMcpServerInvocationsApiV1AdminMcpServersServerIdInvocationsGet
    >
  >,
  TError = HTTPValidationError
>(
  serverId: string,
  params:
    | undefined
    | GetMcpServerInvocationsApiV1AdminMcpServersServerIdInvocationsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getMcpServerInvocationsApiV1AdminMcpServersServerIdInvocationsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getMcpServerInvocationsApiV1AdminMcpServersServerIdInvocationsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getMcpServerInvocationsApiV1AdminMcpServersServerIdInvocationsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMcpServerInvocationsApiV1AdminMcpServersServerIdInvocationsGet<
  TData = Awaited<
    ReturnType<
      typeof getMcpServerInvocationsApiV1AdminMcpServersServerIdInvocationsGet
    >
  >,
  TError = HTTPValidationError
>(
  serverId: string,
  params?: GetMcpServerInvocationsApiV1AdminMcpServersServerIdInvocationsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getMcpServerInvocationsApiV1AdminMcpServersServerIdInvocationsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getMcpServerInvocationsApiV1AdminMcpServersServerIdInvocationsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getMcpServerInvocationsApiV1AdminMcpServersServerIdInvocationsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMcpServerInvocationsApiV1AdminMcpServersServerIdInvocationsGet<
  TData = Awaited<
    ReturnType<
      typeof getMcpServerInvocationsApiV1AdminMcpServersServerIdInvocationsGet
    >
  >,
  TError = HTTPValidationError
>(
  serverId: string,
  params?: GetMcpServerInvocationsApiV1AdminMcpServersServerIdInvocationsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getMcpServerInvocationsApiV1AdminMcpServersServerIdInvocationsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Mcp Server Invocations
 */

export function useGetMcpServerInvocationsApiV1AdminMcpServersServerIdInvocationsGet<
  TData = Awaited<
    ReturnType<
      typeof getMcpServerInvocationsApiV1AdminMcpServersServerIdInvocationsGet
    >
  >,
  TError = HTTPValidationError
>(
  serverId: string,
  params?: GetMcpServerInvocationsApiV1AdminMcpServersServerIdInvocationsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getMcpServerInvocationsApiV1AdminMcpServersServerIdInvocationsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetMcpServerInvocationsApiV1AdminMcpServersServerIdInvocationsGetQueryOptions(
      serverId,
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Operational status of the current tenant workspace. Admin only.

Returns a single payload with user/storage/AI/activity stats, outstanding
onboarding gaps, and the latest 10 admin-relevant audit events. Cached
for 30s per tenant.
 * @summary Get Dashboard Status
 */
export const getDashboardStatusApiV1AdminDashboardStatusGet = (
  signal?: AbortSignal
) => {
  return customInstance<AdminDashboardStatus>({
    url: `/api/v1/admin/dashboard/status`,
    method: 'GET',
    signal
  });
};

export const getGetDashboardStatusApiV1AdminDashboardStatusGetQueryKey = () => {
  return [`/api/v1/admin/dashboard/status`] as const;
};

export const getGetDashboardStatusApiV1AdminDashboardStatusGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getDashboardStatusApiV1AdminDashboardStatusGet>
  >,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<typeof getDashboardStatusApiV1AdminDashboardStatusGet>
      >,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetDashboardStatusApiV1AdminDashboardStatusGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDashboardStatusApiV1AdminDashboardStatusGet>>
  > = ({ signal }) => getDashboardStatusApiV1AdminDashboardStatusGet(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDashboardStatusApiV1AdminDashboardStatusGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetDashboardStatusApiV1AdminDashboardStatusGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getDashboardStatusApiV1AdminDashboardStatusGet>>
  >;
export type GetDashboardStatusApiV1AdminDashboardStatusGetQueryError = unknown;

export function useGetDashboardStatusApiV1AdminDashboardStatusGet<
  TData = Awaited<
    ReturnType<typeof getDashboardStatusApiV1AdminDashboardStatusGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDashboardStatusApiV1AdminDashboardStatusGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getDashboardStatusApiV1AdminDashboardStatusGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getDashboardStatusApiV1AdminDashboardStatusGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDashboardStatusApiV1AdminDashboardStatusGet<
  TData = Awaited<
    ReturnType<typeof getDashboardStatusApiV1AdminDashboardStatusGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDashboardStatusApiV1AdminDashboardStatusGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getDashboardStatusApiV1AdminDashboardStatusGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getDashboardStatusApiV1AdminDashboardStatusGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDashboardStatusApiV1AdminDashboardStatusGet<
  TData = Awaited<
    ReturnType<typeof getDashboardStatusApiV1AdminDashboardStatusGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDashboardStatusApiV1AdminDashboardStatusGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Dashboard Status
 */

export function useGetDashboardStatusApiV1AdminDashboardStatusGet<
  TData = Awaited<
    ReturnType<typeof getDashboardStatusApiV1AdminDashboardStatusGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getDashboardStatusApiV1AdminDashboardStatusGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetDashboardStatusApiV1AdminDashboardStatusGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get tenant AI settings with effective categories for each skill.

Returns all skills with their:
- default_category (from config)
- sysadmin_category (from system settings)
- tenant_category (tenant override, if any)
- effective_category (resolved category to use)
- effective_category_info (provider, name, tier info)
 * @summary Get Ai Settings
 */
export const getAiSettingsApiV1AdminAiSettingsGet = (signal?: AbortSignal) => {
  return customInstance<unknown>({
    url: `/api/v1/admin/ai-settings`,
    method: 'GET',
    signal
  });
};

export const getGetAiSettingsApiV1AdminAiSettingsGetQueryKey = () => {
  return [`/api/v1/admin/ai-settings`] as const;
};

export const getGetAiSettingsApiV1AdminAiSettingsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getAiSettingsApiV1AdminAiSettingsGet>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getAiSettingsApiV1AdminAiSettingsGet>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAiSettingsApiV1AdminAiSettingsGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAiSettingsApiV1AdminAiSettingsGet>>
  > = ({ signal }) => getAiSettingsApiV1AdminAiSettingsGet(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAiSettingsApiV1AdminAiSettingsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAiSettingsApiV1AdminAiSettingsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAiSettingsApiV1AdminAiSettingsGet>>
>;
export type GetAiSettingsApiV1AdminAiSettingsGetQueryError = unknown;

export function useGetAiSettingsApiV1AdminAiSettingsGet<
  TData = Awaited<ReturnType<typeof getAiSettingsApiV1AdminAiSettingsGet>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAiSettingsApiV1AdminAiSettingsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiSettingsApiV1AdminAiSettingsGet>>,
          TError,
          Awaited<ReturnType<typeof getAiSettingsApiV1AdminAiSettingsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAiSettingsApiV1AdminAiSettingsGet<
  TData = Awaited<ReturnType<typeof getAiSettingsApiV1AdminAiSettingsGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAiSettingsApiV1AdminAiSettingsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAiSettingsApiV1AdminAiSettingsGet>>,
          TError,
          Awaited<ReturnType<typeof getAiSettingsApiV1AdminAiSettingsGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAiSettingsApiV1AdminAiSettingsGet<
  TData = Awaited<ReturnType<typeof getAiSettingsApiV1AdminAiSettingsGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAiSettingsApiV1AdminAiSettingsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Ai Settings
 */

export function useGetAiSettingsApiV1AdminAiSettingsGet<
  TData = Awaited<ReturnType<typeof getAiSettingsApiV1AdminAiSettingsGet>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAiSettingsApiV1AdminAiSettingsGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetAiSettingsApiV1AdminAiSettingsGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get categories available to tenants for selection.

Returns categories with resolved model and reasoning info.
 * @summary Get Available Categories
 */
export const getAvailableCategoriesApiV1AdminAiSettingsAvailableCategoriesGet =
  (signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/admin/ai-settings/available-categories`,
      method: 'GET',
      signal
    });
  };

export const getGetAvailableCategoriesApiV1AdminAiSettingsAvailableCategoriesGetQueryKey =
  () => {
    return [`/api/v1/admin/ai-settings/available-categories`] as const;
  };

export const getGetAvailableCategoriesApiV1AdminAiSettingsAvailableCategoriesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getAvailableCategoriesApiV1AdminAiSettingsAvailableCategoriesGet
      >
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAvailableCategoriesApiV1AdminAiSettingsAvailableCategoriesGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetAvailableCategoriesApiV1AdminAiSettingsAvailableCategoriesGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getAvailableCategoriesApiV1AdminAiSettingsAvailableCategoriesGet
        >
      >
    > = ({ signal }) =>
      getAvailableCategoriesApiV1AdminAiSettingsAvailableCategoriesGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getAvailableCategoriesApiV1AdminAiSettingsAvailableCategoriesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetAvailableCategoriesApiV1AdminAiSettingsAvailableCategoriesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getAvailableCategoriesApiV1AdminAiSettingsAvailableCategoriesGet
      >
    >
  >;
export type GetAvailableCategoriesApiV1AdminAiSettingsAvailableCategoriesGetQueryError =
  unknown;

export function useGetAvailableCategoriesApiV1AdminAiSettingsAvailableCategoriesGet<
  TData = Awaited<
    ReturnType<
      typeof getAvailableCategoriesApiV1AdminAiSettingsAvailableCategoriesGet
    >
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAvailableCategoriesApiV1AdminAiSettingsAvailableCategoriesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getAvailableCategoriesApiV1AdminAiSettingsAvailableCategoriesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getAvailableCategoriesApiV1AdminAiSettingsAvailableCategoriesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAvailableCategoriesApiV1AdminAiSettingsAvailableCategoriesGet<
  TData = Awaited<
    ReturnType<
      typeof getAvailableCategoriesApiV1AdminAiSettingsAvailableCategoriesGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAvailableCategoriesApiV1AdminAiSettingsAvailableCategoriesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getAvailableCategoriesApiV1AdminAiSettingsAvailableCategoriesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getAvailableCategoriesApiV1AdminAiSettingsAvailableCategoriesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAvailableCategoriesApiV1AdminAiSettingsAvailableCategoriesGet<
  TData = Awaited<
    ReturnType<
      typeof getAvailableCategoriesApiV1AdminAiSettingsAvailableCategoriesGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAvailableCategoriesApiV1AdminAiSettingsAvailableCategoriesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Available Categories
 */

export function useGetAvailableCategoriesApiV1AdminAiSettingsAvailableCategoriesGet<
  TData = Awaited<
    ReturnType<
      typeof getAvailableCategoriesApiV1AdminAiSettingsAvailableCategoriesGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAvailableCategoriesApiV1AdminAiSettingsAvailableCategoriesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetAvailableCategoriesApiV1AdminAiSettingsAvailableCategoriesGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Set the category override for a specific skill.

The category must be available to tenants.
 * @summary Update Skill Category
 */
export const updateSkillCategoryApiV1AdminAiSettingsSkillsSkillIdPut = (
  skillId: string,
  aISkillCategoryUpdate: AISkillCategoryUpdate
) => {
  return customInstance<unknown>({
    url: `/api/v1/admin/ai-settings/skills/${skillId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: aISkillCategoryUpdate
  });
};

export const getUpdateSkillCategoryApiV1AdminAiSettingsSkillsSkillIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateSkillCategoryApiV1AdminAiSettingsSkillsSkillIdPut
        >
      >,
      TError,
      { skillId: string; data: AISkillCategoryUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateSkillCategoryApiV1AdminAiSettingsSkillsSkillIdPut>
    >,
    TError,
    { skillId: string; data: AISkillCategoryUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateSkillCategoryApiV1AdminAiSettingsSkillsSkillIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateSkillCategoryApiV1AdminAiSettingsSkillsSkillIdPut
        >
      >,
      { skillId: string; data: AISkillCategoryUpdate }
    > = (props) => {
      const { skillId, data } = props ?? {};

      return updateSkillCategoryApiV1AdminAiSettingsSkillsSkillIdPut(
        skillId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateSkillCategoryApiV1AdminAiSettingsSkillsSkillIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updateSkillCategoryApiV1AdminAiSettingsSkillsSkillIdPut>
    >
  >;
export type UpdateSkillCategoryApiV1AdminAiSettingsSkillsSkillIdPutMutationBody =
  AISkillCategoryUpdate;
export type UpdateSkillCategoryApiV1AdminAiSettingsSkillsSkillIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Skill Category
 */
export const useUpdateSkillCategoryApiV1AdminAiSettingsSkillsSkillIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateSkillCategoryApiV1AdminAiSettingsSkillsSkillIdPut
        >
      >,
      TError,
      { skillId: string; data: AISkillCategoryUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateSkillCategoryApiV1AdminAiSettingsSkillsSkillIdPut>
  >,
  TError,
  { skillId: string; data: AISkillCategoryUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateSkillCategoryApiV1AdminAiSettingsSkillsSkillIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Clear the category override for a skill (revert to sysadmin default).
 * @summary Clear Skill Category
 */
export const clearSkillCategoryApiV1AdminAiSettingsSkillsSkillIdDelete = (
  skillId: string
) => {
  return customInstance<unknown>({
    url: `/api/v1/admin/ai-settings/skills/${skillId}`,
    method: 'DELETE'
  });
};

export const getClearSkillCategoryApiV1AdminAiSettingsSkillsSkillIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof clearSkillCategoryApiV1AdminAiSettingsSkillsSkillIdDelete
        >
      >,
      TError,
      { skillId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof clearSkillCategoryApiV1AdminAiSettingsSkillsSkillIdDelete
      >
    >,
    TError,
    { skillId: string },
    TContext
  > => {
    const mutationKey = [
      'clearSkillCategoryApiV1AdminAiSettingsSkillsSkillIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof clearSkillCategoryApiV1AdminAiSettingsSkillsSkillIdDelete
        >
      >,
      { skillId: string }
    > = (props) => {
      const { skillId } = props ?? {};

      return clearSkillCategoryApiV1AdminAiSettingsSkillsSkillIdDelete(skillId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ClearSkillCategoryApiV1AdminAiSettingsSkillsSkillIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof clearSkillCategoryApiV1AdminAiSettingsSkillsSkillIdDelete
      >
    >
  >;

export type ClearSkillCategoryApiV1AdminAiSettingsSkillsSkillIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Clear Skill Category
 */
export const useClearSkillCategoryApiV1AdminAiSettingsSkillsSkillIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof clearSkillCategoryApiV1AdminAiSettingsSkillsSkillIdDelete
        >
      >,
      TError,
      { skillId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof clearSkillCategoryApiV1AdminAiSettingsSkillsSkillIdDelete>
  >,
  TError,
  { skillId: string },
  TContext
> => {
  const mutationOptions =
    getClearSkillCategoryApiV1AdminAiSettingsSkillsSkillIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Update multiple skill category overrides at once.
 * @summary Update Skill Categories
 */
export const updateSkillCategoriesApiV1AdminAiSettingsSkillsPut = (
  aISkillCategoriesUpdate: AISkillCategoriesUpdate
) => {
  return customInstance<unknown>({
    url: `/api/v1/admin/ai-settings/skills`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: aISkillCategoriesUpdate
  });
};

export const getUpdateSkillCategoriesApiV1AdminAiSettingsSkillsPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateSkillCategoriesApiV1AdminAiSettingsSkillsPut>
      >,
      TError,
      { data: AISkillCategoriesUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateSkillCategoriesApiV1AdminAiSettingsSkillsPut>
    >,
    TError,
    { data: AISkillCategoriesUpdate },
    TContext
  > => {
    const mutationKey = ['updateSkillCategoriesApiV1AdminAiSettingsSkillsPut'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateSkillCategoriesApiV1AdminAiSettingsSkillsPut>
      >,
      { data: AISkillCategoriesUpdate }
    > = (props) => {
      const { data } = props ?? {};

      return updateSkillCategoriesApiV1AdminAiSettingsSkillsPut(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateSkillCategoriesApiV1AdminAiSettingsSkillsPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updateSkillCategoriesApiV1AdminAiSettingsSkillsPut>
    >
  >;
export type UpdateSkillCategoriesApiV1AdminAiSettingsSkillsPutMutationBody =
  AISkillCategoriesUpdate;
export type UpdateSkillCategoriesApiV1AdminAiSettingsSkillsPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Skill Categories
 */
export const useUpdateSkillCategoriesApiV1AdminAiSettingsSkillsPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateSkillCategoriesApiV1AdminAiSettingsSkillsPut>
      >,
      TError,
      { data: AISkillCategoriesUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateSkillCategoriesApiV1AdminAiSettingsSkillsPut>
  >,
  TError,
  { data: AISkillCategoriesUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateSkillCategoriesApiV1AdminAiSettingsSkillsPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Set the reasoning effort override for a specific skill.
 * @summary Update Skill Reasoning
 */
export const updateSkillReasoningApiV1AdminAiSettingsSkillsSkillIdReasoningPut =
  (skillId: string, aISkillReasoningUpdate: AISkillReasoningUpdate) => {
    return customInstance<unknown>({
      url: `/api/v1/admin/ai-settings/skills/${skillId}/reasoning`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: aISkillReasoningUpdate
    });
  };

export const getUpdateSkillReasoningApiV1AdminAiSettingsSkillsSkillIdReasoningPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateSkillReasoningApiV1AdminAiSettingsSkillsSkillIdReasoningPut
        >
      >,
      TError,
      { skillId: string; data: AISkillReasoningUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateSkillReasoningApiV1AdminAiSettingsSkillsSkillIdReasoningPut
      >
    >,
    TError,
    { skillId: string; data: AISkillReasoningUpdate },
    TContext
  > => {
    const mutationKey = [
      'updateSkillReasoningApiV1AdminAiSettingsSkillsSkillIdReasoningPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateSkillReasoningApiV1AdminAiSettingsSkillsSkillIdReasoningPut
        >
      >,
      { skillId: string; data: AISkillReasoningUpdate }
    > = (props) => {
      const { skillId, data } = props ?? {};

      return updateSkillReasoningApiV1AdminAiSettingsSkillsSkillIdReasoningPut(
        skillId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateSkillReasoningApiV1AdminAiSettingsSkillsSkillIdReasoningPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateSkillReasoningApiV1AdminAiSettingsSkillsSkillIdReasoningPut
      >
    >
  >;
export type UpdateSkillReasoningApiV1AdminAiSettingsSkillsSkillIdReasoningPutMutationBody =
  AISkillReasoningUpdate;
export type UpdateSkillReasoningApiV1AdminAiSettingsSkillsSkillIdReasoningPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Skill Reasoning
 */
export const useUpdateSkillReasoningApiV1AdminAiSettingsSkillsSkillIdReasoningPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateSkillReasoningApiV1AdminAiSettingsSkillsSkillIdReasoningPut
          >
        >,
        TError,
        { skillId: string; data: AISkillReasoningUpdate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateSkillReasoningApiV1AdminAiSettingsSkillsSkillIdReasoningPut
      >
    >,
    TError,
    { skillId: string; data: AISkillReasoningUpdate },
    TContext
  > => {
    const mutationOptions =
      getUpdateSkillReasoningApiV1AdminAiSettingsSkillsSkillIdReasoningPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * List every AI provider and whether this tenant has brought its own key.
 * @summary List Provider Keys
 */
export const listProviderKeysApiV1AdminAiSettingsProviderKeysGet = (
  signal?: AbortSignal
) => {
  return customInstance<AIProviderKeyListResponse>({
    url: `/api/v1/admin/ai-settings/provider-keys`,
    method: 'GET',
    signal
  });
};

export const getListProviderKeysApiV1AdminAiSettingsProviderKeysGetQueryKey =
  () => {
    return [`/api/v1/admin/ai-settings/provider-keys`] as const;
  };

export const getListProviderKeysApiV1AdminAiSettingsProviderKeysGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listProviderKeysApiV1AdminAiSettingsProviderKeysGet>
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listProviderKeysApiV1AdminAiSettingsProviderKeysGet>
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListProviderKeysApiV1AdminAiSettingsProviderKeysGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listProviderKeysApiV1AdminAiSettingsProviderKeysGet>
      >
    > = ({ signal }) =>
      listProviderKeysApiV1AdminAiSettingsProviderKeysGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listProviderKeysApiV1AdminAiSettingsProviderKeysGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListProviderKeysApiV1AdminAiSettingsProviderKeysGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listProviderKeysApiV1AdminAiSettingsProviderKeysGet>
    >
  >;
export type ListProviderKeysApiV1AdminAiSettingsProviderKeysGetQueryError =
  unknown;

export function useListProviderKeysApiV1AdminAiSettingsProviderKeysGet<
  TData = Awaited<
    ReturnType<typeof listProviderKeysApiV1AdminAiSettingsProviderKeysGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listProviderKeysApiV1AdminAiSettingsProviderKeysGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listProviderKeysApiV1AdminAiSettingsProviderKeysGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listProviderKeysApiV1AdminAiSettingsProviderKeysGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListProviderKeysApiV1AdminAiSettingsProviderKeysGet<
  TData = Awaited<
    ReturnType<typeof listProviderKeysApiV1AdminAiSettingsProviderKeysGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listProviderKeysApiV1AdminAiSettingsProviderKeysGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listProviderKeysApiV1AdminAiSettingsProviderKeysGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listProviderKeysApiV1AdminAiSettingsProviderKeysGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListProviderKeysApiV1AdminAiSettingsProviderKeysGet<
  TData = Awaited<
    ReturnType<typeof listProviderKeysApiV1AdminAiSettingsProviderKeysGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listProviderKeysApiV1AdminAiSettingsProviderKeysGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Provider Keys
 */

export function useListProviderKeysApiV1AdminAiSettingsProviderKeysGet<
  TData = Awaited<
    ReturnType<typeof listProviderKeysApiV1AdminAiSettingsProviderKeysGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listProviderKeysApiV1AdminAiSettingsProviderKeysGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListProviderKeysApiV1AdminAiSettingsProviderKeysGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Store this tenant's own API key for ``provider_id``.

From the next LLM call, that provider's usage runs on their key and is billed
at the markup alone. The first key also opens their BYOK credit line, so a
zero wallet no longer cuts their AI off (design §8).
 * @summary Store Provider Key
 */
export const storeProviderKeyApiV1AdminAiSettingsProviderKeysProviderIdPut = (
  providerId: string,
  aIProviderKeyUpdate: AIProviderKeyUpdate
) => {
  return customInstance<AIProviderKeyListResponse>({
    url: `/api/v1/admin/ai-settings/provider-keys/${providerId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: aIProviderKeyUpdate
  });
};

export const getStoreProviderKeyApiV1AdminAiSettingsProviderKeysProviderIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof storeProviderKeyApiV1AdminAiSettingsProviderKeysProviderIdPut
        >
      >,
      TError,
      { providerId: string; data: AIProviderKeyUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof storeProviderKeyApiV1AdminAiSettingsProviderKeysProviderIdPut
      >
    >,
    TError,
    { providerId: string; data: AIProviderKeyUpdate },
    TContext
  > => {
    const mutationKey = [
      'storeProviderKeyApiV1AdminAiSettingsProviderKeysProviderIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof storeProviderKeyApiV1AdminAiSettingsProviderKeysProviderIdPut
        >
      >,
      { providerId: string; data: AIProviderKeyUpdate }
    > = (props) => {
      const { providerId, data } = props ?? {};

      return storeProviderKeyApiV1AdminAiSettingsProviderKeysProviderIdPut(
        providerId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type StoreProviderKeyApiV1AdminAiSettingsProviderKeysProviderIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof storeProviderKeyApiV1AdminAiSettingsProviderKeysProviderIdPut
      >
    >
  >;
export type StoreProviderKeyApiV1AdminAiSettingsProviderKeysProviderIdPutMutationBody =
  AIProviderKeyUpdate;
export type StoreProviderKeyApiV1AdminAiSettingsProviderKeysProviderIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Store Provider Key
 */
export const useStoreProviderKeyApiV1AdminAiSettingsProviderKeysProviderIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof storeProviderKeyApiV1AdminAiSettingsProviderKeysProviderIdPut
          >
        >,
        TError,
        { providerId: string; data: AIProviderKeyUpdate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof storeProviderKeyApiV1AdminAiSettingsProviderKeysProviderIdPut
      >
    >,
    TError,
    { providerId: string; data: AIProviderKeyUpdate },
    TContext
  > => {
    const mutationOptions =
      getStoreProviderKeyApiV1AdminAiSettingsProviderKeysProviderIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Remove the tenant's key. That provider's usage reverts to PanLuma's keys.
 * @summary Remove Provider Key
 */
export const removeProviderKeyApiV1AdminAiSettingsProviderKeysProviderIdDelete =
  (providerId: string) => {
    return customInstance<AIProviderKeyListResponse>({
      url: `/api/v1/admin/ai-settings/provider-keys/${providerId}`,
      method: 'DELETE'
    });
  };

export const getRemoveProviderKeyApiV1AdminAiSettingsProviderKeysProviderIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof removeProviderKeyApiV1AdminAiSettingsProviderKeysProviderIdDelete
        >
      >,
      TError,
      { providerId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof removeProviderKeyApiV1AdminAiSettingsProviderKeysProviderIdDelete
      >
    >,
    TError,
    { providerId: string },
    TContext
  > => {
    const mutationKey = [
      'removeProviderKeyApiV1AdminAiSettingsProviderKeysProviderIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof removeProviderKeyApiV1AdminAiSettingsProviderKeysProviderIdDelete
        >
      >,
      { providerId: string }
    > = (props) => {
      const { providerId } = props ?? {};

      return removeProviderKeyApiV1AdminAiSettingsProviderKeysProviderIdDelete(
        providerId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RemoveProviderKeyApiV1AdminAiSettingsProviderKeysProviderIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof removeProviderKeyApiV1AdminAiSettingsProviderKeysProviderIdDelete
      >
    >
  >;

export type RemoveProviderKeyApiV1AdminAiSettingsProviderKeysProviderIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Remove Provider Key
 */
export const useRemoveProviderKeyApiV1AdminAiSettingsProviderKeysProviderIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof removeProviderKeyApiV1AdminAiSettingsProviderKeysProviderIdDelete
          >
        >,
        TError,
        { providerId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof removeProviderKeyApiV1AdminAiSettingsProviderKeysProviderIdDelete
      >
    >,
    TError,
    { providerId: string },
    TContext
  > => {
    const mutationOptions =
      getRemoveProviderKeyApiV1AdminAiSettingsProviderKeysProviderIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Test the stored key against the provider and record the outcome.

A failing test records the failure and reports it inline; it deliberately does
NOT notify or switch to the platform key — the admin is looking at the result,
and only a real call failing changes which key we present (design §5).
 * @summary Verify Provider Key
 */
export const verifyProviderKeyApiV1AdminAiSettingsProviderKeysProviderIdVerifyPost =
  (providerId: string, signal?: AbortSignal) => {
    return customInstance<AIProviderKeyVerifyResponse>({
      url: `/api/v1/admin/ai-settings/provider-keys/${providerId}/verify`,
      method: 'POST',
      signal
    });
  };

export const getVerifyProviderKeyApiV1AdminAiSettingsProviderKeysProviderIdVerifyPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof verifyProviderKeyApiV1AdminAiSettingsProviderKeysProviderIdVerifyPost
        >
      >,
      TError,
      { providerId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof verifyProviderKeyApiV1AdminAiSettingsProviderKeysProviderIdVerifyPost
      >
    >,
    TError,
    { providerId: string },
    TContext
  > => {
    const mutationKey = [
      'verifyProviderKeyApiV1AdminAiSettingsProviderKeysProviderIdVerifyPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof verifyProviderKeyApiV1AdminAiSettingsProviderKeysProviderIdVerifyPost
        >
      >,
      { providerId: string }
    > = (props) => {
      const { providerId } = props ?? {};

      return verifyProviderKeyApiV1AdminAiSettingsProviderKeysProviderIdVerifyPost(
        providerId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type VerifyProviderKeyApiV1AdminAiSettingsProviderKeysProviderIdVerifyPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof verifyProviderKeyApiV1AdminAiSettingsProviderKeysProviderIdVerifyPost
      >
    >
  >;

export type VerifyProviderKeyApiV1AdminAiSettingsProviderKeysProviderIdVerifyPostMutationError =
  HTTPValidationError;

/**
 * @summary Verify Provider Key
 */
export const useVerifyProviderKeyApiV1AdminAiSettingsProviderKeysProviderIdVerifyPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof verifyProviderKeyApiV1AdminAiSettingsProviderKeysProviderIdVerifyPost
          >
        >,
        TError,
        { providerId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof verifyProviderKeyApiV1AdminAiSettingsProviderKeysProviderIdVerifyPost
      >
    >,
    TError,
    { providerId: string },
    TContext
  > => {
    const mutationOptions =
      getVerifyProviderKeyApiV1AdminAiSettingsProviderKeysProviderIdVerifyPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Set whether a failing tenant key may fall back to PanLuma's keys.

Off by default and only ever turned on from here — nothing in the system
enables it, because falling back spends tokens the tenant is then billed
cost + markup for.
 * @summary Update Platform Key Fallback
 */
export const updatePlatformKeyFallbackApiV1AdminAiSettingsProviderKeysFallbackPut =
  (aIPlatformKeyFallbackUpdate: AIPlatformKeyFallbackUpdate) => {
    return customInstance<AIProviderKeyListResponse>({
      url: `/api/v1/admin/ai-settings/provider-keys-fallback`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: aIPlatformKeyFallbackUpdate
    });
  };

export const getUpdatePlatformKeyFallbackApiV1AdminAiSettingsProviderKeysFallbackPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updatePlatformKeyFallbackApiV1AdminAiSettingsProviderKeysFallbackPut
        >
      >,
      TError,
      { data: AIPlatformKeyFallbackUpdate },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updatePlatformKeyFallbackApiV1AdminAiSettingsProviderKeysFallbackPut
      >
    >,
    TError,
    { data: AIPlatformKeyFallbackUpdate },
    TContext
  > => {
    const mutationKey = [
      'updatePlatformKeyFallbackApiV1AdminAiSettingsProviderKeysFallbackPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updatePlatformKeyFallbackApiV1AdminAiSettingsProviderKeysFallbackPut
        >
      >,
      { data: AIPlatformKeyFallbackUpdate }
    > = (props) => {
      const { data } = props ?? {};

      return updatePlatformKeyFallbackApiV1AdminAiSettingsProviderKeysFallbackPut(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdatePlatformKeyFallbackApiV1AdminAiSettingsProviderKeysFallbackPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updatePlatformKeyFallbackApiV1AdminAiSettingsProviderKeysFallbackPut
      >
    >
  >;
export type UpdatePlatformKeyFallbackApiV1AdminAiSettingsProviderKeysFallbackPutMutationBody =
  AIPlatformKeyFallbackUpdate;
export type UpdatePlatformKeyFallbackApiV1AdminAiSettingsProviderKeysFallbackPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Platform Key Fallback
 */
export const useUpdatePlatformKeyFallbackApiV1AdminAiSettingsProviderKeysFallbackPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updatePlatformKeyFallbackApiV1AdminAiSettingsProviderKeysFallbackPut
          >
        >,
        TError,
        { data: AIPlatformKeyFallbackUpdate },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updatePlatformKeyFallbackApiV1AdminAiSettingsProviderKeysFallbackPut
      >
    >,
    TError,
    { data: AIPlatformKeyFallbackUpdate },
    TContext
  > => {
    const mutationOptions =
      getUpdatePlatformKeyFallbackApiV1AdminAiSettingsProviderKeysFallbackPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Start emulating a user.

Requires the emulation grant — a sysadmin-tenant member who is either an admin
of that tenant or holds the "User Emulation" role (``admin.emulation.use``).
Sysadmin-tenant membership alone is deliberately not enough: see
``shared.dependencies.auth.can_emulate_users``. Returns a special JWT token that
allows the operator to act as the target user while maintaining audit trail.

The sysadmin must provide:
- justification: Detailed reason for the emulation (min 10 chars)
- authority: Reference to authorization (ticket #, user request, etc.)
 * @summary Start Emulation
 */
export const startEmulationApiV1AdminEmulationStartPost = (
  startEmulationRequest: StartEmulationRequest,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/admin/emulation/start`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: startEmulationRequest,
    signal
  });
};

export const getStartEmulationApiV1AdminEmulationStartPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startEmulationApiV1AdminEmulationStartPost>>,
    TError,
    { data: StartEmulationRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof startEmulationApiV1AdminEmulationStartPost>>,
  TError,
  { data: StartEmulationRequest },
  TContext
> => {
  const mutationKey = ['startEmulationApiV1AdminEmulationStartPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startEmulationApiV1AdminEmulationStartPost>>,
    { data: StartEmulationRequest }
  > = (props) => {
    const { data } = props ?? {};

    return startEmulationApiV1AdminEmulationStartPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type StartEmulationApiV1AdminEmulationStartPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof startEmulationApiV1AdminEmulationStartPost>>
  >;
export type StartEmulationApiV1AdminEmulationStartPostMutationBody =
  StartEmulationRequest;
export type StartEmulationApiV1AdminEmulationStartPostMutationError =
  HTTPValidationError;

/**
 * @summary Start Emulation
 */
export const useStartEmulationApiV1AdminEmulationStartPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof startEmulationApiV1AdminEmulationStartPost>>,
      TError,
      { data: StartEmulationRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof startEmulationApiV1AdminEmulationStartPost>>,
  TError,
  { data: StartEmulationRequest },
  TContext
> => {
  const mutationOptions =
    getStartEmulationApiV1AdminEmulationStartPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * End the current emulation session.

Returns a fresh token for the sysadmin's original identity.
 * @summary End Emulation
 */
export const endEmulationApiV1AdminEmulationEndPost = (
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/admin/emulation/end`,
    method: 'POST',
    signal
  });
};

export const getEndEmulationApiV1AdminEmulationEndPostMutationOptions = <
  TError = unknown,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof endEmulationApiV1AdminEmulationEndPost>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof endEmulationApiV1AdminEmulationEndPost>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['endEmulationApiV1AdminEmulationEndPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof endEmulationApiV1AdminEmulationEndPost>>,
    void
  > = () => {
    return endEmulationApiV1AdminEmulationEndPost();
  };

  return { mutationFn, ...mutationOptions };
};

export type EndEmulationApiV1AdminEmulationEndPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof endEmulationApiV1AdminEmulationEndPost>>
>;

export type EndEmulationApiV1AdminEmulationEndPostMutationError = unknown;

/**
 * @summary End Emulation
 */
export const useEndEmulationApiV1AdminEmulationEndPost = <
  TError = unknown,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof endEmulationApiV1AdminEmulationEndPost>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof endEmulationApiV1AdminEmulationEndPost>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getEndEmulationApiV1AdminEmulationEndPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get the current emulation session details.

Returns null if no active session.
 * @summary Get Current Session
 */
export const getCurrentSessionApiV1AdminEmulationSessionGet = (
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/admin/emulation/session`,
    method: 'GET',
    signal
  });
};

export const getGetCurrentSessionApiV1AdminEmulationSessionGetQueryKey = () => {
  return [`/api/v1/admin/emulation/session`] as const;
};

export const getGetCurrentSessionApiV1AdminEmulationSessionGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getCurrentSessionApiV1AdminEmulationSessionGet>
  >,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<
        ReturnType<typeof getCurrentSessionApiV1AdminEmulationSessionGet>
      >,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCurrentSessionApiV1AdminEmulationSessionGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCurrentSessionApiV1AdminEmulationSessionGet>>
  > = ({ signal }) => getCurrentSessionApiV1AdminEmulationSessionGet(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCurrentSessionApiV1AdminEmulationSessionGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetCurrentSessionApiV1AdminEmulationSessionGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getCurrentSessionApiV1AdminEmulationSessionGet>>
  >;
export type GetCurrentSessionApiV1AdminEmulationSessionGetQueryError = unknown;

export function useGetCurrentSessionApiV1AdminEmulationSessionGet<
  TData = Awaited<
    ReturnType<typeof getCurrentSessionApiV1AdminEmulationSessionGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getCurrentSessionApiV1AdminEmulationSessionGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getCurrentSessionApiV1AdminEmulationSessionGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getCurrentSessionApiV1AdminEmulationSessionGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetCurrentSessionApiV1AdminEmulationSessionGet<
  TData = Awaited<
    ReturnType<typeof getCurrentSessionApiV1AdminEmulationSessionGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getCurrentSessionApiV1AdminEmulationSessionGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getCurrentSessionApiV1AdminEmulationSessionGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof getCurrentSessionApiV1AdminEmulationSessionGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetCurrentSessionApiV1AdminEmulationSessionGet<
  TData = Awaited<
    ReturnType<typeof getCurrentSessionApiV1AdminEmulationSessionGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getCurrentSessionApiV1AdminEmulationSessionGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Current Session
 */

export function useGetCurrentSessionApiV1AdminEmulationSessionGet<
  TData = Awaited<
    ReturnType<typeof getCurrentSessionApiV1AdminEmulationSessionGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getCurrentSessionApiV1AdminEmulationSessionGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetCurrentSessionApiV1AdminEmulationSessionGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List emulation sessions with optional filters.

Sysadmin only. Returns session history for auditing.
 * @summary List Emulation Sessions
 */
export const listEmulationSessionsApiV1AdminEmulationSessionsGet = (
  params?: ListEmulationSessionsApiV1AdminEmulationSessionsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/admin/emulation/sessions`,
    method: 'GET',
    params,
    signal
  });
};

export const getListEmulationSessionsApiV1AdminEmulationSessionsGetQueryKey = (
  params?: ListEmulationSessionsApiV1AdminEmulationSessionsGetParams
) => {
  return [
    `/api/v1/admin/emulation/sessions`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListEmulationSessionsApiV1AdminEmulationSessionsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listEmulationSessionsApiV1AdminEmulationSessionsGet>
    >,
    TError = HTTPValidationError
  >(
    params?: ListEmulationSessionsApiV1AdminEmulationSessionsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listEmulationSessionsApiV1AdminEmulationSessionsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListEmulationSessionsApiV1AdminEmulationSessionsGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listEmulationSessionsApiV1AdminEmulationSessionsGet>
      >
    > = ({ signal }) =>
      listEmulationSessionsApiV1AdminEmulationSessionsGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listEmulationSessionsApiV1AdminEmulationSessionsGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListEmulationSessionsApiV1AdminEmulationSessionsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listEmulationSessionsApiV1AdminEmulationSessionsGet>
    >
  >;
export type ListEmulationSessionsApiV1AdminEmulationSessionsGetQueryError =
  HTTPValidationError;

export function useListEmulationSessionsApiV1AdminEmulationSessionsGet<
  TData = Awaited<
    ReturnType<typeof listEmulationSessionsApiV1AdminEmulationSessionsGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListEmulationSessionsApiV1AdminEmulationSessionsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listEmulationSessionsApiV1AdminEmulationSessionsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listEmulationSessionsApiV1AdminEmulationSessionsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listEmulationSessionsApiV1AdminEmulationSessionsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListEmulationSessionsApiV1AdminEmulationSessionsGet<
  TData = Awaited<
    ReturnType<typeof listEmulationSessionsApiV1AdminEmulationSessionsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListEmulationSessionsApiV1AdminEmulationSessionsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listEmulationSessionsApiV1AdminEmulationSessionsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listEmulationSessionsApiV1AdminEmulationSessionsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listEmulationSessionsApiV1AdminEmulationSessionsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListEmulationSessionsApiV1AdminEmulationSessionsGet<
  TData = Awaited<
    ReturnType<typeof listEmulationSessionsApiV1AdminEmulationSessionsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListEmulationSessionsApiV1AdminEmulationSessionsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listEmulationSessionsApiV1AdminEmulationSessionsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Emulation Sessions
 */

export function useListEmulationSessionsApiV1AdminEmulationSessionsGet<
  TData = Awaited<
    ReturnType<typeof listEmulationSessionsApiV1AdminEmulationSessionsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListEmulationSessionsApiV1AdminEmulationSessionsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listEmulationSessionsApiV1AdminEmulationSessionsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListEmulationSessionsApiV1AdminEmulationSessionsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Search users across all tenants for emulation.

Feeds the emulation target picker, so it carries the same grant as
``POST /start`` rather than plain sysadmin: a sysadmin who may not emulate has
no reason to enumerate every user in every tenant from here.
 * @summary Search Users For Emulation
 */
export const searchUsersForEmulationApiV1AdminEmulationUsersSearchGet = (
  params: SearchUsersForEmulationApiV1AdminEmulationUsersSearchGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/admin/emulation/users/search`,
    method: 'GET',
    params,
    signal
  });
};

export const getSearchUsersForEmulationApiV1AdminEmulationUsersSearchGetQueryKey =
  (params?: SearchUsersForEmulationApiV1AdminEmulationUsersSearchGetParams) => {
    return [
      `/api/v1/admin/emulation/users/search`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getSearchUsersForEmulationApiV1AdminEmulationUsersSearchGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof searchUsersForEmulationApiV1AdminEmulationUsersSearchGet
      >
    >,
    TError = HTTPValidationError
  >(
    params: SearchUsersForEmulationApiV1AdminEmulationUsersSearchGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof searchUsersForEmulationApiV1AdminEmulationUsersSearchGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getSearchUsersForEmulationApiV1AdminEmulationUsersSearchGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof searchUsersForEmulationApiV1AdminEmulationUsersSearchGet
        >
      >
    > = ({ signal }) =>
      searchUsersForEmulationApiV1AdminEmulationUsersSearchGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof searchUsersForEmulationApiV1AdminEmulationUsersSearchGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type SearchUsersForEmulationApiV1AdminEmulationUsersSearchGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof searchUsersForEmulationApiV1AdminEmulationUsersSearchGet
      >
    >
  >;
export type SearchUsersForEmulationApiV1AdminEmulationUsersSearchGetQueryError =
  HTTPValidationError;

export function useSearchUsersForEmulationApiV1AdminEmulationUsersSearchGet<
  TData = Awaited<
    ReturnType<typeof searchUsersForEmulationApiV1AdminEmulationUsersSearchGet>
  >,
  TError = HTTPValidationError
>(
  params: SearchUsersForEmulationApiV1AdminEmulationUsersSearchGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof searchUsersForEmulationApiV1AdminEmulationUsersSearchGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof searchUsersForEmulationApiV1AdminEmulationUsersSearchGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof searchUsersForEmulationApiV1AdminEmulationUsersSearchGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useSearchUsersForEmulationApiV1AdminEmulationUsersSearchGet<
  TData = Awaited<
    ReturnType<typeof searchUsersForEmulationApiV1AdminEmulationUsersSearchGet>
  >,
  TError = HTTPValidationError
>(
  params: SearchUsersForEmulationApiV1AdminEmulationUsersSearchGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof searchUsersForEmulationApiV1AdminEmulationUsersSearchGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof searchUsersForEmulationApiV1AdminEmulationUsersSearchGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof searchUsersForEmulationApiV1AdminEmulationUsersSearchGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useSearchUsersForEmulationApiV1AdminEmulationUsersSearchGet<
  TData = Awaited<
    ReturnType<typeof searchUsersForEmulationApiV1AdminEmulationUsersSearchGet>
  >,
  TError = HTTPValidationError
>(
  params: SearchUsersForEmulationApiV1AdminEmulationUsersSearchGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof searchUsersForEmulationApiV1AdminEmulationUsersSearchGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Search Users For Emulation
 */

export function useSearchUsersForEmulationApiV1AdminEmulationUsersSearchGet<
  TData = Awaited<
    ReturnType<typeof searchUsersForEmulationApiV1AdminEmulationUsersSearchGet>
  >,
  TError = HTTPValidationError
>(
  params: SearchUsersForEmulationApiV1AdminEmulationUsersSearchGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof searchUsersForEmulationApiV1AdminEmulationUsersSearchGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getSearchUsersForEmulationApiV1AdminEmulationUsersSearchGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List active tenants for the emulation tenant filter (typeahead).

Carries the emulation grant for the same reason ``/users/search`` does — it is
the other half of the target picker. Bounded by ``limit`` and narrowed by a
case-insensitive ``search`` on tenant name or slug so the picker never
downloads every tenant.
 * @summary List Tenants For Emulation
 */
export const listTenantsForEmulationApiV1AdminEmulationTenantsGet = (
  params?: ListTenantsForEmulationApiV1AdminEmulationTenantsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/admin/emulation/tenants`,
    method: 'GET',
    params,
    signal
  });
};

export const getListTenantsForEmulationApiV1AdminEmulationTenantsGetQueryKey = (
  params?: ListTenantsForEmulationApiV1AdminEmulationTenantsGetParams
) => {
  return [
    `/api/v1/admin/emulation/tenants`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListTenantsForEmulationApiV1AdminEmulationTenantsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listTenantsForEmulationApiV1AdminEmulationTenantsGet>
    >,
    TError = HTTPValidationError
  >(
    params?: ListTenantsForEmulationApiV1AdminEmulationTenantsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listTenantsForEmulationApiV1AdminEmulationTenantsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListTenantsForEmulationApiV1AdminEmulationTenantsGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listTenantsForEmulationApiV1AdminEmulationTenantsGet>
      >
    > = ({ signal }) =>
      listTenantsForEmulationApiV1AdminEmulationTenantsGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listTenantsForEmulationApiV1AdminEmulationTenantsGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListTenantsForEmulationApiV1AdminEmulationTenantsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listTenantsForEmulationApiV1AdminEmulationTenantsGet>
    >
  >;
export type ListTenantsForEmulationApiV1AdminEmulationTenantsGetQueryError =
  HTTPValidationError;

export function useListTenantsForEmulationApiV1AdminEmulationTenantsGet<
  TData = Awaited<
    ReturnType<typeof listTenantsForEmulationApiV1AdminEmulationTenantsGet>
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | ListTenantsForEmulationApiV1AdminEmulationTenantsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listTenantsForEmulationApiV1AdminEmulationTenantsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listTenantsForEmulationApiV1AdminEmulationTenantsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listTenantsForEmulationApiV1AdminEmulationTenantsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListTenantsForEmulationApiV1AdminEmulationTenantsGet<
  TData = Awaited<
    ReturnType<typeof listTenantsForEmulationApiV1AdminEmulationTenantsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListTenantsForEmulationApiV1AdminEmulationTenantsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listTenantsForEmulationApiV1AdminEmulationTenantsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listTenantsForEmulationApiV1AdminEmulationTenantsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listTenantsForEmulationApiV1AdminEmulationTenantsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListTenantsForEmulationApiV1AdminEmulationTenantsGet<
  TData = Awaited<
    ReturnType<typeof listTenantsForEmulationApiV1AdminEmulationTenantsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListTenantsForEmulationApiV1AdminEmulationTenantsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listTenantsForEmulationApiV1AdminEmulationTenantsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Tenants For Emulation
 */

export function useListTenantsForEmulationApiV1AdminEmulationTenantsGet<
  TData = Awaited<
    ReturnType<typeof listTenantsForEmulationApiV1AdminEmulationTenantsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListTenantsForEmulationApiV1AdminEmulationTenantsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listTenantsForEmulationApiV1AdminEmulationTenantsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListTenantsForEmulationApiV1AdminEmulationTenantsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List all offices for the tenant.
 * @summary List Offices
 */
export const listOfficesApiV1AdminOfficesGet = (
  params?: ListOfficesApiV1AdminOfficesGetParams,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/admin/offices`,
    method: 'GET',
    params,
    signal
  });
};

export const getListOfficesApiV1AdminOfficesGetQueryKey = (
  params?: ListOfficesApiV1AdminOfficesGetParams
) => {
  return [`/api/v1/admin/offices`, ...(params ? [params] : [])] as const;
};

export const getListOfficesApiV1AdminOfficesGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listOfficesApiV1AdminOfficesGet>>,
  TError = HTTPValidationError
>(
  params?: ListOfficesApiV1AdminOfficesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOfficesApiV1AdminOfficesGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListOfficesApiV1AdminOfficesGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listOfficesApiV1AdminOfficesGet>>
  > = ({ signal }) => listOfficesApiV1AdminOfficesGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listOfficesApiV1AdminOfficesGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListOfficesApiV1AdminOfficesGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOfficesApiV1AdminOfficesGet>>
>;
export type ListOfficesApiV1AdminOfficesGetQueryError = HTTPValidationError;

export function useListOfficesApiV1AdminOfficesGet<
  TData = Awaited<ReturnType<typeof listOfficesApiV1AdminOfficesGet>>,
  TError = HTTPValidationError
>(
  params: undefined | ListOfficesApiV1AdminOfficesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOfficesApiV1AdminOfficesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOfficesApiV1AdminOfficesGet>>,
          TError,
          Awaited<ReturnType<typeof listOfficesApiV1AdminOfficesGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListOfficesApiV1AdminOfficesGet<
  TData = Awaited<ReturnType<typeof listOfficesApiV1AdminOfficesGet>>,
  TError = HTTPValidationError
>(
  params?: ListOfficesApiV1AdminOfficesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOfficesApiV1AdminOfficesGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOfficesApiV1AdminOfficesGet>>,
          TError,
          Awaited<ReturnType<typeof listOfficesApiV1AdminOfficesGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListOfficesApiV1AdminOfficesGet<
  TData = Awaited<ReturnType<typeof listOfficesApiV1AdminOfficesGet>>,
  TError = HTTPValidationError
>(
  params?: ListOfficesApiV1AdminOfficesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOfficesApiV1AdminOfficesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Offices
 */

export function useListOfficesApiV1AdminOfficesGet<
  TData = Awaited<ReturnType<typeof listOfficesApiV1AdminOfficesGet>>,
  TError = HTTPValidationError
>(
  params?: ListOfficesApiV1AdminOfficesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOfficesApiV1AdminOfficesGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListOfficesApiV1AdminOfficesGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new office. Admin only.
 * @summary Create Office
 */
export const createOfficeApiV1AdminOfficesPost = (
  officeCreate: OfficeCreate,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/admin/offices`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: officeCreate,
    signal
  });
};

export const getCreateOfficeApiV1AdminOfficesPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOfficeApiV1AdminOfficesPost>>,
    TError,
    { data: OfficeCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createOfficeApiV1AdminOfficesPost>>,
  TError,
  { data: OfficeCreate },
  TContext
> => {
  const mutationKey = ['createOfficeApiV1AdminOfficesPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createOfficeApiV1AdminOfficesPost>>,
    { data: OfficeCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createOfficeApiV1AdminOfficesPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateOfficeApiV1AdminOfficesPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof createOfficeApiV1AdminOfficesPost>>
>;
export type CreateOfficeApiV1AdminOfficesPostMutationBody = OfficeCreate;
export type CreateOfficeApiV1AdminOfficesPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Office
 */
export const useCreateOfficeApiV1AdminOfficesPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createOfficeApiV1AdminOfficesPost>>,
      TError,
      { data: OfficeCreate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createOfficeApiV1AdminOfficesPost>>,
  TError,
  { data: OfficeCreate },
  TContext
> => {
  const mutationOptions =
    getCreateOfficeApiV1AdminOfficesPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get a specific office.
 * @summary Get Office
 */
export const getOfficeApiV1AdminOfficesOfficeIdGet = (
  officeId: string,
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/admin/offices/${officeId}`,
    method: 'GET',
    signal
  });
};

export const getGetOfficeApiV1AdminOfficesOfficeIdGetQueryKey = (
  officeId?: string
) => {
  return [`/api/v1/admin/offices/${officeId}`] as const;
};

export const getGetOfficeApiV1AdminOfficesOfficeIdGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getOfficeApiV1AdminOfficesOfficeIdGet>>,
  TError = HTTPValidationError
>(
  officeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOfficeApiV1AdminOfficesOfficeIdGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetOfficeApiV1AdminOfficesOfficeIdGetQueryKey(officeId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOfficeApiV1AdminOfficesOfficeIdGet>>
  > = ({ signal }) => getOfficeApiV1AdminOfficesOfficeIdGet(officeId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!officeId,
    ...queryOptions
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getOfficeApiV1AdminOfficesOfficeIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetOfficeApiV1AdminOfficesOfficeIdGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOfficeApiV1AdminOfficesOfficeIdGet>>
>;
export type GetOfficeApiV1AdminOfficesOfficeIdGetQueryError =
  HTTPValidationError;

export function useGetOfficeApiV1AdminOfficesOfficeIdGet<
  TData = Awaited<ReturnType<typeof getOfficeApiV1AdminOfficesOfficeIdGet>>,
  TError = HTTPValidationError
>(
  officeId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOfficeApiV1AdminOfficesOfficeIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOfficeApiV1AdminOfficesOfficeIdGet>>,
          TError,
          Awaited<ReturnType<typeof getOfficeApiV1AdminOfficesOfficeIdGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetOfficeApiV1AdminOfficesOfficeIdGet<
  TData = Awaited<ReturnType<typeof getOfficeApiV1AdminOfficesOfficeIdGet>>,
  TError = HTTPValidationError
>(
  officeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOfficeApiV1AdminOfficesOfficeIdGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOfficeApiV1AdminOfficesOfficeIdGet>>,
          TError,
          Awaited<ReturnType<typeof getOfficeApiV1AdminOfficesOfficeIdGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetOfficeApiV1AdminOfficesOfficeIdGet<
  TData = Awaited<ReturnType<typeof getOfficeApiV1AdminOfficesOfficeIdGet>>,
  TError = HTTPValidationError
>(
  officeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOfficeApiV1AdminOfficesOfficeIdGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Office
 */

export function useGetOfficeApiV1AdminOfficesOfficeIdGet<
  TData = Awaited<ReturnType<typeof getOfficeApiV1AdminOfficesOfficeIdGet>>,
  TError = HTTPValidationError
>(
  officeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOfficeApiV1AdminOfficesOfficeIdGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetOfficeApiV1AdminOfficesOfficeIdGetQueryOptions(
    officeId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update an office. Admin only.
 * @summary Update Office
 */
export const updateOfficeApiV1AdminOfficesOfficeIdPut = (
  officeId: string,
  officeUpdate: OfficeUpdate
) => {
  return customInstance<unknown>({
    url: `/api/v1/admin/offices/${officeId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: officeUpdate
  });
};

export const getUpdateOfficeApiV1AdminOfficesOfficeIdPutMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOfficeApiV1AdminOfficesOfficeIdPut>>,
    TError,
    { officeId: string; data: OfficeUpdate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateOfficeApiV1AdminOfficesOfficeIdPut>>,
  TError,
  { officeId: string; data: OfficeUpdate },
  TContext
> => {
  const mutationKey = ['updateOfficeApiV1AdminOfficesOfficeIdPut'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateOfficeApiV1AdminOfficesOfficeIdPut>>,
    { officeId: string; data: OfficeUpdate }
  > = (props) => {
    const { officeId, data } = props ?? {};

    return updateOfficeApiV1AdminOfficesOfficeIdPut(officeId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateOfficeApiV1AdminOfficesOfficeIdPutMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateOfficeApiV1AdminOfficesOfficeIdPut>>
  >;
export type UpdateOfficeApiV1AdminOfficesOfficeIdPutMutationBody = OfficeUpdate;
export type UpdateOfficeApiV1AdminOfficesOfficeIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Office
 */
export const useUpdateOfficeApiV1AdminOfficesOfficeIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateOfficeApiV1AdminOfficesOfficeIdPut>>,
      TError,
      { officeId: string; data: OfficeUpdate },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateOfficeApiV1AdminOfficesOfficeIdPut>>,
  TError,
  { officeId: string; data: OfficeUpdate },
  TContext
> => {
  const mutationOptions =
    getUpdateOfficeApiV1AdminOfficesOfficeIdPutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Delete an office. Admin only.
 * @summary Delete Office
 */
export const deleteOfficeApiV1AdminOfficesOfficeIdDelete = (
  officeId: string
) => {
  return customInstance<void>({
    url: `/api/v1/admin/offices/${officeId}`,
    method: 'DELETE'
  });
};

export const getDeleteOfficeApiV1AdminOfficesOfficeIdDeleteMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteOfficeApiV1AdminOfficesOfficeIdDelete>>,
    TError,
    { officeId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteOfficeApiV1AdminOfficesOfficeIdDelete>>,
  TError,
  { officeId: string },
  TContext
> => {
  const mutationKey = ['deleteOfficeApiV1AdminOfficesOfficeIdDelete'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteOfficeApiV1AdminOfficesOfficeIdDelete>>,
    { officeId: string }
  > = (props) => {
    const { officeId } = props ?? {};

    return deleteOfficeApiV1AdminOfficesOfficeIdDelete(officeId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteOfficeApiV1AdminOfficesOfficeIdDeleteMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof deleteOfficeApiV1AdminOfficesOfficeIdDelete>>
  >;

export type DeleteOfficeApiV1AdminOfficesOfficeIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Office
 */
export const useDeleteOfficeApiV1AdminOfficesOfficeIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteOfficeApiV1AdminOfficesOfficeIdDelete>>,
      TError,
      { officeId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteOfficeApiV1AdminOfficesOfficeIdDelete>>,
  TError,
  { officeId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteOfficeApiV1AdminOfficesOfficeIdDeleteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * List modules/entities available for import.
 * @summary List Importable Entities
 */
export const listImportableEntitiesApiV1AdminDataImportEntitiesGet = (
  signal?: AbortSignal
) => {
  return customInstance<ListImportableEntitiesApiV1AdminDataImportEntitiesGet200>(
    { url: `/api/v1/admin/data-import/entities`, method: 'GET', signal }
  );
};

export const getListImportableEntitiesApiV1AdminDataImportEntitiesGetQueryKey =
  () => {
    return [`/api/v1/admin/data-import/entities`] as const;
  };

export const getListImportableEntitiesApiV1AdminDataImportEntitiesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listImportableEntitiesApiV1AdminDataImportEntitiesGet>
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listImportableEntitiesApiV1AdminDataImportEntitiesGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListImportableEntitiesApiV1AdminDataImportEntitiesGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listImportableEntitiesApiV1AdminDataImportEntitiesGet>
      >
    > = ({ signal }) =>
      listImportableEntitiesApiV1AdminDataImportEntitiesGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listImportableEntitiesApiV1AdminDataImportEntitiesGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListImportableEntitiesApiV1AdminDataImportEntitiesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listImportableEntitiesApiV1AdminDataImportEntitiesGet>
    >
  >;
export type ListImportableEntitiesApiV1AdminDataImportEntitiesGetQueryError =
  unknown;

export function useListImportableEntitiesApiV1AdminDataImportEntitiesGet<
  TData = Awaited<
    ReturnType<typeof listImportableEntitiesApiV1AdminDataImportEntitiesGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listImportableEntitiesApiV1AdminDataImportEntitiesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listImportableEntitiesApiV1AdminDataImportEntitiesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listImportableEntitiesApiV1AdminDataImportEntitiesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListImportableEntitiesApiV1AdminDataImportEntitiesGet<
  TData = Awaited<
    ReturnType<typeof listImportableEntitiesApiV1AdminDataImportEntitiesGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listImportableEntitiesApiV1AdminDataImportEntitiesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listImportableEntitiesApiV1AdminDataImportEntitiesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listImportableEntitiesApiV1AdminDataImportEntitiesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListImportableEntitiesApiV1AdminDataImportEntitiesGet<
  TData = Awaited<
    ReturnType<typeof listImportableEntitiesApiV1AdminDataImportEntitiesGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listImportableEntitiesApiV1AdminDataImportEntitiesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Importable Entities
 */

export function useListImportableEntitiesApiV1AdminDataImportEntitiesGet<
  TData = Awaited<
    ReturnType<typeof listImportableEntitiesApiV1AdminDataImportEntitiesGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listImportableEntitiesApiV1AdminDataImportEntitiesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListImportableEntitiesApiV1AdminDataImportEntitiesGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get the target JSON schema for a module/entity.
 * @summary Get Entity Schema
 */
export const getEntitySchemaApiV1AdminDataImportEntitiesModuleIdEntityIdSchemaGet =
  (moduleId: string, entityId: string, signal?: AbortSignal) => {
    return customInstance<GetEntitySchemaApiV1AdminDataImportEntitiesModuleIdEntityIdSchemaGet200>(
      {
        url: `/api/v1/admin/data-import/entities/${moduleId}/${entityId}/schema`,
        method: 'GET',
        signal
      }
    );
  };

export const getGetEntitySchemaApiV1AdminDataImportEntitiesModuleIdEntityIdSchemaGetQueryKey =
  (moduleId?: string, entityId?: string) => {
    return [
      `/api/v1/admin/data-import/entities/${moduleId}/${entityId}/schema`
    ] as const;
  };

export const getGetEntitySchemaApiV1AdminDataImportEntitiesModuleIdEntityIdSchemaGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getEntitySchemaApiV1AdminDataImportEntitiesModuleIdEntityIdSchemaGet
      >
    >,
    TError = HTTPValidationError
  >(
    moduleId: string,
    entityId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getEntitySchemaApiV1AdminDataImportEntitiesModuleIdEntityIdSchemaGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetEntitySchemaApiV1AdminDataImportEntitiesModuleIdEntityIdSchemaGetQueryKey(
        moduleId,
        entityId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getEntitySchemaApiV1AdminDataImportEntitiesModuleIdEntityIdSchemaGet
        >
      >
    > = ({ signal }) =>
      getEntitySchemaApiV1AdminDataImportEntitiesModuleIdEntityIdSchemaGet(
        moduleId,
        entityId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(moduleId && entityId),
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getEntitySchemaApiV1AdminDataImportEntitiesModuleIdEntityIdSchemaGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetEntitySchemaApiV1AdminDataImportEntitiesModuleIdEntityIdSchemaGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getEntitySchemaApiV1AdminDataImportEntitiesModuleIdEntityIdSchemaGet
      >
    >
  >;
export type GetEntitySchemaApiV1AdminDataImportEntitiesModuleIdEntityIdSchemaGetQueryError =
  HTTPValidationError;

export function useGetEntitySchemaApiV1AdminDataImportEntitiesModuleIdEntityIdSchemaGet<
  TData = Awaited<
    ReturnType<
      typeof getEntitySchemaApiV1AdminDataImportEntitiesModuleIdEntityIdSchemaGet
    >
  >,
  TError = HTTPValidationError
>(
  moduleId: string,
  entityId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEntitySchemaApiV1AdminDataImportEntitiesModuleIdEntityIdSchemaGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getEntitySchemaApiV1AdminDataImportEntitiesModuleIdEntityIdSchemaGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getEntitySchemaApiV1AdminDataImportEntitiesModuleIdEntityIdSchemaGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetEntitySchemaApiV1AdminDataImportEntitiesModuleIdEntityIdSchemaGet<
  TData = Awaited<
    ReturnType<
      typeof getEntitySchemaApiV1AdminDataImportEntitiesModuleIdEntityIdSchemaGet
    >
  >,
  TError = HTTPValidationError
>(
  moduleId: string,
  entityId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEntitySchemaApiV1AdminDataImportEntitiesModuleIdEntityIdSchemaGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getEntitySchemaApiV1AdminDataImportEntitiesModuleIdEntityIdSchemaGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getEntitySchemaApiV1AdminDataImportEntitiesModuleIdEntityIdSchemaGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetEntitySchemaApiV1AdminDataImportEntitiesModuleIdEntityIdSchemaGet<
  TData = Awaited<
    ReturnType<
      typeof getEntitySchemaApiV1AdminDataImportEntitiesModuleIdEntityIdSchemaGet
    >
  >,
  TError = HTTPValidationError
>(
  moduleId: string,
  entityId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEntitySchemaApiV1AdminDataImportEntitiesModuleIdEntityIdSchemaGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Entity Schema
 */

export function useGetEntitySchemaApiV1AdminDataImportEntitiesModuleIdEntityIdSchemaGet<
  TData = Awaited<
    ReturnType<
      typeof getEntitySchemaApiV1AdminDataImportEntitiesModuleIdEntityIdSchemaGet
    >
  >,
  TError = HTTPValidationError
>(
  moduleId: string,
  entityId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEntitySchemaApiV1AdminDataImportEntitiesModuleIdEntityIdSchemaGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetEntitySchemaApiV1AdminDataImportEntitiesModuleIdEntityIdSchemaGetQueryOptions(
      moduleId,
      entityId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Upload a file and run AI-powered data conversion for one or more entity types.
 * @summary Run Ai Import
 */
export const runAiImportApiV1AdminDataImportRunPost = (
  bodyRunAiImportApiV1AdminDataImportRunPost: BodyRunAiImportApiV1AdminDataImportRunPost,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  formData.append(
    `data_file`,
    bodyRunAiImportApiV1AdminDataImportRunPost.data_file
  );
  formData.append(
    `module_id`,
    bodyRunAiImportApiV1AdminDataImportRunPost.module_id
  );
  formData.append(
    `entity_ids`,
    bodyRunAiImportApiV1AdminDataImportRunPost.entity_ids
  );
  formData.append(
    `context_prompt`,
    bodyRunAiImportApiV1AdminDataImportRunPost.context_prompt
  );
  if (
    bodyRunAiImportApiV1AdminDataImportRunPost.enum_lookups !== undefined &&
    bodyRunAiImportApiV1AdminDataImportRunPost.enum_lookups !== null
  ) {
    formData.append(
      `enum_lookups`,
      bodyRunAiImportApiV1AdminDataImportRunPost.enum_lookups
    );
  }

  return customInstance<RunAiImportApiV1AdminDataImportRunPost200>({
    url: `/api/v1/admin/data-import/run`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
    signal
  });
};

export const getRunAiImportApiV1AdminDataImportRunPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof runAiImportApiV1AdminDataImportRunPost>>,
    TError,
    { data: BodyRunAiImportApiV1AdminDataImportRunPost },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof runAiImportApiV1AdminDataImportRunPost>>,
  TError,
  { data: BodyRunAiImportApiV1AdminDataImportRunPost },
  TContext
> => {
  const mutationKey = ['runAiImportApiV1AdminDataImportRunPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof runAiImportApiV1AdminDataImportRunPost>>,
    { data: BodyRunAiImportApiV1AdminDataImportRunPost }
  > = (props) => {
    const { data } = props ?? {};

    return runAiImportApiV1AdminDataImportRunPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RunAiImportApiV1AdminDataImportRunPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof runAiImportApiV1AdminDataImportRunPost>>
>;
export type RunAiImportApiV1AdminDataImportRunPostMutationBody =
  BodyRunAiImportApiV1AdminDataImportRunPost;
export type RunAiImportApiV1AdminDataImportRunPostMutationError =
  HTTPValidationError;

/**
 * @summary Run Ai Import
 */
export const useRunAiImportApiV1AdminDataImportRunPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof runAiImportApiV1AdminDataImportRunPost>>,
      TError,
      { data: BodyRunAiImportApiV1AdminDataImportRunPost },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof runAiImportApiV1AdminDataImportRunPost>>,
  TError,
  { data: BodyRunAiImportApiV1AdminDataImportRunPost },
  TContext
> => {
  const mutationOptions =
    getRunAiImportApiV1AdminDataImportRunPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Upload a file and run import using a saved adapter.
 * @summary Run Adapter Import
 */
export const runAdapterImportApiV1AdminDataImportRunAdapterAdapterIdPost = (
  adapterId: string,
  bodyRunAdapterImportApiV1AdminDataImportRunAdapterAdapterIdPost: BodyRunAdapterImportApiV1AdminDataImportRunAdapterAdapterIdPost,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  formData.append(
    `data_file`,
    bodyRunAdapterImportApiV1AdminDataImportRunAdapterAdapterIdPost.data_file
  );

  return customInstance<RunAdapterImportApiV1AdminDataImportRunAdapterAdapterIdPost200>(
    {
      url: `/api/v1/admin/data-import/run-adapter/${adapterId}`,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
      signal
    }
  );
};

export const getRunAdapterImportApiV1AdminDataImportRunAdapterAdapterIdPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof runAdapterImportApiV1AdminDataImportRunAdapterAdapterIdPost
        >
      >,
      TError,
      {
        adapterId: string;
        data: BodyRunAdapterImportApiV1AdminDataImportRunAdapterAdapterIdPost;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof runAdapterImportApiV1AdminDataImportRunAdapterAdapterIdPost
      >
    >,
    TError,
    {
      adapterId: string;
      data: BodyRunAdapterImportApiV1AdminDataImportRunAdapterAdapterIdPost;
    },
    TContext
  > => {
    const mutationKey = [
      'runAdapterImportApiV1AdminDataImportRunAdapterAdapterIdPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof runAdapterImportApiV1AdminDataImportRunAdapterAdapterIdPost
        >
      >,
      {
        adapterId: string;
        data: BodyRunAdapterImportApiV1AdminDataImportRunAdapterAdapterIdPost;
      }
    > = (props) => {
      const { adapterId, data } = props ?? {};

      return runAdapterImportApiV1AdminDataImportRunAdapterAdapterIdPost(
        adapterId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RunAdapterImportApiV1AdminDataImportRunAdapterAdapterIdPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof runAdapterImportApiV1AdminDataImportRunAdapterAdapterIdPost
      >
    >
  >;
export type RunAdapterImportApiV1AdminDataImportRunAdapterAdapterIdPostMutationBody =
  BodyRunAdapterImportApiV1AdminDataImportRunAdapterAdapterIdPost;
export type RunAdapterImportApiV1AdminDataImportRunAdapterAdapterIdPostMutationError =
  HTTPValidationError;

/**
 * @summary Run Adapter Import
 */
export const useRunAdapterImportApiV1AdminDataImportRunAdapterAdapterIdPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof runAdapterImportApiV1AdminDataImportRunAdapterAdapterIdPost
        >
      >,
      TError,
      {
        adapterId: string;
        data: BodyRunAdapterImportApiV1AdminDataImportRunAdapterAdapterIdPost;
      },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof runAdapterImportApiV1AdminDataImportRunAdapterAdapterIdPost
    >
  >,
  TError,
  {
    adapterId: string;
    data: BodyRunAdapterImportApiV1AdminDataImportRunAdapterAdapterIdPost;
  },
  TContext
> => {
  const mutationOptions =
    getRunAdapterImportApiV1AdminDataImportRunAdapterAdapterIdPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Confirm and insert converted data into the target table.

Confirm is the ONLY arm that writes rows — ``/run`` and ``/run-adapter`` stop
at a preview — so it is also the only one that needs an owner. Building the
service with the wizard's choice (rather than passing it down to
``confirm_import``) keeps the single attribution seam: the service resolves
the owner ONCE per run and every insert chunk grants against that answer.

``import_owner_id`` is validated HERE rather than left to the resolver's
eligibility check, because this is the half of the attribution contract where
the caller is PRESENT: a wizard operator who picks a user that is not an
active internal member of their tenant must be told so, not silently given the
stored policy's owner on a screen that said the records would go to the person
they chose. The resolver's own check still stands behind this and is what makes
a caller-less webhook degrade instead of raising
(:mod:`shared.permissions.import_attribution`).
 * @summary Confirm Import
 */
export const confirmImportApiV1AdminDataImportConfirmImportIdPost = (
  importId: string,
  confirmImportApiV1AdminDataImportConfirmImportIdPostBody: ConfirmImportApiV1AdminDataImportConfirmImportIdPostBody,
  params?: ConfirmImportApiV1AdminDataImportConfirmImportIdPostParams,
  signal?: AbortSignal
) => {
  return customInstance<ConfirmImportApiV1AdminDataImportConfirmImportIdPost200>(
    {
      url: `/api/v1/admin/data-import/confirm/${importId}`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: confirmImportApiV1AdminDataImportConfirmImportIdPostBody,
      params,
      signal
    }
  );
};

export const getConfirmImportApiV1AdminDataImportConfirmImportIdPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof confirmImportApiV1AdminDataImportConfirmImportIdPost>
      >,
      TError,
      {
        importId: string;
        data: ConfirmImportApiV1AdminDataImportConfirmImportIdPostBody;
        params?: ConfirmImportApiV1AdminDataImportConfirmImportIdPostParams;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof confirmImportApiV1AdminDataImportConfirmImportIdPost>
    >,
    TError,
    {
      importId: string;
      data: ConfirmImportApiV1AdminDataImportConfirmImportIdPostBody;
      params?: ConfirmImportApiV1AdminDataImportConfirmImportIdPostParams;
    },
    TContext
  > => {
    const mutationKey = [
      'confirmImportApiV1AdminDataImportConfirmImportIdPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof confirmImportApiV1AdminDataImportConfirmImportIdPost>
      >,
      {
        importId: string;
        data: ConfirmImportApiV1AdminDataImportConfirmImportIdPostBody;
        params?: ConfirmImportApiV1AdminDataImportConfirmImportIdPostParams;
      }
    > = (props) => {
      const { importId, data, params } = props ?? {};

      return confirmImportApiV1AdminDataImportConfirmImportIdPost(
        importId,
        data,
        params
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ConfirmImportApiV1AdminDataImportConfirmImportIdPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof confirmImportApiV1AdminDataImportConfirmImportIdPost>
    >
  >;
export type ConfirmImportApiV1AdminDataImportConfirmImportIdPostMutationBody =
  ConfirmImportApiV1AdminDataImportConfirmImportIdPostBody;
export type ConfirmImportApiV1AdminDataImportConfirmImportIdPostMutationError =
  HTTPValidationError;

/**
 * @summary Confirm Import
 */
export const useConfirmImportApiV1AdminDataImportConfirmImportIdPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof confirmImportApiV1AdminDataImportConfirmImportIdPost>
      >,
      TError,
      {
        importId: string;
        data: ConfirmImportApiV1AdminDataImportConfirmImportIdPostBody;
        params?: ConfirmImportApiV1AdminDataImportConfirmImportIdPostParams;
      },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof confirmImportApiV1AdminDataImportConfirmImportIdPost>
  >,
  TError,
  {
    importId: string;
    data: ConfirmImportApiV1AdminDataImportConfirmImportIdPostBody;
    params?: ConfirmImportApiV1AdminDataImportConfirmImportIdPostParams;
  },
  TContext
> => {
  const mutationOptions =
    getConfirmImportApiV1AdminDataImportConfirmImportIdPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Save a reusable adapter from an import.
 * @summary Save Adapter
 */
export const saveAdapterApiV1AdminDataImportAdaptersPost = (
  saveAdapterRequest: SaveAdapterRequest,
  signal?: AbortSignal
) => {
  return customInstance<SaveAdapterApiV1AdminDataImportAdaptersPost200>({
    url: `/api/v1/admin/data-import/adapters`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: saveAdapterRequest,
    signal
  });
};

export const getSaveAdapterApiV1AdminDataImportAdaptersPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveAdapterApiV1AdminDataImportAdaptersPost>>,
    TError,
    { data: SaveAdapterRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveAdapterApiV1AdminDataImportAdaptersPost>>,
  TError,
  { data: SaveAdapterRequest },
  TContext
> => {
  const mutationKey = ['saveAdapterApiV1AdminDataImportAdaptersPost'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveAdapterApiV1AdminDataImportAdaptersPost>>,
    { data: SaveAdapterRequest }
  > = (props) => {
    const { data } = props ?? {};

    return saveAdapterApiV1AdminDataImportAdaptersPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveAdapterApiV1AdminDataImportAdaptersPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof saveAdapterApiV1AdminDataImportAdaptersPost>>
  >;
export type SaveAdapterApiV1AdminDataImportAdaptersPostMutationBody =
  SaveAdapterRequest;
export type SaveAdapterApiV1AdminDataImportAdaptersPostMutationError =
  HTTPValidationError;

/**
 * @summary Save Adapter
 */
export const useSaveAdapterApiV1AdminDataImportAdaptersPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof saveAdapterApiV1AdminDataImportAdaptersPost>>,
      TError,
      { data: SaveAdapterRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof saveAdapterApiV1AdminDataImportAdaptersPost>>,
  TError,
  { data: SaveAdapterRequest },
  TContext
> => {
  const mutationOptions =
    getSaveAdapterApiV1AdminDataImportAdaptersPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * List saved data import adapters with their version counts.
 * @summary List Adapters
 */
export const listAdaptersApiV1AdminDataImportAdaptersGet = (
  params?: ListAdaptersApiV1AdminDataImportAdaptersGetParams,
  signal?: AbortSignal
) => {
  return customInstance<ListAdaptersApiV1AdminDataImportAdaptersGet200>({
    url: `/api/v1/admin/data-import/adapters`,
    method: 'GET',
    params,
    signal
  });
};

export const getListAdaptersApiV1AdminDataImportAdaptersGetQueryKey = (
  params?: ListAdaptersApiV1AdminDataImportAdaptersGetParams
) => {
  return [
    `/api/v1/admin/data-import/adapters`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListAdaptersApiV1AdminDataImportAdaptersGetQueryOptions = <
  TData = Awaited<
    ReturnType<typeof listAdaptersApiV1AdminDataImportAdaptersGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListAdaptersApiV1AdminDataImportAdaptersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAdaptersApiV1AdminDataImportAdaptersGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListAdaptersApiV1AdminDataImportAdaptersGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAdaptersApiV1AdminDataImportAdaptersGet>>
  > = ({ signal }) =>
    listAdaptersApiV1AdminDataImportAdaptersGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAdaptersApiV1AdminDataImportAdaptersGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListAdaptersApiV1AdminDataImportAdaptersGetQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof listAdaptersApiV1AdminDataImportAdaptersGet>>
  >;
export type ListAdaptersApiV1AdminDataImportAdaptersGetQueryError =
  HTTPValidationError;

export function useListAdaptersApiV1AdminDataImportAdaptersGet<
  TData = Awaited<
    ReturnType<typeof listAdaptersApiV1AdminDataImportAdaptersGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListAdaptersApiV1AdminDataImportAdaptersGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAdaptersApiV1AdminDataImportAdaptersGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listAdaptersApiV1AdminDataImportAdaptersGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listAdaptersApiV1AdminDataImportAdaptersGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListAdaptersApiV1AdminDataImportAdaptersGet<
  TData = Awaited<
    ReturnType<typeof listAdaptersApiV1AdminDataImportAdaptersGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListAdaptersApiV1AdminDataImportAdaptersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAdaptersApiV1AdminDataImportAdaptersGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listAdaptersApiV1AdminDataImportAdaptersGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listAdaptersApiV1AdminDataImportAdaptersGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListAdaptersApiV1AdminDataImportAdaptersGet<
  TData = Awaited<
    ReturnType<typeof listAdaptersApiV1AdminDataImportAdaptersGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListAdaptersApiV1AdminDataImportAdaptersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAdaptersApiV1AdminDataImportAdaptersGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Adapters
 */

export function useListAdaptersApiV1AdminDataImportAdaptersGet<
  TData = Awaited<
    ReturnType<typeof listAdaptersApiV1AdminDataImportAdaptersGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListAdaptersApiV1AdminDataImportAdaptersGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listAdaptersApiV1AdminDataImportAdaptersGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListAdaptersApiV1AdminDataImportAdaptersGetQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get adapter details including conversion script.
 * @summary Get Adapter
 */
export const getAdapterApiV1AdminDataImportAdaptersAdapterIdGet = (
  adapterId: string,
  signal?: AbortSignal
) => {
  return customInstance<GetAdapterApiV1AdminDataImportAdaptersAdapterIdGet200>({
    url: `/api/v1/admin/data-import/adapters/${adapterId}`,
    method: 'GET',
    signal
  });
};

export const getGetAdapterApiV1AdminDataImportAdaptersAdapterIdGetQueryKey = (
  adapterId?: string
) => {
  return [`/api/v1/admin/data-import/adapters/${adapterId}`] as const;
};

export const getGetAdapterApiV1AdminDataImportAdaptersAdapterIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getAdapterApiV1AdminDataImportAdaptersAdapterIdGet>
    >,
    TError = HTTPValidationError
  >(
    adapterId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getAdapterApiV1AdminDataImportAdaptersAdapterIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetAdapterApiV1AdminDataImportAdaptersAdapterIdGetQueryKey(adapterId);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getAdapterApiV1AdminDataImportAdaptersAdapterIdGet>
      >
    > = ({ signal }) =>
      getAdapterApiV1AdminDataImportAdaptersAdapterIdGet(adapterId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!adapterId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getAdapterApiV1AdminDataImportAdaptersAdapterIdGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetAdapterApiV1AdminDataImportAdaptersAdapterIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getAdapterApiV1AdminDataImportAdaptersAdapterIdGet>
    >
  >;
export type GetAdapterApiV1AdminDataImportAdaptersAdapterIdGetQueryError =
  HTTPValidationError;

export function useGetAdapterApiV1AdminDataImportAdaptersAdapterIdGet<
  TData = Awaited<
    ReturnType<typeof getAdapterApiV1AdminDataImportAdaptersAdapterIdGet>
  >,
  TError = HTTPValidationError
>(
  adapterId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getAdapterApiV1AdminDataImportAdaptersAdapterIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getAdapterApiV1AdminDataImportAdaptersAdapterIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getAdapterApiV1AdminDataImportAdaptersAdapterIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAdapterApiV1AdminDataImportAdaptersAdapterIdGet<
  TData = Awaited<
    ReturnType<typeof getAdapterApiV1AdminDataImportAdaptersAdapterIdGet>
  >,
  TError = HTTPValidationError
>(
  adapterId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getAdapterApiV1AdminDataImportAdaptersAdapterIdGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getAdapterApiV1AdminDataImportAdaptersAdapterIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getAdapterApiV1AdminDataImportAdaptersAdapterIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAdapterApiV1AdminDataImportAdaptersAdapterIdGet<
  TData = Awaited<
    ReturnType<typeof getAdapterApiV1AdminDataImportAdaptersAdapterIdGet>
  >,
  TError = HTTPValidationError
>(
  adapterId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getAdapterApiV1AdminDataImportAdaptersAdapterIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Adapter
 */

export function useGetAdapterApiV1AdminDataImportAdaptersAdapterIdGet<
  TData = Awaited<
    ReturnType<typeof getAdapterApiV1AdminDataImportAdaptersAdapterIdGet>
  >,
  TError = HTTPValidationError
>(
  adapterId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getAdapterApiV1AdminDataImportAdaptersAdapterIdGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetAdapterApiV1AdminDataImportAdaptersAdapterIdGetQueryOptions(
      adapterId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update adapter metadata.
 * @summary Update Adapter
 */
export const updateAdapterApiV1AdminDataImportAdaptersAdapterIdPut = (
  adapterId: string,
  updateAdapterRequest: UpdateAdapterRequest
) => {
  return customInstance<UpdateAdapterApiV1AdminDataImportAdaptersAdapterIdPut200>(
    {
      url: `/api/v1/admin/data-import/adapters/${adapterId}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateAdapterRequest
    }
  );
};

export const getUpdateAdapterApiV1AdminDataImportAdaptersAdapterIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateAdapterApiV1AdminDataImportAdaptersAdapterIdPut>
      >,
      TError,
      { adapterId: string; data: UpdateAdapterRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof updateAdapterApiV1AdminDataImportAdaptersAdapterIdPut>
    >,
    TError,
    { adapterId: string; data: UpdateAdapterRequest },
    TContext
  > => {
    const mutationKey = [
      'updateAdapterApiV1AdminDataImportAdaptersAdapterIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof updateAdapterApiV1AdminDataImportAdaptersAdapterIdPut>
      >,
      { adapterId: string; data: UpdateAdapterRequest }
    > = (props) => {
      const { adapterId, data } = props ?? {};

      return updateAdapterApiV1AdminDataImportAdaptersAdapterIdPut(
        adapterId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateAdapterApiV1AdminDataImportAdaptersAdapterIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof updateAdapterApiV1AdminDataImportAdaptersAdapterIdPut>
    >
  >;
export type UpdateAdapterApiV1AdminDataImportAdaptersAdapterIdPutMutationBody =
  UpdateAdapterRequest;
export type UpdateAdapterApiV1AdminDataImportAdaptersAdapterIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Adapter
 */
export const useUpdateAdapterApiV1AdminDataImportAdaptersAdapterIdPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof updateAdapterApiV1AdminDataImportAdaptersAdapterIdPut>
      >,
      TError,
      { adapterId: string; data: UpdateAdapterRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateAdapterApiV1AdminDataImportAdaptersAdapterIdPut>
  >,
  TError,
  { adapterId: string; data: UpdateAdapterRequest },
  TContext
> => {
  const mutationOptions =
    getUpdateAdapterApiV1AdminDataImportAdaptersAdapterIdPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Soft-delete an adapter.
 * @summary Delete Adapter
 */
export const deleteAdapterApiV1AdminDataImportAdaptersAdapterIdDelete = (
  adapterId: string
) => {
  return customInstance<DeleteAdapterApiV1AdminDataImportAdaptersAdapterIdDelete200>(
    { url: `/api/v1/admin/data-import/adapters/${adapterId}`, method: 'DELETE' }
  );
};

export const getDeleteAdapterApiV1AdminDataImportAdaptersAdapterIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteAdapterApiV1AdminDataImportAdaptersAdapterIdDelete
        >
      >,
      TError,
      { adapterId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteAdapterApiV1AdminDataImportAdaptersAdapterIdDelete
      >
    >,
    TError,
    { adapterId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteAdapterApiV1AdminDataImportAdaptersAdapterIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteAdapterApiV1AdminDataImportAdaptersAdapterIdDelete
        >
      >,
      { adapterId: string }
    > = (props) => {
      const { adapterId } = props ?? {};

      return deleteAdapterApiV1AdminDataImportAdaptersAdapterIdDelete(
        adapterId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteAdapterApiV1AdminDataImportAdaptersAdapterIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteAdapterApiV1AdminDataImportAdaptersAdapterIdDelete
      >
    >
  >;

export type DeleteAdapterApiV1AdminDataImportAdaptersAdapterIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Adapter
 */
export const useDeleteAdapterApiV1AdminDataImportAdaptersAdapterIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteAdapterApiV1AdminDataImportAdaptersAdapterIdDelete
        >
      >,
      TError,
      { adapterId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof deleteAdapterApiV1AdminDataImportAdaptersAdapterIdDelete>
  >,
  TError,
  { adapterId: string },
  TContext
> => {
  const mutationOptions =
    getDeleteAdapterApiV1AdminDataImportAdaptersAdapterIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * List data import history. Archived rows are hidden by default.
 * @summary List History
 */
export const listHistoryApiV1AdminDataImportHistoryGet = (
  params?: ListHistoryApiV1AdminDataImportHistoryGetParams,
  signal?: AbortSignal
) => {
  return customInstance<ListHistoryApiV1AdminDataImportHistoryGet200>({
    url: `/api/v1/admin/data-import/history`,
    method: 'GET',
    params,
    signal
  });
};

export const getListHistoryApiV1AdminDataImportHistoryGetQueryKey = (
  params?: ListHistoryApiV1AdminDataImportHistoryGetParams
) => {
  return [
    `/api/v1/admin/data-import/history`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListHistoryApiV1AdminDataImportHistoryGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listHistoryApiV1AdminDataImportHistoryGet>>,
  TError = HTTPValidationError
>(
  params?: ListHistoryApiV1AdminDataImportHistoryGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listHistoryApiV1AdminDataImportHistoryGet>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListHistoryApiV1AdminDataImportHistoryGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listHistoryApiV1AdminDataImportHistoryGet>>
  > = ({ signal }) => listHistoryApiV1AdminDataImportHistoryGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listHistoryApiV1AdminDataImportHistoryGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListHistoryApiV1AdminDataImportHistoryGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listHistoryApiV1AdminDataImportHistoryGet>>
>;
export type ListHistoryApiV1AdminDataImportHistoryGetQueryError =
  HTTPValidationError;

export function useListHistoryApiV1AdminDataImportHistoryGet<
  TData = Awaited<ReturnType<typeof listHistoryApiV1AdminDataImportHistoryGet>>,
  TError = HTTPValidationError
>(
  params: undefined | ListHistoryApiV1AdminDataImportHistoryGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listHistoryApiV1AdminDataImportHistoryGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listHistoryApiV1AdminDataImportHistoryGet>>,
          TError,
          Awaited<ReturnType<typeof listHistoryApiV1AdminDataImportHistoryGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListHistoryApiV1AdminDataImportHistoryGet<
  TData = Awaited<ReturnType<typeof listHistoryApiV1AdminDataImportHistoryGet>>,
  TError = HTTPValidationError
>(
  params?: ListHistoryApiV1AdminDataImportHistoryGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listHistoryApiV1AdminDataImportHistoryGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listHistoryApiV1AdminDataImportHistoryGet>>,
          TError,
          Awaited<ReturnType<typeof listHistoryApiV1AdminDataImportHistoryGet>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListHistoryApiV1AdminDataImportHistoryGet<
  TData = Awaited<ReturnType<typeof listHistoryApiV1AdminDataImportHistoryGet>>,
  TError = HTTPValidationError
>(
  params?: ListHistoryApiV1AdminDataImportHistoryGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listHistoryApiV1AdminDataImportHistoryGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List History
 */

export function useListHistoryApiV1AdminDataImportHistoryGet<
  TData = Awaited<ReturnType<typeof listHistoryApiV1AdminDataImportHistoryGet>>,
  TError = HTTPValidationError
>(
  params?: ListHistoryApiV1AdminDataImportHistoryGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listHistoryApiV1AdminDataImportHistoryGet>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListHistoryApiV1AdminDataImportHistoryGetQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get detailed import history including validation report.
 * @summary Get History Detail
 */
export const getHistoryDetailApiV1AdminDataImportHistoryImportIdGet = (
  importId: string,
  signal?: AbortSignal
) => {
  return customInstance<GetHistoryDetailApiV1AdminDataImportHistoryImportIdGet200>(
    {
      url: `/api/v1/admin/data-import/history/${importId}`,
      method: 'GET',
      signal
    }
  );
};

export const getGetHistoryDetailApiV1AdminDataImportHistoryImportIdGetQueryKey =
  (importId?: string) => {
    return [`/api/v1/admin/data-import/history/${importId}`] as const;
  };

export const getGetHistoryDetailApiV1AdminDataImportHistoryImportIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getHistoryDetailApiV1AdminDataImportHistoryImportIdGet>
    >,
    TError = HTTPValidationError
  >(
    importId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getHistoryDetailApiV1AdminDataImportHistoryImportIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetHistoryDetailApiV1AdminDataImportHistoryImportIdGetQueryKey(
        importId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getHistoryDetailApiV1AdminDataImportHistoryImportIdGet
        >
      >
    > = ({ signal }) =>
      getHistoryDetailApiV1AdminDataImportHistoryImportIdGet(importId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!importId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getHistoryDetailApiV1AdminDataImportHistoryImportIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetHistoryDetailApiV1AdminDataImportHistoryImportIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getHistoryDetailApiV1AdminDataImportHistoryImportIdGet>
    >
  >;
export type GetHistoryDetailApiV1AdminDataImportHistoryImportIdGetQueryError =
  HTTPValidationError;

export function useGetHistoryDetailApiV1AdminDataImportHistoryImportIdGet<
  TData = Awaited<
    ReturnType<typeof getHistoryDetailApiV1AdminDataImportHistoryImportIdGet>
  >,
  TError = HTTPValidationError
>(
  importId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getHistoryDetailApiV1AdminDataImportHistoryImportIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getHistoryDetailApiV1AdminDataImportHistoryImportIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getHistoryDetailApiV1AdminDataImportHistoryImportIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetHistoryDetailApiV1AdminDataImportHistoryImportIdGet<
  TData = Awaited<
    ReturnType<typeof getHistoryDetailApiV1AdminDataImportHistoryImportIdGet>
  >,
  TError = HTTPValidationError
>(
  importId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getHistoryDetailApiV1AdminDataImportHistoryImportIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getHistoryDetailApiV1AdminDataImportHistoryImportIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getHistoryDetailApiV1AdminDataImportHistoryImportIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetHistoryDetailApiV1AdminDataImportHistoryImportIdGet<
  TData = Awaited<
    ReturnType<typeof getHistoryDetailApiV1AdminDataImportHistoryImportIdGet>
  >,
  TError = HTTPValidationError
>(
  importId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getHistoryDetailApiV1AdminDataImportHistoryImportIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get History Detail
 */

export function useGetHistoryDetailApiV1AdminDataImportHistoryImportIdGet<
  TData = Awaited<
    ReturnType<typeof getHistoryDetailApiV1AdminDataImportHistoryImportIdGet>
  >,
  TError = HTTPValidationError
>(
  importId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getHistoryDetailApiV1AdminDataImportHistoryImportIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetHistoryDetailApiV1AdminDataImportHistoryImportIdGetQueryOptions(
      importId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Archive an import row so it disappears from the default list.
 * @summary Archive History
 */
export const archiveHistoryApiV1AdminDataImportHistoryImportIdArchivePost = (
  importId: string,
  signal?: AbortSignal
) => {
  return customInstance<ArchiveHistoryApiV1AdminDataImportHistoryImportIdArchivePost200>(
    {
      url: `/api/v1/admin/data-import/history/${importId}/archive`,
      method: 'POST',
      signal
    }
  );
};

export const getArchiveHistoryApiV1AdminDataImportHistoryImportIdArchivePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof archiveHistoryApiV1AdminDataImportHistoryImportIdArchivePost
        >
      >,
      TError,
      { importId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof archiveHistoryApiV1AdminDataImportHistoryImportIdArchivePost
      >
    >,
    TError,
    { importId: string },
    TContext
  > => {
    const mutationKey = [
      'archiveHistoryApiV1AdminDataImportHistoryImportIdArchivePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof archiveHistoryApiV1AdminDataImportHistoryImportIdArchivePost
        >
      >,
      { importId: string }
    > = (props) => {
      const { importId } = props ?? {};

      return archiveHistoryApiV1AdminDataImportHistoryImportIdArchivePost(
        importId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ArchiveHistoryApiV1AdminDataImportHistoryImportIdArchivePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof archiveHistoryApiV1AdminDataImportHistoryImportIdArchivePost
      >
    >
  >;

export type ArchiveHistoryApiV1AdminDataImportHistoryImportIdArchivePostMutationError =
  HTTPValidationError;

/**
 * @summary Archive History
 */
export const useArchiveHistoryApiV1AdminDataImportHistoryImportIdArchivePost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof archiveHistoryApiV1AdminDataImportHistoryImportIdArchivePost
        >
      >,
      TError,
      { importId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof archiveHistoryApiV1AdminDataImportHistoryImportIdArchivePost
    >
  >,
  TError,
  { importId: string },
  TContext
> => {
  const mutationOptions =
    getArchiveHistoryApiV1AdminDataImportHistoryImportIdArchivePostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Restore an archived import row to the default list.
 * @summary Unarchive History
 */
export const unarchiveHistoryApiV1AdminDataImportHistoryImportIdUnarchivePost =
  (importId: string, signal?: AbortSignal) => {
    return customInstance<UnarchiveHistoryApiV1AdminDataImportHistoryImportIdUnarchivePost200>(
      {
        url: `/api/v1/admin/data-import/history/${importId}/unarchive`,
        method: 'POST',
        signal
      }
    );
  };

export const getUnarchiveHistoryApiV1AdminDataImportHistoryImportIdUnarchivePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof unarchiveHistoryApiV1AdminDataImportHistoryImportIdUnarchivePost
        >
      >,
      TError,
      { importId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof unarchiveHistoryApiV1AdminDataImportHistoryImportIdUnarchivePost
      >
    >,
    TError,
    { importId: string },
    TContext
  > => {
    const mutationKey = [
      'unarchiveHistoryApiV1AdminDataImportHistoryImportIdUnarchivePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof unarchiveHistoryApiV1AdminDataImportHistoryImportIdUnarchivePost
        >
      >,
      { importId: string }
    > = (props) => {
      const { importId } = props ?? {};

      return unarchiveHistoryApiV1AdminDataImportHistoryImportIdUnarchivePost(
        importId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UnarchiveHistoryApiV1AdminDataImportHistoryImportIdUnarchivePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof unarchiveHistoryApiV1AdminDataImportHistoryImportIdUnarchivePost
      >
    >
  >;

export type UnarchiveHistoryApiV1AdminDataImportHistoryImportIdUnarchivePostMutationError =
  HTTPValidationError;

/**
 * @summary Unarchive History
 */
export const useUnarchiveHistoryApiV1AdminDataImportHistoryImportIdUnarchivePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof unarchiveHistoryApiV1AdminDataImportHistoryImportIdUnarchivePost
          >
        >,
        TError,
        { importId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof unarchiveHistoryApiV1AdminDataImportHistoryImportIdUnarchivePost
      >
    >,
    TError,
    { importId: string },
    TContext
  > => {
    const mutationOptions =
      getUnarchiveHistoryApiV1AdminDataImportHistoryImportIdUnarchivePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Download the original source file for an import job.
 * @summary Download Source File
 */
export const downloadSourceFileApiV1AdminDataImportHistoryImportIdDownloadGet =
  (importId: string, signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/admin/data-import/history/${importId}/download`,
      method: 'GET',
      signal
    });
  };

export const getDownloadSourceFileApiV1AdminDataImportHistoryImportIdDownloadGetQueryKey =
  (importId?: string) => {
    return [`/api/v1/admin/data-import/history/${importId}/download`] as const;
  };

export const getDownloadSourceFileApiV1AdminDataImportHistoryImportIdDownloadGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof downloadSourceFileApiV1AdminDataImportHistoryImportIdDownloadGet
      >
    >,
    TError = HTTPValidationError
  >(
    importId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof downloadSourceFileApiV1AdminDataImportHistoryImportIdDownloadGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getDownloadSourceFileApiV1AdminDataImportHistoryImportIdDownloadGetQueryKey(
        importId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof downloadSourceFileApiV1AdminDataImportHistoryImportIdDownloadGet
        >
      >
    > = ({ signal }) =>
      downloadSourceFileApiV1AdminDataImportHistoryImportIdDownloadGet(
        importId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!importId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof downloadSourceFileApiV1AdminDataImportHistoryImportIdDownloadGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type DownloadSourceFileApiV1AdminDataImportHistoryImportIdDownloadGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof downloadSourceFileApiV1AdminDataImportHistoryImportIdDownloadGet
      >
    >
  >;
export type DownloadSourceFileApiV1AdminDataImportHistoryImportIdDownloadGetQueryError =
  HTTPValidationError;

export function useDownloadSourceFileApiV1AdminDataImportHistoryImportIdDownloadGet<
  TData = Awaited<
    ReturnType<
      typeof downloadSourceFileApiV1AdminDataImportHistoryImportIdDownloadGet
    >
  >,
  TError = HTTPValidationError
>(
  importId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof downloadSourceFileApiV1AdminDataImportHistoryImportIdDownloadGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof downloadSourceFileApiV1AdminDataImportHistoryImportIdDownloadGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof downloadSourceFileApiV1AdminDataImportHistoryImportIdDownloadGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useDownloadSourceFileApiV1AdminDataImportHistoryImportIdDownloadGet<
  TData = Awaited<
    ReturnType<
      typeof downloadSourceFileApiV1AdminDataImportHistoryImportIdDownloadGet
    >
  >,
  TError = HTTPValidationError
>(
  importId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof downloadSourceFileApiV1AdminDataImportHistoryImportIdDownloadGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof downloadSourceFileApiV1AdminDataImportHistoryImportIdDownloadGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof downloadSourceFileApiV1AdminDataImportHistoryImportIdDownloadGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useDownloadSourceFileApiV1AdminDataImportHistoryImportIdDownloadGet<
  TData = Awaited<
    ReturnType<
      typeof downloadSourceFileApiV1AdminDataImportHistoryImportIdDownloadGet
    >
  >,
  TError = HTTPValidationError
>(
  importId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof downloadSourceFileApiV1AdminDataImportHistoryImportIdDownloadGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Download Source File
 */

export function useDownloadSourceFileApiV1AdminDataImportHistoryImportIdDownloadGet<
  TData = Awaited<
    ReturnType<
      typeof downloadSourceFileApiV1AdminDataImportHistoryImportIdDownloadGet
    >
  >,
  TError = HTTPValidationError
>(
  importId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof downloadSourceFileApiV1AdminDataImportHistoryImportIdDownloadGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getDownloadSourceFileApiV1AdminDataImportHistoryImportIdDownloadGetQueryOptions(
      importId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Step 1: create a ``status='draft'`` record the moment a file is uploaded.

The wizard URL becomes ``/wizard/{id}/source`` from here on — steps 2 and 3
PATCH this record, and "Start Profiling" transitions it via ``/begin``.
 * @summary Create Draft Import
 */
export const createDraftImportApiV1AdminDataImportImportsDraftPost = (
  bodyCreateDraftImportApiV1AdminDataImportImportsDraftPost: BodyCreateDraftImportApiV1AdminDataImportImportsDraftPost,
  signal?: AbortSignal
) => {
  const formData = new FormData();
  formData.append(
    `data_file`,
    bodyCreateDraftImportApiV1AdminDataImportImportsDraftPost.data_file
  );

  return customInstance<CreateDraftImportApiV1AdminDataImportImportsDraftPost200>(
    {
      url: `/api/v1/admin/data-import/imports/draft`,
      method: 'POST',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
      signal
    }
  );
};

export const getCreateDraftImportApiV1AdminDataImportImportsDraftPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createDraftImportApiV1AdminDataImportImportsDraftPost>
      >,
      TError,
      { data: BodyCreateDraftImportApiV1AdminDataImportImportsDraftPost },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createDraftImportApiV1AdminDataImportImportsDraftPost>
    >,
    TError,
    { data: BodyCreateDraftImportApiV1AdminDataImportImportsDraftPost },
    TContext
  > => {
    const mutationKey = [
      'createDraftImportApiV1AdminDataImportImportsDraftPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createDraftImportApiV1AdminDataImportImportsDraftPost>
      >,
      { data: BodyCreateDraftImportApiV1AdminDataImportImportsDraftPost }
    > = (props) => {
      const { data } = props ?? {};

      return createDraftImportApiV1AdminDataImportImportsDraftPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateDraftImportApiV1AdminDataImportImportsDraftPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof createDraftImportApiV1AdminDataImportImportsDraftPost>
    >
  >;
export type CreateDraftImportApiV1AdminDataImportImportsDraftPostMutationBody =
  BodyCreateDraftImportApiV1AdminDataImportImportsDraftPost;
export type CreateDraftImportApiV1AdminDataImportImportsDraftPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Draft Import
 */
export const useCreateDraftImportApiV1AdminDataImportImportsDraftPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createDraftImportApiV1AdminDataImportImportsDraftPost>
      >,
      TError,
      { data: BodyCreateDraftImportApiV1AdminDataImportImportsDraftPost },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof createDraftImportApiV1AdminDataImportImportsDraftPost>
  >,
  TError,
  { data: BodyCreateDraftImportApiV1AdminDataImportImportsDraftPost },
  TContext
> => {
  const mutationOptions =
    getCreateDraftImportApiV1AdminDataImportImportsDraftPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Step 2/3: patch a draft's target module/entity and context prompt.
 * @summary Update Draft Import
 */
export const updateDraftImportApiV1AdminDataImportImportsImportIdDraftPatch = (
  importId: string,
  draftPatchRequest: DraftPatchRequest
) => {
  return customInstance<UpdateDraftImportApiV1AdminDataImportImportsImportIdDraftPatch200>(
    {
      url: `/api/v1/admin/data-import/imports/${importId}/draft`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: draftPatchRequest
    }
  );
};

export const getUpdateDraftImportApiV1AdminDataImportImportsImportIdDraftPatchMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateDraftImportApiV1AdminDataImportImportsImportIdDraftPatch
        >
      >,
      TError,
      { importId: string; data: DraftPatchRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateDraftImportApiV1AdminDataImportImportsImportIdDraftPatch
      >
    >,
    TError,
    { importId: string; data: DraftPatchRequest },
    TContext
  > => {
    const mutationKey = [
      'updateDraftImportApiV1AdminDataImportImportsImportIdDraftPatch'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateDraftImportApiV1AdminDataImportImportsImportIdDraftPatch
        >
      >,
      { importId: string; data: DraftPatchRequest }
    > = (props) => {
      const { importId, data } = props ?? {};

      return updateDraftImportApiV1AdminDataImportImportsImportIdDraftPatch(
        importId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateDraftImportApiV1AdminDataImportImportsImportIdDraftPatchMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateDraftImportApiV1AdminDataImportImportsImportIdDraftPatch
      >
    >
  >;
export type UpdateDraftImportApiV1AdminDataImportImportsImportIdDraftPatchMutationBody =
  DraftPatchRequest;
export type UpdateDraftImportApiV1AdminDataImportImportsImportIdDraftPatchMutationError =
  HTTPValidationError;

/**
 * @summary Update Draft Import
 */
export const useUpdateDraftImportApiV1AdminDataImportImportsImportIdDraftPatch =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateDraftImportApiV1AdminDataImportImportsImportIdDraftPatch
          >
        >,
        TError,
        { importId: string; data: DraftPatchRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateDraftImportApiV1AdminDataImportImportsImportIdDraftPatch
      >
    >,
    TError,
    { importId: string; data: DraftPatchRequest },
    TContext
  > => {
    const mutationOptions =
      getUpdateDraftImportApiV1AdminDataImportImportsImportIdDraftPatchMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Step 3 → profiling: transition the draft to ``ingesting`` and run A→B→C.
 * @summary Begin Draft Design
 */
export const beginDraftDesignApiV1AdminDataImportImportsImportIdBeginPost = (
  importId: string,
  beginDraftDesignApiV1AdminDataImportImportsImportIdBeginPostBody: BeginDraftDesignApiV1AdminDataImportImportsImportIdBeginPostBody,
  signal?: AbortSignal
) => {
  return customInstance<BeginDraftDesignApiV1AdminDataImportImportsImportIdBeginPost200>(
    {
      url: `/api/v1/admin/data-import/imports/${importId}/begin`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: beginDraftDesignApiV1AdminDataImportImportsImportIdBeginPostBody,
      signal
    }
  );
};

export const getBeginDraftDesignApiV1AdminDataImportImportsImportIdBeginPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof beginDraftDesignApiV1AdminDataImportImportsImportIdBeginPost
        >
      >,
      TError,
      {
        importId: string;
        data: BeginDraftDesignApiV1AdminDataImportImportsImportIdBeginPostBody;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof beginDraftDesignApiV1AdminDataImportImportsImportIdBeginPost
      >
    >,
    TError,
    {
      importId: string;
      data: BeginDraftDesignApiV1AdminDataImportImportsImportIdBeginPostBody;
    },
    TContext
  > => {
    const mutationKey = [
      'beginDraftDesignApiV1AdminDataImportImportsImportIdBeginPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof beginDraftDesignApiV1AdminDataImportImportsImportIdBeginPost
        >
      >,
      {
        importId: string;
        data: BeginDraftDesignApiV1AdminDataImportImportsImportIdBeginPostBody;
      }
    > = (props) => {
      const { importId, data } = props ?? {};

      return beginDraftDesignApiV1AdminDataImportImportsImportIdBeginPost(
        importId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type BeginDraftDesignApiV1AdminDataImportImportsImportIdBeginPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof beginDraftDesignApiV1AdminDataImportImportsImportIdBeginPost
      >
    >
  >;
export type BeginDraftDesignApiV1AdminDataImportImportsImportIdBeginPostMutationBody =
  BeginDraftDesignApiV1AdminDataImportImportsImportIdBeginPostBody;
export type BeginDraftDesignApiV1AdminDataImportImportsImportIdBeginPostMutationError =
  HTTPValidationError;

/**
 * @summary Begin Draft Design
 */
export const useBeginDraftDesignApiV1AdminDataImportImportsImportIdBeginPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof beginDraftDesignApiV1AdminDataImportImportsImportIdBeginPost
        >
      >,
      TError,
      {
        importId: string;
        data: BeginDraftDesignApiV1AdminDataImportImportsImportIdBeginPostBody;
      },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof beginDraftDesignApiV1AdminDataImportImportsImportIdBeginPost
    >
  >,
  TError,
  {
    importId: string;
    data: BeginDraftDesignApiV1AdminDataImportImportsImportIdBeginPostBody;
  },
  TContext
> => {
  const mutationOptions =
    getBeginDraftDesignApiV1AdminDataImportImportsImportIdBeginPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Discard an in-progress import: soft-archive + delete on-disk artefacts.

Only the owning user (or a sysadmin) may discard. Returns 204 No Content.
 * @summary Discard Import
 */
export const discardImportApiV1AdminDataImportImportsImportIdDelete = (
  importId: string
) => {
  return customInstance<void>({
    url: `/api/v1/admin/data-import/imports/${importId}`,
    method: 'DELETE'
  });
};

export const getDiscardImportApiV1AdminDataImportImportsImportIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof discardImportApiV1AdminDataImportImportsImportIdDelete
        >
      >,
      TError,
      { importId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof discardImportApiV1AdminDataImportImportsImportIdDelete>
    >,
    TError,
    { importId: string },
    TContext
  > => {
    const mutationKey = [
      'discardImportApiV1AdminDataImportImportsImportIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof discardImportApiV1AdminDataImportImportsImportIdDelete
        >
      >,
      { importId: string }
    > = (props) => {
      const { importId } = props ?? {};

      return discardImportApiV1AdminDataImportImportsImportIdDelete(importId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type DiscardImportApiV1AdminDataImportImportsImportIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof discardImportApiV1AdminDataImportImportsImportIdDelete>
    >
  >;

export type DiscardImportApiV1AdminDataImportImportsImportIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Discard Import
 */
export const useDiscardImportApiV1AdminDataImportImportsImportIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof discardImportApiV1AdminDataImportImportsImportIdDelete
        >
      >,
      TError,
      { importId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof discardImportApiV1AdminDataImportImportsImportIdDelete>
  >,
  TError,
  { importId: string },
  TContext
> => {
  const mutationOptions =
    getDiscardImportApiV1AdminDataImportImportsImportIdDeleteMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Bundle the on-disk artefacts + DB row for the wizard.
 * @summary Get Design Session
 */
export const getDesignSessionApiV1AdminDataImportDesignImportIdGet = (
  importId: string,
  signal?: AbortSignal
) => {
  return customInstance<GetDesignSessionApiV1AdminDataImportDesignImportIdGet200>(
    {
      url: `/api/v1/admin/data-import/design/${importId}`,
      method: 'GET',
      signal
    }
  );
};

export const getGetDesignSessionApiV1AdminDataImportDesignImportIdGetQueryKey =
  (importId?: string) => {
    return [`/api/v1/admin/data-import/design/${importId}`] as const;
  };

export const getGetDesignSessionApiV1AdminDataImportDesignImportIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getDesignSessionApiV1AdminDataImportDesignImportIdGet>
    >,
    TError = HTTPValidationError
  >(
    importId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getDesignSessionApiV1AdminDataImportDesignImportIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetDesignSessionApiV1AdminDataImportDesignImportIdGetQueryKey(
        importId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getDesignSessionApiV1AdminDataImportDesignImportIdGet>
      >
    > = ({ signal }) =>
      getDesignSessionApiV1AdminDataImportDesignImportIdGet(importId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!importId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getDesignSessionApiV1AdminDataImportDesignImportIdGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetDesignSessionApiV1AdminDataImportDesignImportIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getDesignSessionApiV1AdminDataImportDesignImportIdGet>
    >
  >;
export type GetDesignSessionApiV1AdminDataImportDesignImportIdGetQueryError =
  HTTPValidationError;

export function useGetDesignSessionApiV1AdminDataImportDesignImportIdGet<
  TData = Awaited<
    ReturnType<typeof getDesignSessionApiV1AdminDataImportDesignImportIdGet>
  >,
  TError = HTTPValidationError
>(
  importId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDesignSessionApiV1AdminDataImportDesignImportIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDesignSessionApiV1AdminDataImportDesignImportIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDesignSessionApiV1AdminDataImportDesignImportIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetDesignSessionApiV1AdminDataImportDesignImportIdGet<
  TData = Awaited<
    ReturnType<typeof getDesignSessionApiV1AdminDataImportDesignImportIdGet>
  >,
  TError = HTTPValidationError
>(
  importId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDesignSessionApiV1AdminDataImportDesignImportIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getDesignSessionApiV1AdminDataImportDesignImportIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getDesignSessionApiV1AdminDataImportDesignImportIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetDesignSessionApiV1AdminDataImportDesignImportIdGet<
  TData = Awaited<
    ReturnType<typeof getDesignSessionApiV1AdminDataImportDesignImportIdGet>
  >,
  TError = HTTPValidationError
>(
  importId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDesignSessionApiV1AdminDataImportDesignImportIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Design Session
 */

export function useGetDesignSessionApiV1AdminDataImportDesignImportIdGet<
  TData = Awaited<
    ReturnType<typeof getDesignSessionApiV1AdminDataImportDesignImportIdGet>
  >,
  TError = HTTPValidationError
>(
  importId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getDesignSessionApiV1AdminDataImportDesignImportIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetDesignSessionApiV1AdminDataImportDesignImportIdGetQueryOptions(
      importId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Persist the user's edits to the Phase D mapping.
 * @summary Update Design Mapping
 */
export const updateDesignMappingApiV1AdminDataImportDesignImportIdMappingPut = (
  importId: string,
  updateMappingRequest: UpdateMappingRequest
) => {
  return customInstance<UpdateDesignMappingApiV1AdminDataImportDesignImportIdMappingPut200>(
    {
      url: `/api/v1/admin/data-import/design/${importId}/mapping`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateMappingRequest
    }
  );
};

export const getUpdateDesignMappingApiV1AdminDataImportDesignImportIdMappingPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateDesignMappingApiV1AdminDataImportDesignImportIdMappingPut
        >
      >,
      TError,
      { importId: string; data: UpdateMappingRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateDesignMappingApiV1AdminDataImportDesignImportIdMappingPut
      >
    >,
    TError,
    { importId: string; data: UpdateMappingRequest },
    TContext
  > => {
    const mutationKey = [
      'updateDesignMappingApiV1AdminDataImportDesignImportIdMappingPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateDesignMappingApiV1AdminDataImportDesignImportIdMappingPut
        >
      >,
      { importId: string; data: UpdateMappingRequest }
    > = (props) => {
      const { importId, data } = props ?? {};

      return updateDesignMappingApiV1AdminDataImportDesignImportIdMappingPut(
        importId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateDesignMappingApiV1AdminDataImportDesignImportIdMappingPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateDesignMappingApiV1AdminDataImportDesignImportIdMappingPut
      >
    >
  >;
export type UpdateDesignMappingApiV1AdminDataImportDesignImportIdMappingPutMutationBody =
  UpdateMappingRequest;
export type UpdateDesignMappingApiV1AdminDataImportDesignImportIdMappingPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Design Mapping
 */
export const useUpdateDesignMappingApiV1AdminDataImportDesignImportIdMappingPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateDesignMappingApiV1AdminDataImportDesignImportIdMappingPut
          >
        >,
        TError,
        { importId: string; data: UpdateMappingRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateDesignMappingApiV1AdminDataImportDesignImportIdMappingPut
      >
    >,
    TError,
    { importId: string; data: UpdateMappingRequest },
    TContext
  > => {
    const mutationOptions =
      getUpdateDesignMappingApiV1AdminDataImportDesignImportIdMappingPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Re-run Phase C with an extended timeout, preserving the fuzzy seed.

Triggered by the Phase D wizard banner when the initial AI proposal
timed out or failed. Resets the record back through 'mapping' and
leaves it in 'awaiting_review' on completion.
 * @summary Retry Mapping
 */
export const retryMappingApiV1AdminDataImportDesignImportIdRetryMappingPost = (
  importId: string,
  signal?: AbortSignal
) => {
  return customInstance<RetryMappingApiV1AdminDataImportDesignImportIdRetryMappingPost200>(
    {
      url: `/api/v1/admin/data-import/design/${importId}/retry-mapping`,
      method: 'POST',
      signal
    }
  );
};

export const getRetryMappingApiV1AdminDataImportDesignImportIdRetryMappingPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof retryMappingApiV1AdminDataImportDesignImportIdRetryMappingPost
        >
      >,
      TError,
      { importId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof retryMappingApiV1AdminDataImportDesignImportIdRetryMappingPost
      >
    >,
    TError,
    { importId: string },
    TContext
  > => {
    const mutationKey = [
      'retryMappingApiV1AdminDataImportDesignImportIdRetryMappingPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof retryMappingApiV1AdminDataImportDesignImportIdRetryMappingPost
        >
      >,
      { importId: string }
    > = (props) => {
      const { importId } = props ?? {};

      return retryMappingApiV1AdminDataImportDesignImportIdRetryMappingPost(
        importId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RetryMappingApiV1AdminDataImportDesignImportIdRetryMappingPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof retryMappingApiV1AdminDataImportDesignImportIdRetryMappingPost
      >
    >
  >;

export type RetryMappingApiV1AdminDataImportDesignImportIdRetryMappingPostMutationError =
  HTTPValidationError;

/**
 * @summary Retry Mapping
 */
export const useRetryMappingApiV1AdminDataImportDesignImportIdRetryMappingPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof retryMappingApiV1AdminDataImportDesignImportIdRetryMappingPost
          >
        >,
        TError,
        { importId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof retryMappingApiV1AdminDataImportDesignImportIdRetryMappingPost
      >
    >,
    TError,
    { importId: string },
    TContext
  > => {
    const mutationOptions =
      getRetryMappingApiV1AdminDataImportDesignImportIdRetryMappingPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Phase E + Phase F: generate converter.py and run it on the first 50 rows.
 * @summary Generate Preview
 */
export const generatePreviewApiV1AdminDataImportDesignImportIdPreviewPost = (
  importId: string,
  signal?: AbortSignal
) => {
  return customInstance<GeneratePreviewApiV1AdminDataImportDesignImportIdPreviewPost200>(
    {
      url: `/api/v1/admin/data-import/design/${importId}/preview`,
      method: 'POST',
      signal
    }
  );
};

export const getGeneratePreviewApiV1AdminDataImportDesignImportIdPreviewPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof generatePreviewApiV1AdminDataImportDesignImportIdPreviewPost
        >
      >,
      TError,
      { importId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof generatePreviewApiV1AdminDataImportDesignImportIdPreviewPost
      >
    >,
    TError,
    { importId: string },
    TContext
  > => {
    const mutationKey = [
      'generatePreviewApiV1AdminDataImportDesignImportIdPreviewPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof generatePreviewApiV1AdminDataImportDesignImportIdPreviewPost
        >
      >,
      { importId: string }
    > = (props) => {
      const { importId } = props ?? {};

      return generatePreviewApiV1AdminDataImportDesignImportIdPreviewPost(
        importId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type GeneratePreviewApiV1AdminDataImportDesignImportIdPreviewPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof generatePreviewApiV1AdminDataImportDesignImportIdPreviewPost
      >
    >
  >;

export type GeneratePreviewApiV1AdminDataImportDesignImportIdPreviewPostMutationError =
  HTTPValidationError;

/**
 * @summary Generate Preview
 */
export const useGeneratePreviewApiV1AdminDataImportDesignImportIdPreviewPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof generatePreviewApiV1AdminDataImportDesignImportIdPreviewPost
        >
      >,
      TError,
      { importId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof generatePreviewApiV1AdminDataImportDesignImportIdPreviewPost
    >
  >,
  TError,
  { importId: string },
  TContext
> => {
  const mutationOptions =
    getGeneratePreviewApiV1AdminDataImportDesignImportIdPreviewPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Classify the drift between the adapter baseline and the new file.
 * @summary Analyse Drift
 */
export const analyseDriftApiV1AdminDataImportDesignImportIdDriftAnalysePost = (
  importId: string,
  signal?: AbortSignal
) => {
  return customInstance<AnalyseDriftApiV1AdminDataImportDesignImportIdDriftAnalysePost200>(
    {
      url: `/api/v1/admin/data-import/design/${importId}/drift/analyse`,
      method: 'POST',
      signal
    }
  );
};

export const getAnalyseDriftApiV1AdminDataImportDesignImportIdDriftAnalysePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof analyseDriftApiV1AdminDataImportDesignImportIdDriftAnalysePost
        >
      >,
      TError,
      { importId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof analyseDriftApiV1AdminDataImportDesignImportIdDriftAnalysePost
      >
    >,
    TError,
    { importId: string },
    TContext
  > => {
    const mutationKey = [
      'analyseDriftApiV1AdminDataImportDesignImportIdDriftAnalysePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof analyseDriftApiV1AdminDataImportDesignImportIdDriftAnalysePost
        >
      >,
      { importId: string }
    > = (props) => {
      const { importId } = props ?? {};

      return analyseDriftApiV1AdminDataImportDesignImportIdDriftAnalysePost(
        importId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AnalyseDriftApiV1AdminDataImportDesignImportIdDriftAnalysePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof analyseDriftApiV1AdminDataImportDesignImportIdDriftAnalysePost
      >
    >
  >;

export type AnalyseDriftApiV1AdminDataImportDesignImportIdDriftAnalysePostMutationError =
  HTTPValidationError;

/**
 * @summary Analyse Drift
 */
export const useAnalyseDriftApiV1AdminDataImportDesignImportIdDriftAnalysePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof analyseDriftApiV1AdminDataImportDesignImportIdDriftAnalysePost
          >
        >,
        TError,
        { importId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof analyseDriftApiV1AdminDataImportDesignImportIdDriftAnalysePost
      >
    >,
    TError,
    { importId: string },
    TContext
  > => {
    const mutationOptions =
      getAnalyseDriftApiV1AdminDataImportDesignImportIdDriftAnalysePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Apply approved patches → new adapter version → re-run Phase G.
 * @summary Apply Drift
 */
export const applyDriftApiV1AdminDataImportDesignImportIdDriftApplyPost = (
  importId: string,
  applyDriftRequest: ApplyDriftRequest,
  signal?: AbortSignal
) => {
  return customInstance<ApplyDriftApiV1AdminDataImportDesignImportIdDriftApplyPost200>(
    {
      url: `/api/v1/admin/data-import/design/${importId}/drift/apply`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: applyDriftRequest,
      signal
    }
  );
};

export const getApplyDriftApiV1AdminDataImportDesignImportIdDriftApplyPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof applyDriftApiV1AdminDataImportDesignImportIdDriftApplyPost
        >
      >,
      TError,
      { importId: string; data: ApplyDriftRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof applyDriftApiV1AdminDataImportDesignImportIdDriftApplyPost
      >
    >,
    TError,
    { importId: string; data: ApplyDriftRequest },
    TContext
  > => {
    const mutationKey = [
      'applyDriftApiV1AdminDataImportDesignImportIdDriftApplyPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof applyDriftApiV1AdminDataImportDesignImportIdDriftApplyPost
        >
      >,
      { importId: string; data: ApplyDriftRequest }
    > = (props) => {
      const { importId, data } = props ?? {};

      return applyDriftApiV1AdminDataImportDesignImportIdDriftApplyPost(
        importId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ApplyDriftApiV1AdminDataImportDesignImportIdDriftApplyPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof applyDriftApiV1AdminDataImportDesignImportIdDriftApplyPost
      >
    >
  >;
export type ApplyDriftApiV1AdminDataImportDesignImportIdDriftApplyPostMutationBody =
  ApplyDriftRequest;
export type ApplyDriftApiV1AdminDataImportDesignImportIdDriftApplyPostMutationError =
  HTTPValidationError;

/**
 * @summary Apply Drift
 */
export const useApplyDriftApiV1AdminDataImportDesignImportIdDriftApplyPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof applyDriftApiV1AdminDataImportDesignImportIdDriftApplyPost
        >
      >,
      TError,
      { importId: string; data: ApplyDriftRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof applyDriftApiV1AdminDataImportDesignImportIdDriftApplyPost
    >
  >,
  TError,
  { importId: string; data: ApplyDriftRequest },
  TContext
> => {
  const mutationOptions =
    getApplyDriftApiV1AdminDataImportDesignImportIdDriftApplyPostMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * List all versions of an adapter, newest first.
 * @summary List Adapter Versions
 */
export const listAdapterVersionsApiV1AdminDataImportAdaptersAdapterIdVersionsGet =
  (adapterId: string, signal?: AbortSignal) => {
    return customInstance<ListAdapterVersionsApiV1AdminDataImportAdaptersAdapterIdVersionsGet200>(
      {
        url: `/api/v1/admin/data-import/adapters/${adapterId}/versions`,
        method: 'GET',
        signal
      }
    );
  };

export const getListAdapterVersionsApiV1AdminDataImportAdaptersAdapterIdVersionsGetQueryKey =
  (adapterId?: string) => {
    return [
      `/api/v1/admin/data-import/adapters/${adapterId}/versions`
    ] as const;
  };

export const getListAdapterVersionsApiV1AdminDataImportAdaptersAdapterIdVersionsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listAdapterVersionsApiV1AdminDataImportAdaptersAdapterIdVersionsGet
      >
    >,
    TError = HTTPValidationError
  >(
    adapterId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listAdapterVersionsApiV1AdminDataImportAdaptersAdapterIdVersionsGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListAdapterVersionsApiV1AdminDataImportAdaptersAdapterIdVersionsGetQueryKey(
        adapterId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listAdapterVersionsApiV1AdminDataImportAdaptersAdapterIdVersionsGet
        >
      >
    > = ({ signal }) =>
      listAdapterVersionsApiV1AdminDataImportAdaptersAdapterIdVersionsGet(
        adapterId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!adapterId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listAdapterVersionsApiV1AdminDataImportAdaptersAdapterIdVersionsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListAdapterVersionsApiV1AdminDataImportAdaptersAdapterIdVersionsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listAdapterVersionsApiV1AdminDataImportAdaptersAdapterIdVersionsGet
      >
    >
  >;
export type ListAdapterVersionsApiV1AdminDataImportAdaptersAdapterIdVersionsGetQueryError =
  HTTPValidationError;

export function useListAdapterVersionsApiV1AdminDataImportAdaptersAdapterIdVersionsGet<
  TData = Awaited<
    ReturnType<
      typeof listAdapterVersionsApiV1AdminDataImportAdaptersAdapterIdVersionsGet
    >
  >,
  TError = HTTPValidationError
>(
  adapterId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listAdapterVersionsApiV1AdminDataImportAdaptersAdapterIdVersionsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listAdapterVersionsApiV1AdminDataImportAdaptersAdapterIdVersionsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listAdapterVersionsApiV1AdminDataImportAdaptersAdapterIdVersionsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListAdapterVersionsApiV1AdminDataImportAdaptersAdapterIdVersionsGet<
  TData = Awaited<
    ReturnType<
      typeof listAdapterVersionsApiV1AdminDataImportAdaptersAdapterIdVersionsGet
    >
  >,
  TError = HTTPValidationError
>(
  adapterId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listAdapterVersionsApiV1AdminDataImportAdaptersAdapterIdVersionsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listAdapterVersionsApiV1AdminDataImportAdaptersAdapterIdVersionsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listAdapterVersionsApiV1AdminDataImportAdaptersAdapterIdVersionsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListAdapterVersionsApiV1AdminDataImportAdaptersAdapterIdVersionsGet<
  TData = Awaited<
    ReturnType<
      typeof listAdapterVersionsApiV1AdminDataImportAdaptersAdapterIdVersionsGet
    >
  >,
  TError = HTTPValidationError
>(
  adapterId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listAdapterVersionsApiV1AdminDataImportAdaptersAdapterIdVersionsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Adapter Versions
 */

export function useListAdapterVersionsApiV1AdminDataImportAdaptersAdapterIdVersionsGet<
  TData = Awaited<
    ReturnType<
      typeof listAdapterVersionsApiV1AdminDataImportAdaptersAdapterIdVersionsGet
    >
  >,
  TError = HTTPValidationError
>(
  adapterId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listAdapterVersionsApiV1AdminDataImportAdaptersAdapterIdVersionsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListAdapterVersionsApiV1AdminDataImportAdaptersAdapterIdVersionsGetQueryOptions(
      adapterId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get full adapter version artefacts (converter, mapping, fingerprint).
 * @summary Get Adapter Version
 */
export const getAdapterVersionApiV1AdminDataImportAdaptersAdapterIdVersionsVersionIdGet =
  (adapterId: string, versionId: string, signal?: AbortSignal) => {
    return customInstance<GetAdapterVersionApiV1AdminDataImportAdaptersAdapterIdVersionsVersionIdGet200>(
      {
        url: `/api/v1/admin/data-import/adapters/${adapterId}/versions/${versionId}`,
        method: 'GET',
        signal
      }
    );
  };

export const getGetAdapterVersionApiV1AdminDataImportAdaptersAdapterIdVersionsVersionIdGetQueryKey =
  (adapterId?: string, versionId?: string) => {
    return [
      `/api/v1/admin/data-import/adapters/${adapterId}/versions/${versionId}`
    ] as const;
  };

export const getGetAdapterVersionApiV1AdminDataImportAdaptersAdapterIdVersionsVersionIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getAdapterVersionApiV1AdminDataImportAdaptersAdapterIdVersionsVersionIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    adapterId: string,
    versionId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getAdapterVersionApiV1AdminDataImportAdaptersAdapterIdVersionsVersionIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetAdapterVersionApiV1AdminDataImportAdaptersAdapterIdVersionsVersionIdGetQueryKey(
        adapterId,
        versionId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getAdapterVersionApiV1AdminDataImportAdaptersAdapterIdVersionsVersionIdGet
        >
      >
    > = ({ signal }) =>
      getAdapterVersionApiV1AdminDataImportAdaptersAdapterIdVersionsVersionIdGet(
        adapterId,
        versionId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!(adapterId && versionId),
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getAdapterVersionApiV1AdminDataImportAdaptersAdapterIdVersionsVersionIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetAdapterVersionApiV1AdminDataImportAdaptersAdapterIdVersionsVersionIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getAdapterVersionApiV1AdminDataImportAdaptersAdapterIdVersionsVersionIdGet
      >
    >
  >;
export type GetAdapterVersionApiV1AdminDataImportAdaptersAdapterIdVersionsVersionIdGetQueryError =
  HTTPValidationError;

export function useGetAdapterVersionApiV1AdminDataImportAdaptersAdapterIdVersionsVersionIdGet<
  TData = Awaited<
    ReturnType<
      typeof getAdapterVersionApiV1AdminDataImportAdaptersAdapterIdVersionsVersionIdGet
    >
  >,
  TError = HTTPValidationError
>(
  adapterId: string,
  versionId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAdapterVersionApiV1AdminDataImportAdaptersAdapterIdVersionsVersionIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getAdapterVersionApiV1AdminDataImportAdaptersAdapterIdVersionsVersionIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getAdapterVersionApiV1AdminDataImportAdaptersAdapterIdVersionsVersionIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetAdapterVersionApiV1AdminDataImportAdaptersAdapterIdVersionsVersionIdGet<
  TData = Awaited<
    ReturnType<
      typeof getAdapterVersionApiV1AdminDataImportAdaptersAdapterIdVersionsVersionIdGet
    >
  >,
  TError = HTTPValidationError
>(
  adapterId: string,
  versionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAdapterVersionApiV1AdminDataImportAdaptersAdapterIdVersionsVersionIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getAdapterVersionApiV1AdminDataImportAdaptersAdapterIdVersionsVersionIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getAdapterVersionApiV1AdminDataImportAdaptersAdapterIdVersionsVersionIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAdapterVersionApiV1AdminDataImportAdaptersAdapterIdVersionsVersionIdGet<
  TData = Awaited<
    ReturnType<
      typeof getAdapterVersionApiV1AdminDataImportAdaptersAdapterIdVersionsVersionIdGet
    >
  >,
  TError = HTTPValidationError
>(
  adapterId: string,
  versionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAdapterVersionApiV1AdminDataImportAdaptersAdapterIdVersionsVersionIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Adapter Version
 */

export function useGetAdapterVersionApiV1AdminDataImportAdaptersAdapterIdVersionsVersionIdGet<
  TData = Awaited<
    ReturnType<
      typeof getAdapterVersionApiV1AdminDataImportAdaptersAdapterIdVersionsVersionIdGet
    >
  >,
  TError = HTTPValidationError
>(
  adapterId: string,
  versionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getAdapterVersionApiV1AdminDataImportAdaptersAdapterIdVersionsVersionIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetAdapterVersionApiV1AdminDataImportAdaptersAdapterIdVersionsVersionIdGetQueryOptions(
      adapterId,
      versionId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List the tenant's migration projects, newest first.
 * @summary List Migration Projects
 */
export const listMigrationProjectsApiV1AdminDataImportMigrationProjectsGet = (
  signal?: AbortSignal
) => {
  return customInstance<ListMigrationProjectsApiV1AdminDataImportMigrationProjectsGet200>(
    {
      url: `/api/v1/admin/data-import/migration-projects`,
      method: 'GET',
      signal
    }
  );
};

export const getListMigrationProjectsApiV1AdminDataImportMigrationProjectsGetQueryKey =
  () => {
    return [`/api/v1/admin/data-import/migration-projects`] as const;
  };

export const getListMigrationProjectsApiV1AdminDataImportMigrationProjectsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listMigrationProjectsApiV1AdminDataImportMigrationProjectsGet
      >
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listMigrationProjectsApiV1AdminDataImportMigrationProjectsGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListMigrationProjectsApiV1AdminDataImportMigrationProjectsGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listMigrationProjectsApiV1AdminDataImportMigrationProjectsGet
        >
      >
    > = ({ signal }) =>
      listMigrationProjectsApiV1AdminDataImportMigrationProjectsGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listMigrationProjectsApiV1AdminDataImportMigrationProjectsGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListMigrationProjectsApiV1AdminDataImportMigrationProjectsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listMigrationProjectsApiV1AdminDataImportMigrationProjectsGet
      >
    >
  >;
export type ListMigrationProjectsApiV1AdminDataImportMigrationProjectsGetQueryError =
  unknown;

export function useListMigrationProjectsApiV1AdminDataImportMigrationProjectsGet<
  TData = Awaited<
    ReturnType<
      typeof listMigrationProjectsApiV1AdminDataImportMigrationProjectsGet
    >
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listMigrationProjectsApiV1AdminDataImportMigrationProjectsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listMigrationProjectsApiV1AdminDataImportMigrationProjectsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listMigrationProjectsApiV1AdminDataImportMigrationProjectsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListMigrationProjectsApiV1AdminDataImportMigrationProjectsGet<
  TData = Awaited<
    ReturnType<
      typeof listMigrationProjectsApiV1AdminDataImportMigrationProjectsGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listMigrationProjectsApiV1AdminDataImportMigrationProjectsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listMigrationProjectsApiV1AdminDataImportMigrationProjectsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listMigrationProjectsApiV1AdminDataImportMigrationProjectsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListMigrationProjectsApiV1AdminDataImportMigrationProjectsGet<
  TData = Awaited<
    ReturnType<
      typeof listMigrationProjectsApiV1AdminDataImportMigrationProjectsGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listMigrationProjectsApiV1AdminDataImportMigrationProjectsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Migration Projects
 */

export function useListMigrationProjectsApiV1AdminDataImportMigrationProjectsGet<
  TData = Awaited<
    ReturnType<
      typeof listMigrationProjectsApiV1AdminDataImportMigrationProjectsGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listMigrationProjectsApiV1AdminDataImportMigrationProjectsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListMigrationProjectsApiV1AdminDataImportMigrationProjectsGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Migration Project
 */
export const createMigrationProjectApiV1AdminDataImportMigrationProjectsPost = (
  migrationProjectCreateRequest: MigrationProjectCreateRequest,
  signal?: AbortSignal
) => {
  return customInstance<CreateMigrationProjectApiV1AdminDataImportMigrationProjectsPost200>(
    {
      url: `/api/v1/admin/data-import/migration-projects`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: migrationProjectCreateRequest,
      signal
    }
  );
};

export const getCreateMigrationProjectApiV1AdminDataImportMigrationProjectsPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof createMigrationProjectApiV1AdminDataImportMigrationProjectsPost
        >
      >,
      TError,
      { data: MigrationProjectCreateRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof createMigrationProjectApiV1AdminDataImportMigrationProjectsPost
      >
    >,
    TError,
    { data: MigrationProjectCreateRequest },
    TContext
  > => {
    const mutationKey = [
      'createMigrationProjectApiV1AdminDataImportMigrationProjectsPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof createMigrationProjectApiV1AdminDataImportMigrationProjectsPost
        >
      >,
      { data: MigrationProjectCreateRequest }
    > = (props) => {
      const { data } = props ?? {};

      return createMigrationProjectApiV1AdminDataImportMigrationProjectsPost(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateMigrationProjectApiV1AdminDataImportMigrationProjectsPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof createMigrationProjectApiV1AdminDataImportMigrationProjectsPost
      >
    >
  >;
export type CreateMigrationProjectApiV1AdminDataImportMigrationProjectsPostMutationBody =
  MigrationProjectCreateRequest;
export type CreateMigrationProjectApiV1AdminDataImportMigrationProjectsPostMutationError =
  HTTPValidationError;

/**
 * @summary Create Migration Project
 */
export const useCreateMigrationProjectApiV1AdminDataImportMigrationProjectsPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof createMigrationProjectApiV1AdminDataImportMigrationProjectsPost
          >
        >,
        TError,
        { data: MigrationProjectCreateRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof createMigrationProjectApiV1AdminDataImportMigrationProjectsPost
      >
    >,
    TError,
    { data: MigrationProjectCreateRequest },
    TContext
  > => {
    const mutationOptions =
      getCreateMigrationProjectApiV1AdminDataImportMigrationProjectsPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * @summary Get Migration Project
 */
export const getMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdGet =
  (projectId: string, signal?: AbortSignal) => {
    return customInstance<GetMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdGet200>(
      {
        url: `/api/v1/admin/data-import/migration-projects/${projectId}`,
        method: 'GET',
        signal
      }
    );
  };

export const getGetMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdGetQueryKey =
  (projectId?: string) => {
    return [
      `/api/v1/admin/data-import/migration-projects/${projectId}`
    ] as const;
  };

export const getGetMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdGet
      >
    >,
    TError = HTTPValidationError
  >(
    projectId: string,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdGetQueryKey(
        projectId
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdGet
        >
      >
    > = ({ signal }) =>
      getMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdGet(
        projectId,
        signal
      );

    return {
      queryKey,
      queryFn,
      enabled: !!projectId,
      ...queryOptions
    } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdGet
      >
    >
  >;
export type GetMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdGetQueryError =
  HTTPValidationError;

export function useGetMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdGet<
  TData = Awaited<
    ReturnType<
      typeof getMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdGet
    >
  >,
  TError = HTTPValidationError
>(
  projectId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdGet<
  TData = Awaited<
    ReturnType<
      typeof getMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdGet
    >
  >,
  TError = HTTPValidationError
>(
  projectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdGet<
  TData = Awaited<
    ReturnType<
      typeof getMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdGet
    >
  >,
  TError = HTTPValidationError
>(
  projectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Migration Project
 */

export function useGetMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdGet<
  TData = Awaited<
    ReturnType<
      typeof getMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdGet
    >
  >,
  TError = HTTPValidationError
>(
  projectId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdGetQueryOptions(
      projectId,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update Migration Project
 */
export const updateMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdPut =
  (
    projectId: string,
    migrationProjectUpdateRequest: MigrationProjectUpdateRequest
  ) => {
    return customInstance<UpdateMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdPut200>(
      {
        url: `/api/v1/admin/data-import/migration-projects/${projectId}`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: migrationProjectUpdateRequest
      }
    );
  };

export const getUpdateMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdPut
        >
      >,
      TError,
      { projectId: string; data: MigrationProjectUpdateRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdPut
      >
    >,
    TError,
    { projectId: string; data: MigrationProjectUpdateRequest },
    TContext
  > => {
    const mutationKey = [
      'updateMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdPut
        >
      >,
      { projectId: string; data: MigrationProjectUpdateRequest }
    > = (props) => {
      const { projectId, data } = props ?? {};

      return updateMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdPut(
        projectId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdPut
      >
    >
  >;
export type UpdateMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdPutMutationBody =
  MigrationProjectUpdateRequest;
export type UpdateMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Migration Project
 */
export const useUpdateMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdPut
          >
        >,
        TError,
        { projectId: string; data: MigrationProjectUpdateRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdPut
      >
    >,
    TError,
    { projectId: string; data: MigrationProjectUpdateRequest },
    TContext
  > => {
    const mutationOptions =
      getUpdateMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * @summary Delete Migration Project
 */
export const deleteMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdDelete =
  (projectId: string) => {
    return customInstance<DeleteMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdDelete200>(
      {
        url: `/api/v1/admin/data-import/migration-projects/${projectId}`,
        method: 'DELETE'
      }
    );
  };

export const getDeleteMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof deleteMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdDelete
        >
      >,
      TError,
      { projectId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof deleteMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdDelete
      >
    >,
    TError,
    { projectId: string },
    TContext
  > => {
    const mutationKey = [
      'deleteMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof deleteMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdDelete
        >
      >,
      { projectId: string }
    > = (props) => {
      const { projectId } = props ?? {};

      return deleteMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdDelete(
        projectId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type DeleteMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof deleteMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdDelete
      >
    >
  >;

export type DeleteMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Delete Migration Project
 */
export const useDeleteMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof deleteMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdDelete
          >
        >,
        TError,
        { projectId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof deleteMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdDelete
      >
    >,
    TError,
    { projectId: string },
    TContext
  > => {
    const mutationOptions =
      getDeleteMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * @summary Add Migration Project File
 */
export const addMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesPost =
  (
    projectId: string,
    migrationProjectFileAddRequest: MigrationProjectFileAddRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<AddMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesPost200>(
      {
        url: `/api/v1/admin/data-import/migration-projects/${projectId}/files`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: migrationProjectFileAddRequest,
        signal
      }
    );
  };

export const getAddMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof addMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesPost
        >
      >,
      TError,
      { projectId: string; data: MigrationProjectFileAddRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof addMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesPost
      >
    >,
    TError,
    { projectId: string; data: MigrationProjectFileAddRequest },
    TContext
  > => {
    const mutationKey = [
      'addMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof addMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesPost
        >
      >,
      { projectId: string; data: MigrationProjectFileAddRequest }
    > = (props) => {
      const { projectId, data } = props ?? {};

      return addMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesPost(
        projectId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type AddMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof addMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesPost
      >
    >
  >;
export type AddMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesPostMutationBody =
  MigrationProjectFileAddRequest;
export type AddMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesPostMutationError =
  HTTPValidationError;

/**
 * @summary Add Migration Project File
 */
export const useAddMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof addMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesPost
          >
        >,
        TError,
        { projectId: string; data: MigrationProjectFileAddRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof addMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesPost
      >
    >,
    TError,
    { projectId: string; data: MigrationProjectFileAddRequest },
    TContext
  > => {
    const mutationOptions =
      getAddMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * @summary Update Migration Project File
 */
export const updateMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesFileIdPut =
  (
    projectId: string,
    fileId: string,
    migrationProjectFileUpdateRequest: MigrationProjectFileUpdateRequest
  ) => {
    return customInstance<UpdateMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesFileIdPut200>(
      {
        url: `/api/v1/admin/data-import/migration-projects/${projectId}/files/${fileId}`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: migrationProjectFileUpdateRequest
      }
    );
  };

export const getUpdateMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesFileIdPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesFileIdPut
        >
      >,
      TError,
      {
        projectId: string;
        fileId: string;
        data: MigrationProjectFileUpdateRequest;
      },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesFileIdPut
      >
    >,
    TError,
    {
      projectId: string;
      fileId: string;
      data: MigrationProjectFileUpdateRequest;
    },
    TContext
  > => {
    const mutationKey = [
      'updateMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesFileIdPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesFileIdPut
        >
      >,
      {
        projectId: string;
        fileId: string;
        data: MigrationProjectFileUpdateRequest;
      }
    > = (props) => {
      const { projectId, fileId, data } = props ?? {};

      return updateMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesFileIdPut(
        projectId,
        fileId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesFileIdPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesFileIdPut
      >
    >
  >;
export type UpdateMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesFileIdPutMutationBody =
  MigrationProjectFileUpdateRequest;
export type UpdateMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesFileIdPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Migration Project File
 */
export const useUpdateMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesFileIdPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesFileIdPut
          >
        >,
        TError,
        {
          projectId: string;
          fileId: string;
          data: MigrationProjectFileUpdateRequest;
        },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesFileIdPut
      >
    >,
    TError,
    {
      projectId: string;
      fileId: string;
      data: MigrationProjectFileUpdateRequest;
    },
    TContext
  > => {
    const mutationOptions =
      getUpdateMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesFileIdPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * @summary Remove Migration Project File
 */
export const removeMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesFileIdDelete =
  (projectId: string, fileId: string) => {
    return customInstance<RemoveMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesFileIdDelete200>(
      {
        url: `/api/v1/admin/data-import/migration-projects/${projectId}/files/${fileId}`,
        method: 'DELETE'
      }
    );
  };

export const getRemoveMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesFileIdDeleteMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof removeMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesFileIdDelete
        >
      >,
      TError,
      { projectId: string; fileId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof removeMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesFileIdDelete
      >
    >,
    TError,
    { projectId: string; fileId: string },
    TContext
  > => {
    const mutationKey = [
      'removeMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesFileIdDelete'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof removeMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesFileIdDelete
        >
      >,
      { projectId: string; fileId: string }
    > = (props) => {
      const { projectId, fileId } = props ?? {};

      return removeMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesFileIdDelete(
        projectId,
        fileId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RemoveMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesFileIdDeleteMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof removeMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesFileIdDelete
      >
    >
  >;

export type RemoveMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesFileIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Remove Migration Project File
 */
export const useRemoveMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesFileIdDelete =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof removeMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesFileIdDelete
          >
        >,
        TError,
        { projectId: string; fileId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof removeMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesFileIdDelete
      >
    >,
    TError,
    { projectId: string; fileId: string },
    TContext
  > => {
    const mutationOptions =
      getRemoveMigrationProjectFileApiV1AdminDataImportMigrationProjectsProjectIdFilesFileIdDeleteMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Run Phases A→F on every file in the project.
 * @summary Run Migration Project Design
 */
export const runMigrationProjectDesignApiV1AdminDataImportMigrationProjectsProjectIdRunDesignPost =
  (
    projectId: string,
    migrationProjectRunDesignRequest: MigrationProjectRunDesignRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<RunMigrationProjectDesignApiV1AdminDataImportMigrationProjectsProjectIdRunDesignPost200>(
      {
        url: `/api/v1/admin/data-import/migration-projects/${projectId}/run-design`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: migrationProjectRunDesignRequest,
        signal
      }
    );
  };

export const getRunMigrationProjectDesignApiV1AdminDataImportMigrationProjectsProjectIdRunDesignPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof runMigrationProjectDesignApiV1AdminDataImportMigrationProjectsProjectIdRunDesignPost
        >
      >,
      TError,
      { projectId: string; data: MigrationProjectRunDesignRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof runMigrationProjectDesignApiV1AdminDataImportMigrationProjectsProjectIdRunDesignPost
      >
    >,
    TError,
    { projectId: string; data: MigrationProjectRunDesignRequest },
    TContext
  > => {
    const mutationKey = [
      'runMigrationProjectDesignApiV1AdminDataImportMigrationProjectsProjectIdRunDesignPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof runMigrationProjectDesignApiV1AdminDataImportMigrationProjectsProjectIdRunDesignPost
        >
      >,
      { projectId: string; data: MigrationProjectRunDesignRequest }
    > = (props) => {
      const { projectId, data } = props ?? {};

      return runMigrationProjectDesignApiV1AdminDataImportMigrationProjectsProjectIdRunDesignPost(
        projectId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RunMigrationProjectDesignApiV1AdminDataImportMigrationProjectsProjectIdRunDesignPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof runMigrationProjectDesignApiV1AdminDataImportMigrationProjectsProjectIdRunDesignPost
      >
    >
  >;
export type RunMigrationProjectDesignApiV1AdminDataImportMigrationProjectsProjectIdRunDesignPostMutationBody =
  MigrationProjectRunDesignRequest;
export type RunMigrationProjectDesignApiV1AdminDataImportMigrationProjectsProjectIdRunDesignPostMutationError =
  HTTPValidationError;

/**
 * @summary Run Migration Project Design
 */
export const useRunMigrationProjectDesignApiV1AdminDataImportMigrationProjectsProjectIdRunDesignPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof runMigrationProjectDesignApiV1AdminDataImportMigrationProjectsProjectIdRunDesignPost
          >
        >,
        TError,
        { projectId: string; data: MigrationProjectRunDesignRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof runMigrationProjectDesignApiV1AdminDataImportMigrationProjectsProjectIdRunDesignPost
      >
    >,
    TError,
    { projectId: string; data: MigrationProjectRunDesignRequest },
    TContext
  > => {
    const mutationOptions =
      getRunMigrationProjectDesignApiV1AdminDataImportMigrationProjectsProjectIdRunDesignPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Run Phase G on every approved file in dependency order.
 * @summary Run Migration Project Execute
 */
export const runMigrationProjectExecuteApiV1AdminDataImportMigrationProjectsProjectIdRunExecutePost =
  (
    projectId: string,
    migrationProjectRunExecuteRequest: MigrationProjectRunExecuteRequest,
    signal?: AbortSignal
  ) => {
    return customInstance<RunMigrationProjectExecuteApiV1AdminDataImportMigrationProjectsProjectIdRunExecutePost200>(
      {
        url: `/api/v1/admin/data-import/migration-projects/${projectId}/run-execute`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: migrationProjectRunExecuteRequest,
        signal
      }
    );
  };

export const getRunMigrationProjectExecuteApiV1AdminDataImportMigrationProjectsProjectIdRunExecutePostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof runMigrationProjectExecuteApiV1AdminDataImportMigrationProjectsProjectIdRunExecutePost
        >
      >,
      TError,
      { projectId: string; data: MigrationProjectRunExecuteRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof runMigrationProjectExecuteApiV1AdminDataImportMigrationProjectsProjectIdRunExecutePost
      >
    >,
    TError,
    { projectId: string; data: MigrationProjectRunExecuteRequest },
    TContext
  > => {
    const mutationKey = [
      'runMigrationProjectExecuteApiV1AdminDataImportMigrationProjectsProjectIdRunExecutePost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof runMigrationProjectExecuteApiV1AdminDataImportMigrationProjectsProjectIdRunExecutePost
        >
      >,
      { projectId: string; data: MigrationProjectRunExecuteRequest }
    > = (props) => {
      const { projectId, data } = props ?? {};

      return runMigrationProjectExecuteApiV1AdminDataImportMigrationProjectsProjectIdRunExecutePost(
        projectId,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RunMigrationProjectExecuteApiV1AdminDataImportMigrationProjectsProjectIdRunExecutePostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof runMigrationProjectExecuteApiV1AdminDataImportMigrationProjectsProjectIdRunExecutePost
      >
    >
  >;
export type RunMigrationProjectExecuteApiV1AdminDataImportMigrationProjectsProjectIdRunExecutePostMutationBody =
  MigrationProjectRunExecuteRequest;
export type RunMigrationProjectExecuteApiV1AdminDataImportMigrationProjectsProjectIdRunExecutePostMutationError =
  HTTPValidationError;

/**
 * @summary Run Migration Project Execute
 */
export const useRunMigrationProjectExecuteApiV1AdminDataImportMigrationProjectsProjectIdRunExecutePost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof runMigrationProjectExecuteApiV1AdminDataImportMigrationProjectsProjectIdRunExecutePost
          >
        >,
        TError,
        { projectId: string; data: MigrationProjectRunExecuteRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof runMigrationProjectExecuteApiV1AdminDataImportMigrationProjectsProjectIdRunExecutePost
      >
    >,
    TError,
    { projectId: string; data: MigrationProjectRunExecuteRequest },
    TContext
  > => {
    const mutationOptions =
      getRunMigrationProjectExecuteApiV1AdminDataImportMigrationProjectsProjectIdRunExecutePostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Delete every row imported by this project.
 * @summary Rollback Migration Project
 */
export const rollbackMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdRollbackPost =
  (projectId: string, signal?: AbortSignal) => {
    return customInstance<RollbackMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdRollbackPost200>(
      {
        url: `/api/v1/admin/data-import/migration-projects/${projectId}/rollback`,
        method: 'POST',
        signal
      }
    );
  };

export const getRollbackMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdRollbackPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof rollbackMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdRollbackPost
        >
      >,
      TError,
      { projectId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof rollbackMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdRollbackPost
      >
    >,
    TError,
    { projectId: string },
    TContext
  > => {
    const mutationKey = [
      'rollbackMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdRollbackPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof rollbackMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdRollbackPost
        >
      >,
      { projectId: string }
    > = (props) => {
      const { projectId } = props ?? {};

      return rollbackMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdRollbackPost(
        projectId
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type RollbackMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdRollbackPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof rollbackMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdRollbackPost
      >
    >
  >;

export type RollbackMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdRollbackPostMutationError =
  HTTPValidationError;

/**
 * @summary Rollback Migration Project
 */
export const useRollbackMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdRollbackPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof rollbackMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdRollbackPost
          >
        >,
        TError,
        { projectId: string },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof rollbackMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdRollbackPost
      >
    >,
    TError,
    { projectId: string },
    TContext
  > => {
    const mutationOptions =
      getRollbackMigrationProjectApiV1AdminDataImportMigrationProjectsProjectIdRollbackPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Option set for the imported-records entity filter.

A sibling of the list endpoint rather than a block on its response: the
list is server-paged, so options derived from its rows would name only the
tables on the current page (ui-list-pages.md § 11), and computing them on
every page turn would re-run the DISTINCT for nothing.
 * @summary List Imported Record Entity Tables
 */
export const listImportedRecordEntityTablesApiV1AdminDataImportRecordsEntityTablesGet =
  (
    params?: ListImportedRecordEntityTablesApiV1AdminDataImportRecordsEntityTablesGetParams,
    signal?: AbortSignal
  ) => {
    return customInstance<EntityTablesResponse>({
      url: `/api/v1/admin/data-import/records/entity-tables`,
      method: 'GET',
      params,
      signal
    });
  };

export const getListImportedRecordEntityTablesApiV1AdminDataImportRecordsEntityTablesGetQueryKey =
  (
    params?: ListImportedRecordEntityTablesApiV1AdminDataImportRecordsEntityTablesGetParams
  ) => {
    return [
      `/api/v1/admin/data-import/records/entity-tables`,
      ...(params ? [params] : [])
    ] as const;
  };

export const getListImportedRecordEntityTablesApiV1AdminDataImportRecordsEntityTablesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof listImportedRecordEntityTablesApiV1AdminDataImportRecordsEntityTablesGet
      >
    >,
    TError = HTTPValidationError
  >(
    params?: ListImportedRecordEntityTablesApiV1AdminDataImportRecordsEntityTablesGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof listImportedRecordEntityTablesApiV1AdminDataImportRecordsEntityTablesGet
            >
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListImportedRecordEntityTablesApiV1AdminDataImportRecordsEntityTablesGetQueryKey(
        params
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof listImportedRecordEntityTablesApiV1AdminDataImportRecordsEntityTablesGet
        >
      >
    > = ({ signal }) =>
      listImportedRecordEntityTablesApiV1AdminDataImportRecordsEntityTablesGet(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof listImportedRecordEntityTablesApiV1AdminDataImportRecordsEntityTablesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListImportedRecordEntityTablesApiV1AdminDataImportRecordsEntityTablesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof listImportedRecordEntityTablesApiV1AdminDataImportRecordsEntityTablesGet
      >
    >
  >;
export type ListImportedRecordEntityTablesApiV1AdminDataImportRecordsEntityTablesGetQueryError =
  HTTPValidationError;

export function useListImportedRecordEntityTablesApiV1AdminDataImportRecordsEntityTablesGet<
  TData = Awaited<
    ReturnType<
      typeof listImportedRecordEntityTablesApiV1AdminDataImportRecordsEntityTablesGet
    >
  >,
  TError = HTTPValidationError
>(
  params:
    | undefined
    | ListImportedRecordEntityTablesApiV1AdminDataImportRecordsEntityTablesGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listImportedRecordEntityTablesApiV1AdminDataImportRecordsEntityTablesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listImportedRecordEntityTablesApiV1AdminDataImportRecordsEntityTablesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listImportedRecordEntityTablesApiV1AdminDataImportRecordsEntityTablesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListImportedRecordEntityTablesApiV1AdminDataImportRecordsEntityTablesGet<
  TData = Awaited<
    ReturnType<
      typeof listImportedRecordEntityTablesApiV1AdminDataImportRecordsEntityTablesGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListImportedRecordEntityTablesApiV1AdminDataImportRecordsEntityTablesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listImportedRecordEntityTablesApiV1AdminDataImportRecordsEntityTablesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listImportedRecordEntityTablesApiV1AdminDataImportRecordsEntityTablesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listImportedRecordEntityTablesApiV1AdminDataImportRecordsEntityTablesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListImportedRecordEntityTablesApiV1AdminDataImportRecordsEntityTablesGet<
  TData = Awaited<
    ReturnType<
      typeof listImportedRecordEntityTablesApiV1AdminDataImportRecordsEntityTablesGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListImportedRecordEntityTablesApiV1AdminDataImportRecordsEntityTablesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listImportedRecordEntityTablesApiV1AdminDataImportRecordsEntityTablesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Imported Record Entity Tables
 */

export function useListImportedRecordEntityTablesApiV1AdminDataImportRecordsEntityTablesGet<
  TData = Awaited<
    ReturnType<
      typeof listImportedRecordEntityTablesApiV1AdminDataImportRecordsEntityTablesGet
    >
  >,
  TError = HTTPValidationError
>(
  params?: ListImportedRecordEntityTablesApiV1AdminDataImportRecordsEntityTablesGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listImportedRecordEntityTablesApiV1AdminDataImportRecordsEntityTablesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListImportedRecordEntityTablesApiV1AdminDataImportRecordsEntityTablesGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List imported entity records with optional filters.
 * @summary List Imported Records
 */
export const listImportedRecordsApiV1AdminDataImportRecordsGet = (
  params?: ListImportedRecordsApiV1AdminDataImportRecordsGetParams,
  signal?: AbortSignal
) => {
  return customInstance<ListImportedRecordsApiV1AdminDataImportRecordsGet200>({
    url: `/api/v1/admin/data-import/records`,
    method: 'GET',
    params,
    signal
  });
};

export const getListImportedRecordsApiV1AdminDataImportRecordsGetQueryKey = (
  params?: ListImportedRecordsApiV1AdminDataImportRecordsGetParams
) => {
  return [
    `/api/v1/admin/data-import/records`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListImportedRecordsApiV1AdminDataImportRecordsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listImportedRecordsApiV1AdminDataImportRecordsGet>
    >,
    TError = HTTPValidationError
  >(
    params?: ListImportedRecordsApiV1AdminDataImportRecordsGetParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<typeof listImportedRecordsApiV1AdminDataImportRecordsGet>
          >,
          TError,
          TData
        >
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListImportedRecordsApiV1AdminDataImportRecordsGetQueryKey(params);

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listImportedRecordsApiV1AdminDataImportRecordsGet>
      >
    > = ({ signal }) =>
      listImportedRecordsApiV1AdminDataImportRecordsGet(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listImportedRecordsApiV1AdminDataImportRecordsGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListImportedRecordsApiV1AdminDataImportRecordsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listImportedRecordsApiV1AdminDataImportRecordsGet>
    >
  >;
export type ListImportedRecordsApiV1AdminDataImportRecordsGetQueryError =
  HTTPValidationError;

export function useListImportedRecordsApiV1AdminDataImportRecordsGet<
  TData = Awaited<
    ReturnType<typeof listImportedRecordsApiV1AdminDataImportRecordsGet>
  >,
  TError = HTTPValidationError
>(
  params: undefined | ListImportedRecordsApiV1AdminDataImportRecordsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listImportedRecordsApiV1AdminDataImportRecordsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listImportedRecordsApiV1AdminDataImportRecordsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listImportedRecordsApiV1AdminDataImportRecordsGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListImportedRecordsApiV1AdminDataImportRecordsGet<
  TData = Awaited<
    ReturnType<typeof listImportedRecordsApiV1AdminDataImportRecordsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListImportedRecordsApiV1AdminDataImportRecordsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listImportedRecordsApiV1AdminDataImportRecordsGet>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof listImportedRecordsApiV1AdminDataImportRecordsGet>
          >,
          TError,
          Awaited<
            ReturnType<typeof listImportedRecordsApiV1AdminDataImportRecordsGet>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListImportedRecordsApiV1AdminDataImportRecordsGet<
  TData = Awaited<
    ReturnType<typeof listImportedRecordsApiV1AdminDataImportRecordsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListImportedRecordsApiV1AdminDataImportRecordsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listImportedRecordsApiV1AdminDataImportRecordsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Imported Records
 */

export function useListImportedRecordsApiV1AdminDataImportRecordsGet<
  TData = Awaited<
    ReturnType<typeof listImportedRecordsApiV1AdminDataImportRecordsGet>
  >,
  TError = HTTPValidationError
>(
  params?: ListImportedRecordsApiV1AdminDataImportRecordsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof listImportedRecordsApiV1AdminDataImportRecordsGet>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListImportedRecordsApiV1AdminDataImportRecordsGetQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List the configured demo variations (sysadmin — including hidden ones).
 * @summary List Variations Sysadmin
 */
export const listVariationsSysadminApiV1AdminDemoDataVariationsGet = (
  signal?: AbortSignal
) => {
  return customInstance<ModulesAdminApiDemoProvisioningRoutesDemoVariationsResponse>(
    { url: `/api/v1/admin/demo-data/variations`, method: 'GET', signal }
  );
};

export const getListVariationsSysadminApiV1AdminDemoDataVariationsGetQueryKey =
  () => {
    return [`/api/v1/admin/demo-data/variations`] as const;
  };

export const getListVariationsSysadminApiV1AdminDemoDataVariationsGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof listVariationsSysadminApiV1AdminDemoDataVariationsGet>
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listVariationsSysadminApiV1AdminDemoDataVariationsGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getListVariationsSysadminApiV1AdminDemoDataVariationsGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof listVariationsSysadminApiV1AdminDemoDataVariationsGet>
      >
    > = ({ signal }) =>
      listVariationsSysadminApiV1AdminDemoDataVariationsGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof listVariationsSysadminApiV1AdminDemoDataVariationsGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type ListVariationsSysadminApiV1AdminDemoDataVariationsGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof listVariationsSysadminApiV1AdminDemoDataVariationsGet>
    >
  >;
export type ListVariationsSysadminApiV1AdminDemoDataVariationsGetQueryError =
  unknown;

export function useListVariationsSysadminApiV1AdminDemoDataVariationsGet<
  TData = Awaited<
    ReturnType<typeof listVariationsSysadminApiV1AdminDemoDataVariationsGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listVariationsSysadminApiV1AdminDemoDataVariationsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listVariationsSysadminApiV1AdminDemoDataVariationsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listVariationsSysadminApiV1AdminDemoDataVariationsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListVariationsSysadminApiV1AdminDemoDataVariationsGet<
  TData = Awaited<
    ReturnType<typeof listVariationsSysadminApiV1AdminDemoDataVariationsGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listVariationsSysadminApiV1AdminDemoDataVariationsGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof listVariationsSysadminApiV1AdminDemoDataVariationsGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof listVariationsSysadminApiV1AdminDemoDataVariationsGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListVariationsSysadminApiV1AdminDemoDataVariationsGet<
  TData = Awaited<
    ReturnType<typeof listVariationsSysadminApiV1AdminDemoDataVariationsGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listVariationsSysadminApiV1AdminDemoDataVariationsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List Variations Sysadmin
 */

export function useListVariationsSysadminApiV1AdminDemoDataVariationsGet<
  TData = Awaited<
    ReturnType<typeof listVariationsSysadminApiV1AdminDemoDataVariationsGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof listVariationsSysadminApiV1AdminDemoDataVariationsGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getListVariationsSysadminApiV1AdminDemoDataVariationsGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Provision a named variation into an explicit target tenant (sales/support).
 * @summary Provision Tenant
 */
export const provisionTenantApiV1AdminDemoDataProvisionPost = (
  provisionDemoRequest: ProvisionDemoRequest,
  signal?: AbortSignal
) => {
  return customInstance<DemoProvisionResponse>({
    url: `/api/v1/admin/demo-data/provision`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: provisionDemoRequest,
    signal
  });
};

export const getProvisionTenantApiV1AdminDemoDataProvisionPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof provisionTenantApiV1AdminDemoDataProvisionPost>
      >,
      TError,
      { data: ProvisionDemoRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof provisionTenantApiV1AdminDemoDataProvisionPost>>,
    TError,
    { data: ProvisionDemoRequest },
    TContext
  > => {
    const mutationKey = ['provisionTenantApiV1AdminDemoDataProvisionPost'];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof provisionTenantApiV1AdminDemoDataProvisionPost>
      >,
      { data: ProvisionDemoRequest }
    > = (props) => {
      const { data } = props ?? {};

      return provisionTenantApiV1AdminDemoDataProvisionPost(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ProvisionTenantApiV1AdminDemoDataProvisionPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof provisionTenantApiV1AdminDemoDataProvisionPost>>
  >;
export type ProvisionTenantApiV1AdminDemoDataProvisionPostMutationBody =
  ProvisionDemoRequest;
export type ProvisionTenantApiV1AdminDemoDataProvisionPostMutationError =
  HTTPValidationError;

/**
 * @summary Provision Tenant
 */
export const useProvisionTenantApiV1AdminDemoDataProvisionPost = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof provisionTenantApiV1AdminDemoDataProvisionPost>
      >,
      TError,
      { data: ProvisionDemoRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof provisionTenantApiV1AdminDemoDataProvisionPost>>,
  TError,
  { data: ProvisionDemoRequest },
  TContext
> => {
  const mutationOptions =
    getProvisionTenantApiV1AdminDemoDataProvisionPostMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Status of every registered golden tenant in THIS environment (sysadmin tile).

Per tenant: seeded badge, curated headline entity counts, clone history, and
the (non-secret) admin login. Registry-driven — adding a golden tenant in
``tools/seed_golden_tenants.py`` + config makes it appear here with no code
change. Runs in a :func:`sysadmin_session` (cross-tenant reads, RLS bypassed,
every query ``tenant_id``-filtered).
 * @summary Golden Tenants Status
 */
export const goldenTenantsStatusApiV1AdminDemoDataGoldenTenantsStatusGet = (
  signal?: AbortSignal
) => {
  return customInstance<GoldenTenantsStatusResponse>({
    url: `/api/v1/admin/demo-data/golden-tenants/status`,
    method: 'GET',
    signal
  });
};

export const getGoldenTenantsStatusApiV1AdminDemoDataGoldenTenantsStatusGetQueryKey =
  () => {
    return [`/api/v1/admin/demo-data/golden-tenants/status`] as const;
  };

export const getGoldenTenantsStatusApiV1AdminDemoDataGoldenTenantsStatusGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof goldenTenantsStatusApiV1AdminDemoDataGoldenTenantsStatusGet
      >
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof goldenTenantsStatusApiV1AdminDemoDataGoldenTenantsStatusGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGoldenTenantsStatusApiV1AdminDemoDataGoldenTenantsStatusGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof goldenTenantsStatusApiV1AdminDemoDataGoldenTenantsStatusGet
        >
      >
    > = ({ signal }) =>
      goldenTenantsStatusApiV1AdminDemoDataGoldenTenantsStatusGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof goldenTenantsStatusApiV1AdminDemoDataGoldenTenantsStatusGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GoldenTenantsStatusApiV1AdminDemoDataGoldenTenantsStatusGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof goldenTenantsStatusApiV1AdminDemoDataGoldenTenantsStatusGet
      >
    >
  >;
export type GoldenTenantsStatusApiV1AdminDemoDataGoldenTenantsStatusGetQueryError =
  unknown;

export function useGoldenTenantsStatusApiV1AdminDemoDataGoldenTenantsStatusGet<
  TData = Awaited<
    ReturnType<
      typeof goldenTenantsStatusApiV1AdminDemoDataGoldenTenantsStatusGet
    >
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof goldenTenantsStatusApiV1AdminDemoDataGoldenTenantsStatusGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof goldenTenantsStatusApiV1AdminDemoDataGoldenTenantsStatusGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof goldenTenantsStatusApiV1AdminDemoDataGoldenTenantsStatusGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGoldenTenantsStatusApiV1AdminDemoDataGoldenTenantsStatusGet<
  TData = Awaited<
    ReturnType<
      typeof goldenTenantsStatusApiV1AdminDemoDataGoldenTenantsStatusGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof goldenTenantsStatusApiV1AdminDemoDataGoldenTenantsStatusGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof goldenTenantsStatusApiV1AdminDemoDataGoldenTenantsStatusGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof goldenTenantsStatusApiV1AdminDemoDataGoldenTenantsStatusGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGoldenTenantsStatusApiV1AdminDemoDataGoldenTenantsStatusGet<
  TData = Awaited<
    ReturnType<
      typeof goldenTenantsStatusApiV1AdminDemoDataGoldenTenantsStatusGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof goldenTenantsStatusApiV1AdminDemoDataGoldenTenantsStatusGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Golden Tenants Status
 */

export function useGoldenTenantsStatusApiV1AdminDemoDataGoldenTenantsStatusGet<
  TData = Awaited<
    ReturnType<
      typeof goldenTenantsStatusApiV1AdminDemoDataGoldenTenantsStatusGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof goldenTenantsStatusApiV1AdminDemoDataGoldenTenantsStatusGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGoldenTenantsStatusApiV1AdminDemoDataGoldenTenantsStatusGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Re-run the golden-tenant seeder for ``key`` (operator equivalent of the CLI
``tools/seed_golden_tenants.py --only <key>``).

Default = create-if-absent (a populated tenant is skipped). ``force=true`` is
the destructive reset+rebuild — only the dev/superuser DB role can suppress
the inventory ledger triggers it needs; on the restricted prod role it fails
cleanly (returned as ``status='failed'``). Synchronous (mirrors ``/provision``);
a real build can take several seconds — the create-if-absent skip is instant.
 * @summary Reseed Golden Tenant
 */
export const reseedGoldenTenantApiV1AdminDemoDataGoldenTenantsKeyReseedPost = (
  key: string,
  reseedGoldenTenantRequest: ReseedGoldenTenantRequest,
  signal?: AbortSignal
) => {
  return customInstance<ReseedGoldenTenantResponse>({
    url: `/api/v1/admin/demo-data/golden-tenants/${key}/reseed`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: reseedGoldenTenantRequest,
    signal
  });
};

export const getReseedGoldenTenantApiV1AdminDemoDataGoldenTenantsKeyReseedPostMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof reseedGoldenTenantApiV1AdminDemoDataGoldenTenantsKeyReseedPost
        >
      >,
      TError,
      { key: string; data: ReseedGoldenTenantRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof reseedGoldenTenantApiV1AdminDemoDataGoldenTenantsKeyReseedPost
      >
    >,
    TError,
    { key: string; data: ReseedGoldenTenantRequest },
    TContext
  > => {
    const mutationKey = [
      'reseedGoldenTenantApiV1AdminDemoDataGoldenTenantsKeyReseedPost'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof reseedGoldenTenantApiV1AdminDemoDataGoldenTenantsKeyReseedPost
        >
      >,
      { key: string; data: ReseedGoldenTenantRequest }
    > = (props) => {
      const { key, data } = props ?? {};

      return reseedGoldenTenantApiV1AdminDemoDataGoldenTenantsKeyReseedPost(
        key,
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ReseedGoldenTenantApiV1AdminDemoDataGoldenTenantsKeyReseedPostMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof reseedGoldenTenantApiV1AdminDemoDataGoldenTenantsKeyReseedPost
      >
    >
  >;
export type ReseedGoldenTenantApiV1AdminDemoDataGoldenTenantsKeyReseedPostMutationBody =
  ReseedGoldenTenantRequest;
export type ReseedGoldenTenantApiV1AdminDemoDataGoldenTenantsKeyReseedPostMutationError =
  HTTPValidationError;

/**
 * @summary Reseed Golden Tenant
 */
export const useReseedGoldenTenantApiV1AdminDemoDataGoldenTenantsKeyReseedPost =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof reseedGoldenTenantApiV1AdminDemoDataGoldenTenantsKeyReseedPost
          >
        >,
        TError,
        { key: string; data: ReseedGoldenTenantRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof reseedGoldenTenantApiV1AdminDemoDataGoldenTenantsKeyReseedPost
      >
    >,
    TError,
    { key: string; data: ReseedGoldenTenantRequest },
    TContext
  > => {
    const mutationOptions =
      getReseedGoldenTenantApiV1AdminDemoDataGoldenTenantsKeyReseedPostMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * The page's state: any live reset, the last finished one, any restore, re-auth mode.
 * @summary Get State
 */
export const getTenantDataResetState = (signal?: AbortSignal) => {
  return customInstance<TenantDataResetState>({
    url: `/api/v1/admin/data-reset`,
    method: 'GET',
    signal
  });
};

export const getGetTenantDataResetStateQueryKey = () => {
  return [`/api/v1/admin/data-reset`] as const;
};

export const getGetTenantDataResetStateQueryOptions = <
  TData = Awaited<ReturnType<typeof getTenantDataResetState>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getTenantDataResetState>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTenantDataResetStateQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTenantDataResetState>>
  > = ({ signal }) => getTenantDataResetState(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTenantDataResetState>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetTenantDataResetStateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTenantDataResetState>>
>;
export type GetTenantDataResetStateQueryError = unknown;

export function useGetTenantDataResetState<
  TData = Awaited<ReturnType<typeof getTenantDataResetState>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTenantDataResetState>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenantDataResetState>>,
          TError,
          Awaited<ReturnType<typeof getTenantDataResetState>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTenantDataResetState<
  TData = Awaited<ReturnType<typeof getTenantDataResetState>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTenantDataResetState>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTenantDataResetState>>,
          TError,
          Awaited<ReturnType<typeof getTenantDataResetState>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTenantDataResetState<
  TData = Awaited<ReturnType<typeof getTenantDataResetState>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTenantDataResetState>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get State
 */

export function useGetTenantDataResetState<
  TData = Awaited<ReturnType<typeof getTenantDataResetState>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTenantDataResetState>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetTenantDataResetStateQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Every reset this workspace has requested, newest first.

A read-only ledger: what was chosen, whether it succeeded, and what it deleted
per entity. Bounded by ``limit`` and reported against the full ``total``, so the
page can say the list is the most recent slice rather than the whole record.
 * @summary List History
 */
export const listTenantDataResetHistory = (
  params?: ListTenantDataResetHistoryParams,
  signal?: AbortSignal
) => {
  return customInstance<TenantDataResetHistory>({
    url: `/api/v1/admin/data-reset/history`,
    method: 'GET',
    params,
    signal
  });
};

export const getListTenantDataResetHistoryQueryKey = (
  params?: ListTenantDataResetHistoryParams
) => {
  return [
    `/api/v1/admin/data-reset/history`,
    ...(params ? [params] : [])
  ] as const;
};

export const getListTenantDataResetHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof listTenantDataResetHistory>>,
  TError = HTTPValidationError
>(
  params?: ListTenantDataResetHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTenantDataResetHistory>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListTenantDataResetHistoryQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listTenantDataResetHistory>>
  > = ({ signal }) => listTenantDataResetHistory(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTenantDataResetHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type ListTenantDataResetHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTenantDataResetHistory>>
>;
export type ListTenantDataResetHistoryQueryError = HTTPValidationError;

export function useListTenantDataResetHistory<
  TData = Awaited<ReturnType<typeof listTenantDataResetHistory>>,
  TError = HTTPValidationError
>(
  params: undefined | ListTenantDataResetHistoryParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTenantDataResetHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTenantDataResetHistory>>,
          TError,
          Awaited<ReturnType<typeof listTenantDataResetHistory>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useListTenantDataResetHistory<
  TData = Awaited<ReturnType<typeof listTenantDataResetHistory>>,
  TError = HTTPValidationError
>(
  params?: ListTenantDataResetHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTenantDataResetHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTenantDataResetHistory>>,
          TError,
          Awaited<ReturnType<typeof listTenantDataResetHistory>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useListTenantDataResetHistory<
  TData = Awaited<ReturnType<typeof listTenantDataResetHistory>>,
  TError = HTTPValidationError
>(
  params?: ListTenantDataResetHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTenantDataResetHistory>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List History
 */

export function useListTenantDataResetHistory<
  TData = Awaited<ReturnType<typeof listTenantDataResetHistory>>,
  TError = HTTPValidationError
>(
  params?: ListTenantDataResetHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTenantDataResetHistory>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getListTenantDataResetHistoryQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Count exactly what a reset would delete — the reset's own predicates, not an estimate.
 * @summary Preview
 */
export const previewTenantDataReset = (
  tenantDataResetPreviewRequest: TenantDataResetPreviewRequest,
  signal?: AbortSignal
) => {
  return customInstance<TenantDataResetPreview>({
    url: `/api/v1/admin/data-reset/preview`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: tenantDataResetPreviewRequest,
    signal
  });
};

export const getPreviewTenantDataResetMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewTenantDataReset>>,
    TError,
    { data: TenantDataResetPreviewRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof previewTenantDataReset>>,
  TError,
  { data: TenantDataResetPreviewRequest },
  TContext
> => {
  const mutationKey = ['previewTenantDataReset'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof previewTenantDataReset>>,
    { data: TenantDataResetPreviewRequest }
  > = (props) => {
    const { data } = props ?? {};

    return previewTenantDataReset(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PreviewTenantDataResetMutationResult = NonNullable<
  Awaited<ReturnType<typeof previewTenantDataReset>>
>;
export type PreviewTenantDataResetMutationBody = TenantDataResetPreviewRequest;
export type PreviewTenantDataResetMutationError = HTTPValidationError;

/**
 * @summary Preview
 */
export const usePreviewTenantDataReset = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof previewTenantDataReset>>,
      TError,
      { data: TenantDataResetPreviewRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof previewTenantDataReset>>,
  TError,
  { data: TenantDataResetPreviewRequest },
  TContext
> => {
  const mutationOptions = getPreviewTenantDataResetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Confirm a reset: re-auth, type-to-confirm, then a cancellable grace window.
 * @summary Schedule
 */
export const scheduleTenantDataReset = (
  tenantDataResetScheduleRequest: TenantDataResetScheduleRequest,
  signal?: AbortSignal
) => {
  return customInstance<TenantDataResetState>({
    url: `/api/v1/admin/data-reset/schedule`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: tenantDataResetScheduleRequest,
    signal
  });
};

export const getScheduleTenantDataResetMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof scheduleTenantDataReset>>,
    TError,
    { data: TenantDataResetScheduleRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof scheduleTenantDataReset>>,
  TError,
  { data: TenantDataResetScheduleRequest },
  TContext
> => {
  const mutationKey = ['scheduleTenantDataReset'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof scheduleTenantDataReset>>,
    { data: TenantDataResetScheduleRequest }
  > = (props) => {
    const { data } = props ?? {};

    return scheduleTenantDataReset(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ScheduleTenantDataResetMutationResult = NonNullable<
  Awaited<ReturnType<typeof scheduleTenantDataReset>>
>;
export type ScheduleTenantDataResetMutationBody =
  TenantDataResetScheduleRequest;
export type ScheduleTenantDataResetMutationError = HTTPValidationError;

/**
 * @summary Schedule
 */
export const useScheduleTenantDataReset = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof scheduleTenantDataReset>>,
      TError,
      { data: TenantDataResetScheduleRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof scheduleTenantDataReset>>,
  TError,
  { data: TenantDataResetScheduleRequest },
  TContext
> => {
  const mutationOptions = getScheduleTenantDataResetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Cancel a scheduled reset. A reset that has started cannot be undone.
 * @summary Cancel
 */
export const cancelTenantDataReset = (
  resetId: string,
  signal?: AbortSignal
) => {
  return customInstance<TenantDataResetState>({
    url: `/api/v1/admin/data-reset/${resetId}/cancel`,
    method: 'POST',
    signal
  });
};

export const getCancelTenantDataResetMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelTenantDataReset>>,
    TError,
    { resetId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelTenantDataReset>>,
  TError,
  { resetId: string },
  TContext
> => {
  const mutationKey = ['cancelTenantDataReset'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelTenantDataReset>>,
    { resetId: string }
  > = (props) => {
    const { resetId } = props ?? {};

    return cancelTenantDataReset(resetId);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelTenantDataResetMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelTenantDataReset>>
>;

export type CancelTenantDataResetMutationError = HTTPValidationError;

/**
 * @summary Cancel
 */
export const useCancelTenantDataReset = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof cancelTenantDataReset>>,
      TError,
      { resetId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof cancelTenantDataReset>>,
  TError,
  { resetId: string },
  TContext
> => {
  const mutationOptions = getCancelTenantDataResetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Put this reset's pre-reset snapshot back (design §8.5).

Records the intent and returns; the work happens in the
``execute_tenant_data_restores`` scheduled task, because a tenant-sized import
cannot finish inside the 60s gateway cap. Every refusal — the retention window
has lapsed, the snapshot is gone, the workspace holds records created since
the reset, a restore is already running — is raised HERE, from the service, as
a coded error the client translates.
 * @summary Restore
 */
export const restoreTenantDataReset = (
  resetId: string,
  tenantDataRestoreRequest: TenantDataRestoreRequest,
  signal?: AbortSignal
) => {
  return customInstance<TenantDataResetState>({
    url: `/api/v1/admin/data-reset/${resetId}/restore`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: tenantDataRestoreRequest,
    signal
  });
};

export const getRestoreTenantDataResetMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreTenantDataReset>>,
    TError,
    { resetId: string; data: TenantDataRestoreRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof restoreTenantDataReset>>,
  TError,
  { resetId: string; data: TenantDataRestoreRequest },
  TContext
> => {
  const mutationKey = ['restoreTenantDataReset'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof restoreTenantDataReset>>,
    { resetId: string; data: TenantDataRestoreRequest }
  > = (props) => {
    const { resetId, data } = props ?? {};

    return restoreTenantDataReset(resetId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RestoreTenantDataResetMutationResult = NonNullable<
  Awaited<ReturnType<typeof restoreTenantDataReset>>
>;
export type RestoreTenantDataResetMutationBody = TenantDataRestoreRequest;
export type RestoreTenantDataResetMutationError = HTTPValidationError;

/**
 * @summary Restore
 */
export const useRestoreTenantDataReset = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof restoreTenantDataReset>>,
      TError,
      { resetId: string; data: TenantDataRestoreRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof restoreTenantDataReset>>,
  TError,
  { resetId: string; data: TenantDataRestoreRequest },
  TContext
> => {
  const mutationOptions = getRestoreTenantDataResetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Where every eligible Shopify connection's money backlog stands, per tenant.

Read-only, and counts only: no order number, customer, amount or id of anything
below the connection leaves this surface, which is what makes a cross-tenant
read defensible at all.

The two columns that decide what to do next are ``recoverable_by_reset`` and
``refused_on_retry`` — an unreconciled order the sales module would refuse if the
sweep re-asked it (already written to by the pre-fix sweep, invoiced, or edited
since) cannot be recovered by clearing its marker.
 * @summary Get Money Resolution Census
 */
export const getChannelMoneyResolutionCensus = (signal?: AbortSignal) => {
  return customInstance<ChannelMoneyResolutionCensusResponse>({
    url: `/api/v1/admin/channel-money-recovery/connections`,
    method: 'GET',
    signal
  });
};

export const getGetChannelMoneyResolutionCensusQueryKey = () => {
  return [`/api/v1/admin/channel-money-recovery/connections`] as const;
};

export const getGetChannelMoneyResolutionCensusQueryOptions = <
  TData = Awaited<ReturnType<typeof getChannelMoneyResolutionCensus>>,
  TError = unknown
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getChannelMoneyResolutionCensus>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetChannelMoneyResolutionCensusQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getChannelMoneyResolutionCensus>>
  > = ({ signal }) => getChannelMoneyResolutionCensus(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getChannelMoneyResolutionCensus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetChannelMoneyResolutionCensusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getChannelMoneyResolutionCensus>>
>;
export type GetChannelMoneyResolutionCensusQueryError = unknown;

export function useGetChannelMoneyResolutionCensus<
  TData = Awaited<ReturnType<typeof getChannelMoneyResolutionCensus>>,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getChannelMoneyResolutionCensus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChannelMoneyResolutionCensus>>,
          TError,
          Awaited<ReturnType<typeof getChannelMoneyResolutionCensus>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetChannelMoneyResolutionCensus<
  TData = Awaited<ReturnType<typeof getChannelMoneyResolutionCensus>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getChannelMoneyResolutionCensus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getChannelMoneyResolutionCensus>>,
          TError,
          Awaited<ReturnType<typeof getChannelMoneyResolutionCensus>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetChannelMoneyResolutionCensus<
  TData = Awaited<ReturnType<typeof getChannelMoneyResolutionCensus>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getChannelMoneyResolutionCensus>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Money Resolution Census
 */

export function useGetChannelMoneyResolutionCensus<
  TData = Awaited<ReturnType<typeof getChannelMoneyResolutionCensus>>,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getChannelMoneyResolutionCensus>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetChannelMoneyResolutionCensusQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Clear this connection's terminal ``unreconciled`` stamps back to NULL.

The orders become candidates again and the next nightly sweep re-asks them
against the store. Use it after the thing that made them fail has been fixed —
a tax rate configured, a SKU mapped, a defect in the sweep deployed.

``source_missing`` and ``reconciled`` are untouched: Shopify no longer has the
first (no configuration change makes it answerable) and the second is right.

Writes ONE audit row against the TARGET tenant naming the sysadmin who pressed
it and how many markers moved — ``inv_channel_order_links`` is not registered
for automatic audit tracking, so without that call a cross-tenant marker reset
would leave no trail at all.

Idempotent in the sense that matters: running it twice clears nothing the second
time, because the first run left nothing stamped ``unreconciled``.
 * @summary Reset Unreconciled
 */
export const resetChannelMoneyResolutionUnreconciled = (
  connectionId: string,
  signal?: AbortSignal
) => {
  return customInstance<ChannelMoneyResolutionResetResponse>({
    url: `/api/v1/admin/channel-money-recovery/connections/${connectionId}/reset-unreconciled`,
    method: 'POST',
    signal
  });
};

export const getResetChannelMoneyResolutionUnreconciledMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetChannelMoneyResolutionUnreconciled>>,
    TError,
    { connectionId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resetChannelMoneyResolutionUnreconciled>>,
  TError,
  { connectionId: string },
  TContext
> => {
  const mutationKey = ['resetChannelMoneyResolutionUnreconciled'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resetChannelMoneyResolutionUnreconciled>>,
    { connectionId: string }
  > = (props) => {
    const { connectionId } = props ?? {};

    return resetChannelMoneyResolutionUnreconciled(connectionId);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResetChannelMoneyResolutionUnreconciledMutationResult = NonNullable<
  Awaited<ReturnType<typeof resetChannelMoneyResolutionUnreconciled>>
>;

export type ResetChannelMoneyResolutionUnreconciledMutationError =
  HTTPValidationError;

/**
 * @summary Reset Unreconciled
 */
export const useResetChannelMoneyResolutionUnreconciled = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof resetChannelMoneyResolutionUnreconciled>>,
      TError,
      { connectionId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof resetChannelMoneyResolutionUnreconciled>>,
  TError,
  { connectionId: string },
  TContext
> => {
  const mutationOptions =
    getResetChannelMoneyResolutionUnreconciledMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
